export const MOGILEV_REGION_COORDS = [
  [53.2743972, 28.081725],
  [53.2520432, 28.0889511],
  [53.2512215, 28.08923],
  [53.2502586, 28.0889296],
  [53.2498093, 28.0877065],
  [53.2475556, 28.0870507],
  [53.246663, 28.094125],
  [53.2429891, 28.1035332],
  [53.2431637, 28.1133711],
  [53.2380776, 28.1147574],
  [53.2221262, 28.1079705],
  [53.2166679, 28.1181583],
  [53.2153605, 28.1215893],
  [53.2169194, 28.130792],
  [53.2163329, 28.132899],
  [53.2144663, 28.1366439],
  [53.2121991, 28.1419606],
  [53.2060063, 28.1577393],
  [53.2039042, 28.1621357],
  [53.205483, 28.1693474],
  [53.2050546, 28.1701931],
  [53.2058205, 28.1764463],
  [53.1863364, 28.1855613],
  [53.1894902, 28.1922983],
  [53.1901284, 28.201266],
  [53.1947884, 28.2090769],
  [53.1961599, 28.2194645],
  [53.1877594, 28.2254077],
  [53.1829678, 28.226505],
  [53.1820854, 28.2386137],
  [53.1871362, 28.242073],
  [53.1885638, 28.2443256],
  [53.1932264, 28.243068],
  [53.1957316, 28.2520007],
  [53.1979608, 28.2539606],
  [53.1961098, 28.2567286],
  [53.1946829, 28.2607412],
  [53.1939592, 28.2660324],
  [53.1789146, 28.275641],
  [53.1790223, 28.2841293],
  [53.1879393, 28.2862199],
  [53.1931981, 28.3039652],
  [53.2027344, 28.3034433],
  [53.1987149, 28.3227485],
  [53.1885675, 28.348105],
  [53.1883104, 28.348522],
  [53.1849689, 28.3497729],
  [53.1815436, 28.3510086],
  [53.1812398, 28.3507141],
  [53.1817826, 28.3486151],
  [53.1817723, 28.3482074],
  [53.1796552, 28.3434429],
  [53.1795106, 28.3433304],
  [53.1735602, 28.3422823],
  [53.1692453, 28.3387234],
  [53.1676944, 28.3373895],
  [53.1644502, 28.334693],
  [53.1627328, 28.3330323],
  [53.1624228, 28.3286265],
  [53.1641291, 28.3269356],
  [53.1636241, 28.3241058],
  [53.1641688, 28.3229795],
  [53.1630541, 28.3181441],
  [53.1602193, 28.3158483],
  [53.1596501, 28.3153532],
  [53.1584981, 28.3127323],
  [53.1579561, 28.311901],
  [53.157736, 28.3116822],
  [53.1573664, 28.310106],
  [53.1572951, 28.3099774],
  [53.1572393, 28.309947],
  [53.1563622, 28.309987],
  [53.156164, 28.3113611],
  [53.1565511, 28.3114574],
  [53.157718, 28.3127918],
  [53.1590971, 28.3228213],
  [53.1589457, 28.3228895],
  [53.1597808, 28.3291021],
  [53.1616938, 28.3351417],
  [53.1618634, 28.3354962],
  [53.1627944, 28.3369118],
  [53.1645532, 28.3397745],
  [53.166806, 28.3410197],
  [53.1656286, 28.345958],
  [53.1609767, 28.3445078],
  [53.1599128, 28.3441981],
  [53.1598144, 28.3441325],
  [53.1597402, 28.343994],
  [53.1594028, 28.3429662],
  [53.1586564, 28.3420668],
  [53.1557883, 28.3400485],
  [53.1453918, 28.3413565],
  [53.1469234, 28.372737],
  [53.1512323, 28.3723068],
  [53.1515879, 28.3797402],
  [53.153054, 28.379272],
  [53.1529192, 28.376916],
  [53.1546611, 28.3764634],
  [53.1552237, 28.3752089],
  [53.1545499, 28.3730794],
  [53.1540457, 28.3730168],
  [53.153593, 28.3724735],
  [53.1540402, 28.370114],
  [53.154993, 28.3687639],
  [53.1561518, 28.3686841],
  [53.1563585, 28.371538],
  [53.1660791, 28.3702148],
  [53.1662519, 28.3742434],
  [53.1666718, 28.3829948],
  [53.1596497, 28.4023146],
  [53.1578838, 28.4023035],
  [53.157317, 28.3895369],
  [53.1503306, 28.3907373],
  [53.1509278, 28.4044298],
  [53.1484349, 28.4047942],
  [53.1488261, 28.4141381],
  [53.1492955, 28.4240683],
  [53.1494572, 28.4259408],
  [53.1546979, 28.42956],
  [53.1546964, 28.4300221],
  [53.1546514, 28.4441492],
  [53.1531597, 28.4515194],
  [53.1592956, 28.4749626],
  [53.1585095, 28.480107],
  [53.1602851, 28.486965],
  [53.1619454, 28.4899883],
  [53.1480666, 28.5053895],
  [53.1442127, 28.5114093],
  [53.1407212, 28.508234],
  [53.1360229, 28.5062599],
  [53.1360486, 28.5057235],
  [53.1354178, 28.5042429],
  [53.1324956, 28.5031485],
  [53.1310022, 28.4993291],
  [53.1303713, 28.5003376],
  [53.128659, 28.4958958],
  [53.1236761, 28.4947586],
  [53.1242169, 28.5033846],
  [53.1256075, 28.502891],
  [53.1267921, 28.4988999],
  [53.1272942, 28.4989428],
  [53.130204, 28.501625],
  [53.1308734, 28.5046077],
  [53.129676, 28.5093495],
  [53.1302941, 28.5129118],
  [53.1301074, 28.5135823],
  [53.1301573, 28.5139235],
  [53.1283831, 28.5162815],
  [53.1245428, 28.5132928],
  [53.1116926, 28.5220185],
  [53.1113463, 28.5243075],
  [53.1090651, 28.5262263],
  [53.1087367, 28.5280502],
  [53.1088333, 28.5295844],
  [53.1085395, 28.5305179],
  [53.1084914, 28.5306709],
  [53.1084716, 28.5307338],
  [53.1080777, 28.5293497],
  [53.0999409, 28.5182792],
  [53.0991715, 28.5194457],
  [53.0919266, 28.5233958],
  [53.0902936, 28.5228896],
  [53.090126, 28.5230076],
  [53.0901776, 28.5212374],
  [53.088007, 28.5212101],
  [53.0878437, 28.5214284],
  [53.0874775, 28.522741],
  [53.0881806, 28.5229837],
  [53.0888823, 28.5245264],
  [53.088884, 28.5249086],
  [53.0845743, 28.5270041],
  [53.0679934, 28.5356137],
  [53.0643097, 28.5325792],
  [53.0609312, 28.529941],
  [53.0574649, 28.5270564],
  [53.0518854, 28.522491],
  [53.0486624, 28.5263155],
  [53.0484087, 28.5260289],
  [53.0469577, 28.5293911],
  [53.0468059, 28.5296277],
  [53.0444055, 28.5292498],
  [53.0353986, 28.5277138],
  [53.0311534, 28.5271987],
  [53.0312906, 28.5318491],
  [53.0310429, 28.5318815],
  [53.0231835, 28.5306369],
  [53.0177235, 28.5297179],
  [53.0174636, 28.5302778],
  [53.0169015, 28.5311842],
  [53.0159472, 28.5317593],
  [53.0157523, 28.5319204],
  [53.0165393, 28.5340499],
  [53.0165652, 28.5342391],
  [53.0165134, 28.5343768],
  [53.00718, 28.5455694],
  [53.0071483, 28.545692],
  [53.0076058, 28.546944],
  [53.0077196, 28.547264],
  [53.0077196, 28.5475479],
  [52.9988359, 28.5583101],
  [52.9996863, 28.5611337],
  [52.9990286, 28.5630153],
  [52.9986518, 28.5632166],
  [52.9843147, 28.5527465],
  [52.9842228, 28.5530741],
  [52.9768875, 28.5471205],
  [52.9758124, 28.5447121],
  [52.9726485, 28.5440893],
  [52.972033, 28.5367083],
  [52.971516, 28.5338115],
  [52.9716923, 28.5248421],
  [52.9714514, 28.5233402],
  [52.973002, 28.5222244],
  [52.9757026, 28.5175466],
  [52.9769429, 28.51583],
  [52.9775502, 28.5133409],
  [52.9807612, 28.508871],
  [52.9820333, 28.5063672],
  [52.9826017, 28.505702],
  [52.9836223, 28.5035777],
  [52.985543, 28.5015303],
  [52.9857665, 28.5013213],
  [52.9866167, 28.4985285],
  [52.987525, 28.492012],
  [52.9864643, 28.4883427],
  [52.9853224, 28.4859069],
  [52.9843974, 28.4841585],
  [52.9808336, 28.4790396],
  [52.9781187, 28.4744811],
  [52.9761617, 28.4706257],
  [52.9738161, 28.4685159],
  [52.9721104, 28.4666705],
  [52.97124, 28.463739],
  [52.9750694, 28.4571647],
  [52.9772756, 28.4526964],
  [52.9739502, 28.4484212],
  [52.9732992, 28.4470153],
  [52.9728769, 28.4444957],
  [52.9690975, 28.4421868],
  [52.9668897, 28.4440326],
  [52.9603241, 28.4357714],
  [52.9595097, 28.4327674],
  [52.9539588, 28.4296988],
  [52.9515597, 28.4332609],
  [52.9464917, 28.435235],
  [52.9425868, 28.4375953],
  [52.9377763, 28.4379386],
  [52.9386556, 28.4444189],
  [52.9138117, 28.4568643],
  [52.9150409, 28.4630009],
  [52.8973574, 28.4744596],
  [52.8926454, 28.4817552],
  [52.8892446, 28.4775061],
  [52.8885026, 28.4784078],
  [52.8863275, 28.4765625],
  [52.8833753, 28.473258],
  [52.8805007, 28.4674215],
  [52.8753207, 28.4633231],
  [52.8737148, 28.4639883],
  [52.8730413, 28.4626579],
  [52.8718238, 28.4645891],
  [52.8668706, 28.4569064],
  [52.8615915, 28.4246126],
  [52.8579578, 28.4126823],
  [52.853519, 28.411932],
  [52.8535708, 28.4112453],
  [52.8480075, 28.4113949],
  [52.8454286, 28.4265876],
  [52.8381489, 28.4329605],
  [52.8379544, 28.4327674],
  [52.8352064, 28.4343982],
  [52.8269407, 28.4417154],
  [52.8214378, 28.4465861],
  [52.8197235, 28.4487312],
  [52.8118412, 28.4437751],
  [52.8114781, 28.4452342],
  [52.790358, 28.4282397],
  [52.7897351, 28.4299564],
  [52.7890604, 28.429613],
  [52.7905907, 28.4244631],
  [52.7726679, 28.4102368],
  [52.7705185, 28.4055805],
  [52.7596064, 28.3677932],
  [52.7267016, 28.3680416],
  [52.7247704, 28.3801526],
  [52.7187139, 28.4170382],
  [52.7112548, 28.4307557],
  [52.6975676, 28.4555999],
  [52.6954666, 28.4527009],
  [52.6886678, 28.464481],
  [52.6884711, 28.4641613],
  [52.6830919, 28.473979],
  [52.6806718, 28.4701419],
  [52.6745741, 28.4843682],
  [52.685391, 28.4897472],
  [52.6916905, 28.5079053],
  [52.6815579, 28.5195972],
  [52.681807, 28.5222459],
  [52.6826005, 28.5227179],
  [52.6827576, 28.5249673],
  [52.6850203, 28.5247002],
  [52.6856834, 28.5289836],
  [52.6847338, 28.538661],
  [52.6847864, 28.5416753],
  [52.6878369, 28.5415283],
  [52.6880636, 28.5473299],
  [52.6875043, 28.5494542],
  [52.6882857, 28.5513103],
  [52.6875954, 28.5578441],
  [52.6877255, 28.5596251],
  [52.6871792, 28.5610628],
  [52.6857484, 28.5706544],
  [52.6841485, 28.5740876],
  [52.6831603, 28.5773584],
  [52.6831338, 28.5817265],
  [52.6820867, 28.5844839],
  [52.6817094, 28.5860502],
  [52.6819442, 28.5868701],
  [52.6833319, 28.5886333],
  [52.6841979, 28.5935734],
  [52.6850864, 28.5944582],
  [52.685007, 28.5950947],
  [52.6892147, 28.5957813],
  [52.6902292, 28.5964572],
  [52.6903592, 28.5968971],
  [52.6909348, 28.597235],
  [52.6920045, 28.6025834],
  [52.6901446, 28.607583],
  [52.688818, 28.6089349],
  [52.6885579, 28.6121535],
  [52.6885449, 28.6162734],
  [52.688792, 28.6173463],
  [52.6884409, 28.6193632],
  [52.6977135, 28.6271953],
  [52.6974144, 28.6370444],
  [52.6973884, 28.6412072],
  [52.6983637, 28.6412287],
  [52.6988692, 28.64171],
  [52.6974189, 28.6461664],
  [52.6991179, 28.6477947],
  [52.6990731, 28.6504849],
  [52.6955677, 28.6593301],
  [52.695782, 28.6664805],
  [52.6955743, 28.6665809],
  [52.6956133, 28.667525],
  [52.6946582, 28.6676277],
  [52.6948499, 28.6764576],
  [52.6916533, 28.6835647],
  [52.6910355, 28.6837578],
  [52.6870252, 28.6910618],
  [52.6979828, 28.7054841],
  [52.6971934, 28.707211],
  [52.6989662, 28.7096327],
  [52.6989944, 28.7102795],
  [52.6987668, 28.7114811],
  [52.6986368, 28.7127578],
  [52.6987083, 28.7149465],
  [52.6987287, 28.7170824],
  [52.6968422, 28.7253213],
  [52.694693, 28.7335442],
  [52.6926111, 28.7305143],
  [52.6922906, 28.7306106],
  [52.6877314, 28.7487865],
  [52.6905315, 28.7505015],
  [52.689917, 28.7530231],
  [52.6889285, 28.7543743],
  [52.6895984, 28.7546432],
  [52.6904763, 28.7541604],
  [52.6914505, 28.7557016],
  [52.6918484, 28.7536883],
  [52.6928108, 28.7543106],
  [52.693409, 28.7557697],
  [52.694573, 28.7550402],
  [52.6953858, 28.7549543],
  [52.6963416, 28.7560594],
  [52.6963221, 28.7569821],
  [52.6956069, 28.7577009],
  [52.6993, 28.7593746],
  [52.6998721, 28.760662],
  [52.7019981, 28.7595892],
  [52.7032853, 28.763473],
  [52.704553, 28.7638807],
  [52.7042084, 28.7652326],
  [52.7047545, 28.766756],
  [52.7056711, 28.7678933],
  [52.7061652, 28.7701785],
  [52.7071727, 28.7702429],
  [52.7078748, 28.7700069],
  [52.7085768, 28.7708437],
  [52.7089465, 28.7708522],
  [52.7107024, 28.7758112],
  [52.7107673, 28.7768626],
  [52.7122103, 28.7779033],
  [52.7129318, 28.7794053],
  [52.7122493, 28.7798613],
  [52.7143162, 28.7828386],
  [52.7151676, 28.7829029],
  [52.715551, 28.7821305],
  [52.7162335, 28.7828278],
  [52.7166949, 28.782978],
  [52.7169614, 28.7835789],
  [52.7172733, 28.7839329],
  [52.7174683, 28.7849951],
  [52.7178907, 28.7849307],
  [52.7182156, 28.7845015],
  [52.7186229, 28.783428],
  [52.7197623, 28.7866044],
  [52.7195934, 28.7931275],
  [52.7184252, 28.7987723],
  [52.7217899, 28.8113451],
  [52.7208411, 28.8127398],
  [52.7200353, 28.8203358],
  [52.7188005, 28.8213444],
  [52.7188698, 28.8360211],
  [52.7193334, 28.8368797],
  [52.7202432, 28.8369441],
  [52.7276639, 28.8359785],
  [52.7256429, 28.8215157],
  [52.7281188, 28.8203573],
  [52.7296064, 28.8188332],
  [52.7408647, 28.8102937],
  [52.7423603, 28.8116019],
  [52.7426574, 28.7994575],
  [52.7432956, 28.7973116],
  [52.7538407, 28.7985348],
  [52.7593467, 28.7983416],
  [52.7588404, 28.8037705],
  [52.7615024, 28.8034701],
  [52.7638006, 28.8058948],
  [52.7702941, 28.8082978],
  [52.7634631, 28.8392186],
  [52.7598663, 28.8550965],
  [52.7668388, 28.86029],
  [52.7728237, 28.8656115],
  [52.7721746, 28.8733148],
  [52.7766586, 28.8757176],
  [52.7765881, 28.8945794],
  [52.7760722, 28.8982485],
  [52.7793269, 28.9012098],
  [52.780469, 28.9079904],
  [52.7822601, 28.9088916],
  [52.782961, 28.9134407],
  [52.7853489, 28.9141702],
  [52.799129, 28.9280748],
  [52.7978576, 28.9316368],
  [52.8016977, 28.9354991],
  [52.8025409, 28.9380097],
  [52.8022685, 28.9387393],
  [52.8032284, 28.9391684],
  [52.8040846, 28.938117],
  [52.8425402, 28.9794868],
  [52.865925, 28.9737363],
  [52.8726759, 29.0523172],
  [52.8739584, 29.0673688],
  [52.8739628, 29.0674207],
  [52.8770727, 29.103813],
  [52.8761527, 29.1045909],
  [52.875759, 29.1107879],
  [52.8815605, 29.1162639],
  [52.8818681, 29.1202881],
  [52.8820407, 29.1199905],
  [52.8832854, 29.1192345],
  [52.885181, 29.1183743],
  [52.9070882, 29.113029],
  [52.9073371, 29.1136944],
  [52.9080922, 29.1182625],
  [52.9083754, 29.1190451],
  [52.9091954, 29.1206395],
  [52.9094432, 29.1214123],
  [52.9098502, 29.1231633],
  [52.910039, 29.1234763],
  [52.9104342, 29.1235447],
  [52.9191629, 29.1216878],
  [52.9206722, 29.1213569],
  [52.9208262, 29.1211864],
  [52.9212324, 29.121559],
  [52.9218988, 29.1220938],
  [52.9222427, 29.12248],
  [52.923964, 29.1239735],
  [52.9272166, 29.1270158],
  [52.9293131, 29.1289132],
  [52.9298611, 29.1293707],
  [52.9304235, 29.1298401],
  [52.9308031, 29.1301135],
  [52.9309643, 29.1302204],
  [52.931215, 29.1306364],
  [52.9325131, 29.1317178],
  [52.9332209, 29.1326303],
  [52.9341994, 29.134058],
  [52.9357331, 29.1364184],
  [52.9372945, 29.138652],
  [52.939057, 29.1413923],
  [52.9410484, 29.1443514],
  [52.9428594, 29.1470801],
  [52.9441985, 29.1491066],
  [52.9459746, 29.1517548],
  [52.9487496, 29.1558767],
  [52.9515592, 29.1602174],
  [52.9522182, 29.1609658],
  [52.95312, 29.1614264],
  [52.9577538, 29.1626251],
  [52.9578173, 29.1628342],
  [52.9579552, 29.1628861],
  [52.9581086, 29.1628284],
  [52.9583864, 29.1627065],
  [52.9586688, 29.1629012],
  [52.9591096, 29.163],
  [52.9598601, 29.1632148],
  [52.9616743, 29.1647121],
  [52.9631685, 29.1660398],
  [52.9636349, 29.1662278],
  [52.9639684, 29.1659428],
  [52.9643067, 29.1658777],
  [52.9649324, 29.1662821],
  [52.9671934, 29.1669416],
  [52.9690379, 29.1676785],
  [52.969193, 29.1677425],
  [52.9698424, 29.1690661],
  [52.9702739, 29.1692487],
  [52.9717348, 29.1710195],
  [52.9722625, 29.1712952],
  [52.9733532, 29.1729095],
  [52.9713914, 29.1732722],
  [52.9709611, 29.1733673],
  [52.9705885, 29.178507],
  [52.9715788, 29.1841627],
  [52.973459, 29.1857593],
  [52.976145, 29.196021],
  [52.9777193, 29.1961231],
  [52.9789611, 29.1948489],
  [52.9793603, 29.1944659],
  [52.9796472, 29.198269],
  [52.9801667, 29.201239],
  [52.9790683, 29.2012095],
  [52.9778284, 29.2008645],
  [52.9758655, 29.2032145],
  [52.9759511, 29.206042],
  [52.9726082, 29.2214691],
  [52.9687914, 29.221931],
  [52.9694862, 29.2385939],
  [52.9666961, 29.2388846],
  [52.9685671, 29.2591152],
  [52.9617585, 29.2587981],
  [52.951712, 29.2784095],
  [52.9530478, 29.2931396],
  [52.953019, 29.2953651],
  [52.9514946, 29.3204847],
  [52.9501853, 29.3421131],
  [52.9474904, 29.3781993],
  [52.9470708, 29.3827159],
  [52.9459402, 29.3975772],
  [52.9434113, 29.4002143],
  [52.9420303, 29.4000877],
  [52.9405879, 29.3977371],
  [52.9380515, 29.3969299],
  [52.9346429, 29.3994498],
  [52.9338916, 29.4016143],
  [52.9349802, 29.4046519],
  [52.9348567, 29.4055323],
  [52.9340783, 29.4098564],
  [52.9334632, 29.411881],
  [52.9351454, 29.4159647],
  [52.9345175, 29.4161175],
  [52.9342586, 29.4167089],
  [52.9340258, 29.4169879],
  [52.9332821, 29.4173098],
  [52.9321051, 29.4187367],
  [52.9306953, 29.4192342],
  [52.9301655, 29.4197346],
  [52.9295377, 29.4209254],
  [52.9292855, 29.4211185],
  [52.9289619, 29.4218697],
  [52.9274099, 29.4229638],
  [52.9270412, 29.4238865],
  [52.9264591, 29.4244981],
  [52.9261422, 29.4243479],
  [52.9258988, 29.4244832],
  [52.9267962, 29.438531],
  [52.9298429, 29.4418718],
  [52.9369202, 29.4717711],
  [52.942196, 29.4809875],
  [52.9432417, 29.4827812],
  [52.9488772, 29.4928708],
  [52.9503302, 29.4997211],
  [52.9553738, 29.5034171],
  [52.9555081, 29.5068387],
  [52.9601781, 29.5157323],
  [52.9653237, 29.5195528],
  [52.9631327, 29.5253881],
  [52.9654233, 29.5411762],
  [52.9657417, 29.5433788],
  [52.9665494, 29.5489661],
  [52.9654042, 29.5615298],
  [52.9607492, 29.5680515],
  [52.9590432, 29.5704414],
  [52.9588353, 29.5705452],
  [52.9592964, 29.5737394],
  [52.9596283, 29.5773199],
  [52.9596329, 29.5786014],
  [52.9607665, 29.5868507],
  [52.9645279, 29.5968388],
  [52.965087, 29.5996247],
  [52.9664963, 29.6050225],
  [52.9655663, 29.6074748],
  [52.9638221, 29.6111501],
  [52.9616398, 29.6248992],
  [52.963633, 29.6296432],
  [52.963902, 29.6304002],
  [52.9645821, 29.6335929],
  [52.9627874, 29.6347018],
  [52.9648939, 29.6413513],
  [52.9634691, 29.6413949],
  [52.9547683, 29.6480921],
  [52.9542774, 29.6485603],
  [52.9535906, 29.6493049],
  [52.9534361, 29.6496019],
  [52.9533697, 29.6499964],
  [52.9531772, 29.6505174],
  [52.9525453, 29.6518157],
  [52.9520848, 29.652805],
  [52.9519891, 29.6531367],
  [52.9518908, 29.6537929],
  [52.9518628, 29.6539795],
  [52.9517933, 29.654593],
  [52.9513663, 29.6569385],
  [52.9509244, 29.6573947],
  [52.9507206, 29.6579482],
  [52.9506421, 29.6584264],
  [52.9506412, 29.65869],
  [52.9507186, 29.6592626],
  [52.9507494, 29.6597548],
  [52.9506459, 29.6601488],
  [52.9502226, 29.6604941],
  [52.9498909, 29.6606953],
  [52.9496768, 29.6607663],
  [52.9500791, 29.6611078],
  [52.9501833, 29.6611962],
  [52.9503926, 29.6613738],
  [52.9503736, 29.6615531],
  [52.9503552, 29.6617273],
  [52.9493957, 29.6707872],
  [52.9490554, 29.6706613],
  [52.9486602, 29.6703505],
  [52.9478482, 29.6697119],
  [52.9464895, 29.6868975],
  [52.9463301, 29.689269],
  [52.9462848, 29.6896806],
  [52.9460497, 29.6918187],
  [52.9460019, 29.6923943],
  [52.945938, 29.6948723],
  [52.9459352, 29.695467],
  [52.9459821, 29.6955282],
  [52.9460548, 29.6955464],
  [52.9472782, 29.6956407],
  [52.9484329, 29.695727],
  [52.9485015, 29.6957082],
  [52.9486365, 29.6956666],
  [52.9491345, 29.695451],
  [52.9495784, 29.695297],
  [52.9498182, 29.6951943],
  [52.9512981, 29.6945891],
  [52.9516632, 29.6944772],
  [52.9545829, 29.6989372],
  [52.9548244, 29.7071009],
  [52.954767, 29.7071052],
  [52.9546644, 29.7071128],
  [52.9539304, 29.7071672],
  [52.9540327, 29.7105224],
  [52.954091, 29.7109507],
  [52.9561984, 29.726429],
  [52.9574436, 29.7263022],
  [52.9588245, 29.7265308],
  [52.9594151, 29.7263564],
  [52.9608705, 29.7245185],
  [52.9621342, 29.7224331],
  [52.9631611, 29.7225559],
  [52.9634704, 29.7220659],
  [52.9654051, 29.7212814],
  [52.9678402, 29.7194013],
  [52.9722314, 29.7259542],
  [52.972313, 29.7260742],
  [52.9758814, 29.7313218],
  [52.9762346, 29.7318412],
  [52.9778003, 29.7284216],
  [52.9784723, 29.7290142],
  [52.9788529, 29.7293947],
  [52.9834906, 29.7334393],
  [52.9876335, 29.7272531],
  [52.984139, 29.720571],
  [52.9824704, 29.7179024],
  [53.0024812, 29.6732995],
  [53.0124596, 29.6711325],
  [53.0129433, 29.6686667],
  [53.0130405, 29.6681714],
  [53.0199853, 29.6672702],
  [53.0230856, 29.6619477],
  [53.0254862, 29.6531504],
  [53.0271613, 29.6564984],
  [53.0277937, 29.6568417],
  [53.0288777, 29.655683],
  [53.0298327, 29.656198],
  [53.0312134, 29.6559834],
  [53.0326071, 29.6577215],
  [53.0331232, 29.6598029],
  [53.0325813, 29.6627211],
  [53.0363361, 29.6663475],
  [53.0393601, 29.6672486],
  [53.0423354, 29.6715832],
  [53.0431611, 29.6803593],
  [53.0441335, 29.6840282],
  [53.0501163, 29.6785242],
  [53.0572892, 29.6929713],
  [53.0599416, 29.6890068],
  [53.063823, 29.685359],
  [53.0716121, 29.6801229],
  [53.0658737, 29.6508543],
  [53.0753813, 29.6461236],
  [53.0788939, 29.6444821],
  [53.081227, 29.6364569],
  [53.0814365, 29.6352338],
  [53.0821163, 29.6354055],
  [53.0939491, 29.6284202],
  [53.0967943, 29.6412635],
  [53.0976963, 29.6443319],
  [53.0980741, 29.6475451],
  [53.1030196, 29.6457532],
  [53.103687, 29.651134],
  [53.1035131, 29.6516704],
  [53.1038159, 29.6537733],
  [53.1028625, 29.6542239],
  [53.1025688, 29.6556412],
  [53.1073197, 29.6539235],
  [53.1097156, 29.6566164],
  [53.1099301, 29.6566448],
  [53.1146487, 29.6527648],
  [53.1197743, 29.6490311],
  [53.1237827, 29.643298],
  [53.1248478, 29.6429801],
  [53.1258908, 29.6450829],
  [53.1256719, 29.6482587],
  [53.1315944, 29.6458983],
  [53.1315944, 29.6525717],
  [53.1299593, 29.6596741],
  [53.1376833, 29.6587894],
  [53.1421242, 29.6768543],
  [53.1453389, 29.6893696],
  [53.1453561, 29.6894365],
  [53.1488908, 29.688365],
  [53.1511562, 29.6977997],
  [53.1500918, 29.6990485],
  [53.1499168, 29.6994567],
  [53.1492734, 29.7001755],
  [53.1487779, 29.6996176],
  [53.148231, 29.6995103],
  [53.1478707, 29.6989479],
  [53.1460882, 29.6989524],
  [53.1454898, 29.6984053],
  [53.1451423, 29.6987486],
  [53.1408333, 29.6989672],
  [53.1387647, 29.6983838],
  [53.1346326, 29.7062588],
  [53.134182, 29.7082972],
  [53.1335641, 29.7089624],
  [53.1333839, 29.7098636],
  [53.1318379, 29.7111596],
  [53.1313884, 29.7115588],
  [53.1295216, 29.7112155],
  [53.1282084, 29.7116875],
  [53.1278006, 29.7125388],
  [53.1257878, 29.7175884],
  [53.1242555, 29.7197127],
  [53.1222485, 29.7260255],
  [53.1222725, 29.7280383],
  [53.1227876, 29.7285533],
  [53.1260968, 29.7364926],
  [53.127112, 29.7341371],
  [53.1276032, 29.735291],
  [53.1310338, 29.7543473],
  [53.1304486, 29.7546887],
  [53.1308552, 29.7565465],
  [53.1367282, 29.7744325],
  [53.1378508, 29.7736037],
  [53.1381404, 29.7747946],
  [53.1377864, 29.7751808],
  [53.1384778, 29.7776006],
  [53.1391315, 29.7771052],
  [53.1394791, 29.7741616],
  [53.1390093, 29.7724879],
  [53.1398266, 29.7716939],
  [53.1405732, 29.7678745],
  [53.1399296, 29.7666514],
  [53.1395241, 29.7668445],
  [53.1385909, 29.7645163],
  [53.1408433, 29.7624233],
  [53.1469119, 29.7613513],
  [53.1473401, 29.7610717],
  [53.1488037, 29.7646665],
  [53.1497302, 29.7654605],
  [53.1501485, 29.7658789],
  [53.1507533, 29.765954],
  [53.1565573, 29.7735279],
  [53.1600111, 29.7817254],
  [53.1624036, 29.7777661],
  [53.1640374, 29.777584],
  [53.1675626, 29.7712004],
  [53.1681221, 29.7691727],
  [53.1727205, 29.7690117],
  [53.172709, 29.7712862],
  [53.1754278, 29.7756851],
  [53.1775913, 29.7805234],
  [53.1787458, 29.7746873],
  [53.1794531, 29.7681641],
  [53.180234, 29.7622089],
  [53.1812663, 29.7626281],
  [53.1820572, 29.756062],
  [53.18171, 29.7559225],
  [53.1820379, 29.7521889],
  [53.1890985, 29.7532076],
  [53.1893155, 29.7559547],
  [53.1896562, 29.7570598],
  [53.1879012, 29.7751808],
  [53.1950572, 29.7787102],
  [53.1955558, 29.7877545],
  [53.1964042, 29.7977641],
  [53.2020753, 29.7959363],
  [53.2039505, 29.795351],
  [53.2069322, 29.7895574],
  [53.207729, 29.7889566],
  [53.2085515, 29.789257],
  [53.2105192, 29.7915498],
  [53.2177005, 29.7896862],
  [53.2584136, 29.7725735],
  [53.2602844, 29.7709107],
  [53.2686603, 29.7614041],
  [53.275823, 29.7690432],
  [53.2790459, 29.7666835],
  [53.2862813, 29.7634649],
  [53.2896164, 29.7577571],
  [53.3000532, 29.7573058],
  [53.3112882, 29.757843],
  [53.3126984, 29.7617483],
  [53.3162365, 29.7662115],
  [53.3182105, 29.7680139],
  [53.3209023, 29.7677564],
  [53.3236707, 29.7709322],
  [53.3255932, 29.7846221],
  [53.3282075, 29.7846651],
  [53.3320519, 29.791789],
  [53.3333333, 29.7969389],
  [53.3369978, 29.8019599],
  [53.3418515, 29.8041486],
  [53.3419176, 29.8149633],
  [53.3490143, 29.8356485],
  [53.3500646, 29.8404765],
  [53.3509612, 29.8473859],
  [53.3543297, 29.8473859],
  [53.3537277, 29.849081],
  [53.3549444, 29.854896],
  [53.3546922, 29.8580497],
  [53.340534, 29.8604536],
  [53.3233221, 29.8620406],
  [53.3230222, 29.9075312],
  [53.3225608, 29.9062434],
  [53.316837, 29.9036687],
  [53.3136035, 29.9042486],
  [53.3111779, 29.9007505],
  [53.3084775, 29.9007082],
  [53.3086727, 29.9090552],
  [53.307721, 29.924311],
  [53.3046339, 29.9244833],
  [53.303894, 29.929068],
  [53.3018932, 29.9291549],
  [53.3018988, 29.9305603],
  [53.3019527, 29.9309122],
  [53.3019477, 29.9316072],
  [53.3019469, 29.9317148],
  [53.3020963, 29.9326975],
  [53.3021277, 29.9334035],
  [53.3019828, 29.933853],
  [53.3018591, 29.934427],
  [53.3015924, 29.9344914],
  [53.3013731, 29.9345193],
  [53.3011859, 29.9346866],
  [53.3010224, 29.9350268],
  [53.3009473, 29.9354484],
  [53.3010602, 29.9359087],
  [53.3013429, 29.9364054],
  [53.3017155, 29.9365846],
  [53.3020546, 29.9366382],
  [53.3023329, 29.9364966],
  [53.3026041, 29.9364168],
  [53.3028227, 29.9365749],
  [53.3029939, 29.9369794],
  [53.3030965, 29.937533],
  [53.303133, 29.9385265],
  [53.303133, 29.9391895],
  [53.3029811, 29.9395897],
  [53.3028317, 29.939874],
  [53.3026374, 29.940138],
  [53.3023271, 29.9403171],
  [53.3018975, 29.9403161],
  [53.3015225, 29.9401476],
  [53.3013423, 29.939991],
  [53.3011762, 29.9400082],
  [53.3010781, 29.9401862],
  [53.3010628, 29.9404191],
  [53.3010756, 29.9408493],
  [53.3013295, 29.9416196],
  [53.3015026, 29.9418836],
  [53.301745, 29.9419876],
  [53.3020296, 29.9420198],
  [53.3023335, 29.941919],
  [53.3028343, 29.9415477],
  [53.3032042, 29.9410199],
  [53.3035254, 29.9405467],
  [53.3038767, 29.9402088],
  [53.3041127, 29.9398451],
  [53.3042467, 29.9394663],
  [53.3042428, 29.9391316],
  [53.3041364, 29.938828],
  [53.3040691, 29.9385308],
  [53.3041377, 29.9382872],
  [53.3043294, 29.9382261],
  [53.3046672, 29.9383098],
  [53.3049737, 29.9387003],
  [53.3053699, 29.9389117],
  [53.3057071, 29.9389771],
  [53.3059918, 29.9391338],
  [53.3062123, 29.9393601],
  [53.3063277, 29.9396444],
  [53.3063399, 29.939991],
  [53.3062149, 29.9403161],
  [53.3059969, 29.940565],
  [53.305459, 29.9407087],
  [53.3049878, 29.9410081],
  [53.304716, 29.9415703],
  [53.3045589, 29.9423481],
  [53.3041223, 29.9436914],
  [53.3036748, 29.9445218],
  [53.3035998, 29.9449359],
  [53.3037312, 29.9460592],
  [53.3040114, 29.9467029],
  [53.3042742, 29.9471117],
  [53.3044794, 29.9473048],
  [53.3043967, 29.9477059],
  [53.3041274, 29.9482316],
  [53.3034703, 29.9487573],
  [53.3034927, 29.9490577],
  [53.3036145, 29.9494815],
  [53.3043646, 29.9504041],
  [53.3066279, 29.951978],
  [53.3134064, 29.9561888],
  [53.3163518, 29.9617553],
  [53.3252727, 29.9641156],
  [53.3308865, 29.9618616],
  [53.331629, 29.978621],
  [53.3260333, 29.9784456],
  [53.325952, 29.9857664],
  [53.3293865, 29.9944353],
  [53.3232863, 30.0028037],
  [53.3165441, 30.0655889],
  [53.3158391, 30.0676489],
  [53.3161852, 30.0697303],
  [53.3160442, 30.0711894],
  [53.3160826, 30.0724768],
  [53.3149921, 30.0730495],
  [53.3116727, 30.0826049],
  [53.3078522, 30.0892353],
  [53.3060572, 30.0952434],
  [53.305113, 30.1016118],
  [53.2965536, 30.0951782],
  [53.2871802, 30.1238887],
  [53.2837414, 30.1231383],
  [53.2799953, 30.1275157],
  [53.2683444, 30.1323223],
  [53.2664963, 30.1349401],
  [53.2484997, 30.1396179],
  [53.2294483, 30.1526745],
  [53.2230014, 30.1663986],
  [53.2239681, 30.1711815],
  [53.225413, 30.1780761],
  [53.2259753, 30.1801591],
  [53.2304123, 30.1903436],
  [53.2308262, 30.1913747],
  [53.225933, 30.2004204],
  [53.2310799, 30.212338],
  [53.2324542, 30.2188182],
  [53.2325438, 30.2202124],
  [53.23169, 30.2230453],
  [53.2308294, 30.2226806],
  [53.2305019, 30.2264893],
  [53.2301679, 30.2277553],
  [53.229834, 30.2283776],
  [53.2293973, 30.2288175],
  [53.228511, 30.2292251],
  [53.2285688, 30.2314031],
  [53.228759, 30.234375],
  [53.2284146, 30.2377867],
  [53.2291065, 30.2382232],
  [53.2294294, 30.2379477],
  [53.2298448, 30.2371448],
  [53.2302322, 30.2366924],
  [53.2306368, 30.2368855],
  [53.2305918, 30.2376258],
  [53.2308551, 30.2385163],
  [53.2315423, 30.2397716],
  [53.2311676, 30.2408098],
  [53.230885, 30.2413849],
  [53.2338551, 30.2433337],
  [53.2348215, 30.2442989],
  [53.2343487, 30.2482367],
  [53.2348514, 30.2481135],
  [53.2361379, 30.2481248],
  [53.2377782, 30.2484636],
  [53.2386479, 30.2492316],
  [53.2391791, 30.2498107],
  [53.2396018, 30.2503888],
  [53.2406676, 30.2518463],
  [53.243543, 30.2545686],
  [53.2458351, 30.2563406],
  [53.2469944, 30.2580293],
  [53.2480214, 30.2599711],
  [53.2497417, 30.2643591],
  [53.2519141, 30.2708755],
  [53.2519065, 30.2718338],
  [53.2516935, 30.2725347],
  [53.2511286, 30.2730496],
  [53.2506664, 30.2731355],
  [53.2497707, 30.2723551],
  [53.2495268, 30.2712071],
  [53.249344, 30.2692088],
  [53.2492063, 30.2671136],
  [53.2488963, 30.2659109],
  [53.2484578, 30.2649228],
  [53.2479573, 30.264287],
  [53.2471485, 30.2636512],
  [53.2456842, 30.2632851],
  [53.2446906, 30.2634747],
  [53.243543, 30.2639217],
  [53.2428213, 30.2646501],
  [53.2422537, 30.2656359],
  [53.2420732, 30.2674413],
  [53.2422542, 30.2685823],
  [53.2426501, 30.2694794],
  [53.2436337, 30.2711825],
  [53.2456044, 30.2743828],
  [53.2469944, 30.2767833],
  [53.2473925, 30.2779635],
  [53.2475337, 30.2800019],
  [53.2473121, 30.2809703],
  [53.2469818, 30.2819073],
  [53.2456082, 30.2850144],
  [53.2446452, 30.2869752],
  [53.2442985, 30.289451],
  [53.2445235, 30.2978415],
  [53.2445542, 30.298354],
  [53.2449526, 30.2997995],
  [53.2458132, 30.3013738],
  [53.2467634, 30.3030045],
  [53.2470752, 30.3040946],
  [53.2472329, 30.3056998],
  [53.2472264, 30.3063926],
  [53.2472146, 30.3076576],
  [53.2472036, 30.3088368],
  [53.2473173, 30.3111778],
  [53.2475337, 30.3126605],
  [53.2478868, 30.313544],
  [53.2497007, 30.3164417],
  [53.2501194, 30.3178341],
  [53.2501785, 30.3190549],
  [53.2499217, 30.3203062],
  [53.2480346, 30.3232096],
  [53.2475638, 30.3245005],
  [53.2473498, 30.3254482],
  [53.2474931, 30.3266289],
  [53.2478932, 30.3272946],
  [53.2491795, 30.3278307],
  [53.2497689, 30.3284223],
  [53.2500764, 30.3291889],
  [53.2501272, 30.3299554],
  [53.2501247, 30.3310529],
  [53.2496638, 30.3332936],
  [53.249665, 30.3355773],
  [53.2503325, 30.3384098],
  [53.2503582, 30.3397616],
  [53.2501785, 30.3410276],
  [53.2489879, 30.3434043],
  [53.2476188, 30.3450805],
  [53.2459929, 30.3474434],
  [53.2450801, 30.3485622],
  [53.2442034, 30.3495393],
  [53.2427618, 30.350688],
  [53.2423439, 30.3513976],
  [53.2422998, 30.3518621],
  [53.2422138, 30.3527674],
  [53.2425837, 30.3540659],
  [53.2433479, 30.3549321],
  [53.244298, 30.3553183],
  [53.2458516, 30.355211],
  [53.2467279, 30.3552461],
  [53.247999, 30.3555597],
  [53.2492028, 30.3555544],
  [53.2513111, 30.3543207],
  [53.2537789, 30.3524863],
  [53.2545648, 30.3521469],
  [53.2552281, 30.3512348],
  [53.2556712, 30.3504237],
  [53.2562941, 30.3499559],
  [53.2572778, 30.3500417],
  [53.258022, 30.3507346],
  [53.2587505, 30.351727],
  [53.2589992, 30.3521427],
  [53.2590768, 30.3525851],
  [53.2590553, 30.3531057],
  [53.2589398, 30.3534543],
  [53.2583179, 30.3543573],
  [53.257797, 30.3546693],
  [53.2573149, 30.3547751],
  [53.2542672, 30.3548419],
  [53.2521339, 30.3554805],
  [53.251459, 30.356276],
  [53.2510087, 30.3572257],
  [53.2507862, 30.3586753],
  [53.2508428, 30.3603476],
  [53.2517448, 30.3631289],
  [53.2523913, 30.3644045],
  [53.2537567, 30.3655942],
  [53.2544991, 30.3666807],
  [53.2545692, 30.3677638],
  [53.2543455, 30.3687967],
  [53.2539354, 30.3695681],
  [53.2531658, 30.3704253],
  [53.2526207, 30.3708913],
  [53.251973, 30.3719582],
  [53.2513899, 30.3734411],
  [53.251111, 30.3746328],
  [53.2510888, 30.3759104],
  [53.2513655, 30.3769226],
  [53.2516935, 30.3776773],
  [53.2521428, 30.3783639],
  [53.2526873, 30.3786927],
  [53.2539507, 30.3788499],
  [53.2549928, 30.3792249],
  [53.2555728, 30.3796857],
  [53.256623, 30.3809302],
  [53.2572777, 30.3825009],
  [53.2578297, 30.3847154],
  [53.2582533, 30.3862389],
  [53.2587795, 30.3875049],
  [53.2593187, 30.3882774],
  [53.2599989, 30.3881486],
  [53.2604739, 30.387934],
  [53.261244, 30.3869491],
  [53.2619627, 30.3853634],
  [53.2650586, 30.3791781],
  [53.2663064, 30.3777528],
  [53.2674807, 30.3770904],
  [53.2684535, 30.3769336],
  [53.2696702, 30.3771844],
  [53.2704494, 30.3780316],
  [53.2713057, 30.3795226],
  [53.2748641, 30.3863495],
  [53.2761374, 30.3869244],
  [53.2775195, 30.3862919],
  [53.2793281, 30.3842568],
  [53.2798561, 30.385213],
  [53.2804709, 30.3847606],
  [53.2809419, 30.3845162],
  [53.2812135, 30.3844838],
  [53.281787, 30.3847573],
  [53.2819, 30.3847445],
  [53.2819776, 30.3846958],
  [53.2821134, 30.3844329],
  [53.2822709, 30.3839938],
  [53.2823579, 30.3838845],
  [53.2824781, 30.3838456],
  [53.2825538, 30.3839073],
  [53.282645, 30.3840565],
  [53.2826683, 30.3842285],
  [53.2826819, 30.3847931],
  [53.2828194, 30.3854291],
  [53.2828798, 30.3861175],
  [53.2829758, 30.3867966],
  [53.2831119, 30.3872584],
  [53.2831788, 30.3874988],
  [53.2832117, 30.3877236],
  [53.2832063, 30.3880403],
  [53.2831514, 30.3884441],
  [53.2831624, 30.388825],
  [53.2832172, 30.3889903],
  [53.2833572, 30.3892059],
  [53.2834652, 30.3894748],
  [53.2836433, 30.3895311],
  [53.2841249, 30.3891927],
  [53.2845945, 30.3884625],
  [53.284992, 30.3877312],
  [53.2850774, 30.3873841],
  [53.2851981, 30.3865121],
  [53.2853133, 30.3859201],
  [53.2854505, 30.3856356],
  [53.2856678, 30.3852929],
  [53.2861885, 30.3846581],
  [53.2864382, 30.3842405],
  [53.286633, 30.3840064],
  [53.2868891, 30.3838501],
  [53.2871377, 30.3838917],
  [53.2873353, 30.3839606],
  [53.2874752, 30.3840432],
  [53.2875657, 30.3841166],
  [53.2877715, 30.3844424],
  [53.2881062, 30.3851537],
  [53.2881473, 30.385374],
  [53.2881583, 30.385553],
  [53.2881418, 30.3857457],
  [53.2880946, 30.38587],
  [53.2880321, 30.3860532],
  [53.2878949, 30.3862414],
  [53.2875212, 30.3866742],
  [53.2867838, 30.3878108],
  [53.2863578, 30.3885695],
  [53.2862583, 30.3888048],
  [53.2862292, 30.3889402],
  [53.2862235, 30.3890185],
  [53.2862816, 30.3891964],
  [53.2863696, 30.389339],
  [53.2867317, 30.3894859],
  [53.2869094, 30.3895972],
  [53.2870198, 30.3897566],
  [53.2869539, 30.3900733],
  [53.2868058, 30.3904817],
  [53.2867262, 30.3907708],
  [53.2866181, 30.3910925],
  [53.2865198, 30.3911766],
  [53.2863744, 30.3911949],
  [53.2862198, 30.3911136],
  [53.2861168, 30.3911523],
  [53.2859852, 30.3913797],
  [53.2857242, 30.3922963],
  [53.2854044, 30.3935563],
  [53.285063, 30.3943936],
  [53.2848765, 30.3955041],
  [53.2846871, 30.3962797],
  [53.2844402, 30.3968212],
  [53.2842085, 30.3971549],
  [53.2838449, 30.397528],
  [53.2836819, 30.3982132],
  [53.2834001, 30.3987796],
  [53.2832454, 30.3989461],
  [53.282777, 30.3992142],
  [53.2825733, 30.3992653],
  [53.2823014, 30.3993411],
  [53.2818901, 30.3996137],
  [53.2815291, 30.400116],
  [53.2809167, 30.4005339],
  [53.2807878, 30.4007567],
  [53.2807493, 30.4009766],
  [53.2807319, 30.4013699],
  [53.2806667, 30.4017457],
  [53.2804979, 30.4021026],
  [53.2804125, 30.4021708],
  [53.2802896, 30.4022013],
  [53.2853129, 30.4148116],
  [53.2849514, 30.4151366],
  [53.2836797, 30.4163381],
  [53.2824917, 30.4209365],
  [53.2791891, 30.4292656],
  [53.2791246, 30.4327055],
  [53.2788567, 30.4334685],
  [53.2790964, 30.4356235],
  [53.280642, 30.4377831],
  [53.2778399, 30.4453441],
  [53.2771573, 30.4506956],
  [53.2778405, 30.4536607],
  [53.2779038, 30.4547107],
  [53.2765205, 30.4549812],
  [53.2761985, 30.4562694],
  [53.2758493, 30.4577676],
  [53.280873, 30.4626781],
  [53.2844837, 30.4655176],
  [53.2869511, 30.4672731],
  [53.2864417, 30.470837],
  [53.2948514, 30.4720058],
  [53.293214, 30.4935772],
  [53.3132988, 30.5068865],
  [53.3131247, 30.5074156],
  [53.3117787, 30.5437377],
  [53.3201974, 30.5490833],
  [53.3233315, 30.5510867],
  [53.3318745, 30.5567157],
  [53.3303293, 30.5618898],
  [53.3312864, 30.5642685],
  [53.3320904, 30.5635035],
  [53.3340596, 30.56273],
  [53.3346022, 30.5627617],
  [53.3359788, 30.5629199],
  [53.3377548, 30.5648447],
  [53.3395834, 30.566871],
  [53.3398967, 30.5672182],
  [53.342389, 30.5674482],
  [53.3454353, 30.5678469],
  [53.3460074, 30.5668288],
  [53.3482681, 30.5690603],
  [53.3479985, 30.569935],
  [53.343353, 30.58494],
  [53.342852, 30.5862582],
  [53.3390009, 30.5828533],
  [53.3383615, 30.5822202],
  [53.3374343, 30.5810893],
  [53.3356521, 30.5798027],
  [53.3332855, 30.5777785],
  [53.3275286, 30.5727409],
  [53.3210473, 30.5665173],
  [53.3206882, 30.5662196],
  [53.3185524, 30.5733326],
  [53.3178547, 30.5739696],
  [53.3166971, 30.5763457],
  [53.3154797, 30.5793502],
  [53.3156928, 30.5854405],
  [53.3115823, 30.5862416],
  [53.3084226, 30.5782366],
  [53.3078284, 30.5767314],
  [53.3041984, 30.5727285],
  [53.3015427, 30.5902885],
  [53.2962076, 30.6277095],
  [53.2934422, 30.6455611],
  [53.293308, 30.645575],
  [53.292421, 30.6518493],
  [53.2928642, 30.6569303],
  [53.2933353, 30.656955],
  [53.2932494, 30.6726134],
  [53.2886581, 30.6668277],
  [53.2883245, 30.6649379],
  [53.2865665, 30.6630967],
  [53.282124, 30.6601982],
  [53.2755141, 30.6569596],
  [53.2752678, 30.6568485],
  [53.2744344, 30.658534],
  [53.2741776, 30.6649978],
  [53.2732097, 30.6691564],
  [53.2656266, 30.671822],
  [53.2647831, 30.6731455],
  [53.2604304, 30.6806576],
  [53.2604538, 30.6854097],
  [53.2608432, 30.7130191],
  [53.262159, 30.7133022],
  [53.2624775, 30.7180137],
  [53.2622493, 30.7201428],
  [53.2615693, 30.7236159],
  [53.2737984, 30.7209667],
  [53.2779128, 30.7202857],
  [53.278198, 30.723266],
  [53.2781516, 30.7251677],
  [53.2781442, 30.725466],
  [53.2780087, 30.7309264],
  [53.278776, 30.7358457],
  [53.280372, 30.7594333],
  [53.2806725, 30.7593964],
  [53.2865629, 30.7586702],
  [53.286581, 30.7588809],
  [53.28712, 30.76026],
  [53.28747, 30.7612],
  [53.2877105, 30.7625216],
  [53.28789, 30.76429],
  [53.28781, 30.7661],
  [53.2876242, 30.7665653],
  [53.2877189, 30.7667278],
  [53.287707, 30.7670423],
  [53.2880952, 30.7673739],
  [53.28805, 30.7679466],
  [53.2879329, 30.7682017],
  [53.287949, 30.7684121],
  [53.2881825, 30.768652],
  [53.288067, 30.7691408],
  [53.2879067, 30.7690677],
  [53.2878284, 30.7698013],
  [53.2877303, 30.770485],
  [53.2880162, 30.7706645],
  [53.2881854, 30.7709982],
  [53.2883639, 30.770925],
  [53.2884038, 30.7712077],
  [53.2882476, 30.7713662],
  [53.2880957, 30.7711376],
  [53.2880617, 30.7714326],
  [53.2881581, 30.7715591],
  [53.2880511, 30.7717604],
  [53.2881468, 30.7721377],
  [53.2884049, 30.7719995],
  [53.2881605, 30.7726106],
  [53.2881171, 30.7724166],
  [53.2880275, 30.7724372],
  [53.2879739, 30.7722861],
  [53.2878715, 30.7723282],
  [53.287845, 30.7726759],
  [53.2879494, 30.7729076],
  [53.2879019, 30.7733307],
  [53.28807, 30.77408],
  [53.2879492, 30.776413],
  [53.2878224, 30.7768277],
  [53.2881574, 30.7774656],
  [53.2882866, 30.7781293],
  [53.2882156, 30.7783897],
  [53.288411, 30.7786539],
  [53.2880341, 30.7789197],
  [53.2880748, 30.7791602],
  [53.2883494, 30.7791106],
  [53.2883671, 30.7793091],
  [53.2882463, 30.7794132],
  [53.28841, 30.77957],
  [53.2885254, 30.7793109],
  [53.2886306, 30.7792751],
  [53.28861, 30.7798213],
  [53.2883688, 30.7802957],
  [53.2883745, 30.7804377],
  [53.2886342, 30.7803143],
  [53.288666, 30.7800912],
  [53.288898, 30.780251],
  [53.2889012, 30.7806132],
  [53.2889996, 30.7807053],
  [53.288898, 30.7808935],
  [53.288793, 30.780695],
  [53.2887105, 30.7807765],
  [53.2889687, 30.781133],
  [53.2890696, 30.7809638],
  [53.2890755, 30.7811508],
  [53.2891386, 30.7811944],
  [53.289272, 30.7810843],
  [53.2892799, 30.780986],
  [53.2893509, 30.7810599],
  [53.2893754, 30.7811857],
  [53.2893018, 30.7811936],
  [53.2892727, 30.7816615],
  [53.2893251, 30.7817552],
  [53.2894114, 30.7819098],
  [53.2894365, 30.7817989],
  [53.2894701, 30.7817752],
  [53.2895987, 30.7823889],
  [53.2897073, 30.782429],
  [53.2897582, 30.7823262],
  [53.2898146, 30.78233],
  [53.2897987, 30.7825914],
  [53.289864, 30.7825408],
  [53.2898841, 30.7826422],
  [53.2898294, 30.7827456],
  [53.2897055, 30.7827031],
  [53.2897103, 30.7828197],
  [53.289738, 30.7830077],
  [53.2896682, 30.7833159],
  [53.2895779, 30.783418],
  [53.2896467, 30.7836318],
  [53.2896154, 30.7837077],
  [53.2896176, 30.7838395],
  [53.289681, 30.7841148],
  [53.2897, 30.7844815],
  [53.2894966, 30.7848781],
  [53.2892409, 30.7852412],
  [53.2890656, 30.78532],
  [53.2889265, 30.7853848],
  [53.2889102, 30.7854843],
  [53.2888604, 30.7855045],
  [53.2888315, 30.7857745],
  [53.2888383, 30.7858796],
  [53.2889137, 30.7861154],
  [53.288989, 30.7861724],
  [53.2891056, 30.7861195],
  [53.2891907, 30.786152],
  [53.2892053, 30.7862089],
  [53.2891785, 30.7863472],
  [53.2890619, 30.7863146],
  [53.2890109, 30.7863797],
  [53.2890036, 30.786522],
  [53.2890522, 30.7867822],
  [53.2890935, 30.7869448],
  [53.2891421, 30.787018],
  [53.2891372, 30.7870871],
  [53.2892247, 30.7871847],
  [53.2892199, 30.7872822],
  [53.2891105, 30.7873513],
  [53.2890133, 30.7872782],
  [53.2889671, 30.7871196],
  [53.2889404, 30.7870505],
  [53.2888918, 30.7869773],
  [53.2888918, 30.7867944],
  [53.2889185, 30.7867375],
  [53.2889137, 30.7866317],
  [53.2888699, 30.7866074],
  [53.2888456, 30.7866561],
  [53.2887362, 30.7866602],
  [53.2886439, 30.7867049],
  [53.2886123, 30.7868025],
  [53.2886293, 30.7868919],
  [53.2886803, 30.7869285],
  [53.288746, 30.7871481],
  [53.2887533, 30.7872578],
  [53.2887046, 30.7873635],
  [53.2886172, 30.787331],
  [53.2885005, 30.7872578],
  [53.2884446, 30.7871684],
  [53.2883984, 30.787205],
  [53.288362, 30.7873147],
  [53.2884373, 30.7874774],
  [53.2884884, 30.7876034],
  [53.2885831, 30.7876034],
  [53.2886585, 30.7876197],
  [53.2887095, 30.787705],
  [53.2886731, 30.7878189],
  [53.2885661, 30.7878839],
  [53.2884786, 30.7880506],
  [53.2885515, 30.7881034],
  [53.2886269, 30.7881604],
  [53.2886731, 30.788136],
  [53.28878, 30.7879002],
  [53.2888189, 30.787766],
  [53.2888869, 30.787766],
  [53.2888748, 30.7879368],
  [53.2889282, 30.7881034],
  [53.2890084, 30.788197],
  [53.2890011, 30.788262],
  [53.2889209, 30.7883108],
  [53.288831, 30.7884287],
  [53.2887508, 30.7884165],
  [53.288571, 30.7882539],
  [53.2884859, 30.7882173],
  [53.2884082, 30.7882457],
  [53.2883401, 30.7883718],
  [53.2882502, 30.7885344],
  [53.2881262, 30.7885425],
  [53.2881457, 30.7886482],
  [53.2880558, 30.7887783],
  [53.2880485, 30.788945],
  [53.2881384, 30.7889897],
  [53.2882623, 30.7891889],
  [53.2883863, 30.7892377],
  [53.2884495, 30.7892946],
  [53.2884811, 30.7891849],
  [53.2885151, 30.7890629],
  [53.2885661, 30.7890548],
  [53.2885564, 30.7891767],
  [53.2885807, 30.7893231],
  [53.2885199, 30.7894613],
  [53.288396, 30.7895833],
  [53.2883984, 30.7897256],
  [53.2883996, 30.7897693],
  [53.2884057, 30.7900061],
  [53.2883644, 30.7902581],
  [53.2882842, 30.7905143],
  [53.2882113, 30.7906891],
  [53.2881214, 30.7908842],
  [53.2882016, 30.7910103],
  [53.288221, 30.7911241],
  [53.2881748, 30.7912745],
  [53.2882113, 30.7914046],
  [53.288328, 30.7914534],
  [53.2883863, 30.7914778],
  [53.2885078, 30.791551],
  [53.2885686, 30.7916567],
  [53.2887265, 30.7917217],
  [53.2887654, 30.7918152],
  [53.2887411, 30.7919778],
  [53.2887217, 30.7921445],
  [53.2887209, 30.792345],
  [53.2886986, 30.7925318],
  [53.2887376, 30.7926298],
  [53.2887683, 30.7926625],
  [53.2887795, 30.7930361],
  [53.2887404, 30.7932136],
  [53.288693, 30.793279],
  [53.288559, 30.793293],
  [53.2884892, 30.7932042],
  [53.288344, 30.7931108],
  [53.2882854, 30.7931248],
  [53.2881235, 30.7934377],
  [53.2881542, 30.7937273],
  [53.2882324, 30.79383],
  [53.2882994, 30.7941196],
  [53.2882882, 30.7941943],
  [53.2881877, 30.7941569],
  [53.2880565, 30.7940495],
  [53.2880174, 30.7940495],
  [53.2879978, 30.7941289],
  [53.2880649, 30.7943017],
  [53.2880565, 30.7944745],
  [53.2880062, 30.7944932],
  [53.2879085, 30.7944791],
  [53.2878164, 30.7946426],
  [53.2877215, 30.7946426],
  [53.2876824, 30.7945772],
  [53.2876154, 30.7945772],
  [53.2875763, 30.794708],
  [53.2876321, 30.7949275],
  [53.2876405, 30.7952123],
  [53.2875791, 30.7953384],
  [53.2874981, 30.7953618],
  [53.2873613, 30.7955019],
  [53.2873474, 30.7955766],
  [53.2873865, 30.7956046],
  [53.2875177, 30.795642],
  [53.2875819, 30.7959268],
  [53.2875344, 30.7960156],
  [53.2874786, 30.7960202],
  [53.2874088, 30.796123],
  [53.2874004, 30.7962351],
  [53.2875512, 30.7962584],
  [53.2876377, 30.7963985],
  [53.2877243, 30.7964592],
  [53.2878331, 30.7964172],
  [53.2878276, 30.7965199],
  [53.2877913, 30.7966974],
  [53.2877271, 30.7967768],
  [53.2876656, 30.7969122],
  [53.2875864, 30.7971238],
  [53.2876644, 30.7972656],
  [53.2867559, 30.802617],
  [53.2862519, 30.8063648],
  [53.2864045, 30.8114147],
  [53.285752, 30.8164421],
  [53.2855154, 30.8177245],
  [53.2854481, 30.818293],
  [53.2854569, 30.8190626],
  [53.2851053, 30.8201661],
  [53.2820091, 30.83049],
  [53.2812399, 30.8329813],
  [53.2804735, 30.8354636],
  [53.2832795, 30.8384943],
  [53.2855245, 30.8416486],
  [53.290518, 30.8515402],
  [53.2919765, 30.850296],
  [53.2958098, 30.8494588],
  [53.2964269, 30.8501887],
  [53.2975939, 30.8548665],
  [53.3005049, 30.8554244],
  [53.3013641, 30.8584499],
  [53.3021848, 30.8586645],
  [53.3027875, 30.8625269],
  [53.303544, 30.8634496],
  [53.3024071, 30.8677402],
  [53.3004408, 30.8666682],
  [53.2992226, 30.8676982],
  [53.2983121, 30.8688569],
  [53.2963371, 30.8710885],
  [53.2955804, 30.8731913],
  [53.301736, 30.8819246],
  [53.3057366, 30.8830404],
  [53.3060828, 30.8836627],
  [53.3062174, 30.8847892],
  [53.3061533, 30.8858943],
  [53.3050089, 30.8890217],
  [53.3045057, 30.8925676],
  [53.3066726, 30.9001851],
  [53.3088779, 30.9058499],
  [53.3101728, 30.9059143],
  [53.3113108, 30.9150766],
  [53.3096728, 30.9146905],
  [53.3053866, 30.915568],
  [53.3033902, 30.9153556],
  [53.3039031, 30.9377574],
  [53.3062623, 30.9435081],
  [53.3072881, 30.9682273],
  [53.3063521, 30.9832263],
  [53.3077084, 31.0015425],
  [53.3077185, 31.0016786],
  [53.307865, 31.0053277],
  [53.3085416, 31.0125999],
  [53.305664, 31.014404],
  [53.3030809, 31.01788],
  [53.3014667, 31.0184169],
  [53.2996329, 31.0180092],
  [53.29744, 31.0152626],
  [53.2958049, 31.013267],
  [53.2941087, 31.0083517],
  [53.2939187, 31.0080147],
  [53.2936012, 31.007505],
  [53.2930698, 31.0069954],
  [53.2912338, 31.0059969],
  [53.2884035, 31.004447],
  [53.2866417, 31.0034202],
  [53.2856625, 31.0025434],
  [53.2846153, 31.0014227],
  [53.28403, 31.00084],
  [53.2830486, 30.9993887],
  [53.2827328, 30.9982938],
  [53.2816786, 30.9946035],
  [53.2808746, 30.9913426],
  [53.2800706, 30.9892038],
  [53.2779456, 30.9836873],
  [53.2758001, 30.9807029],
  [53.2748223, 30.9793428],
  [53.2745986, 30.9789643],
  [53.2715959, 30.9752351],
  [53.2708352, 30.9740583],
  [53.269032, 30.9717812],
  [53.2682033, 30.9710891],
  [53.26721, 30.97003],
  [53.2664753, 30.9696527],
  [53.2653017, 30.9696117],
  [53.2638305, 30.9697286],
  [53.26146, 30.9702],
  [53.2606305, 30.9701865],
  [53.2598042, 30.969981],
  [53.2589779, 30.9695309],
  [53.2582243, 30.9685562],
  [53.2573706, 30.9721327],
  [53.2569342, 30.9732699],
  [53.2566004, 30.9749436],
  [53.2574219, 30.9771108],
  [53.2579482, 30.9796858],
  [53.2575728, 30.9838694],
  [53.2561896, 30.9854579],
  [53.2556633, 30.9867024],
  [53.2553552, 30.9882474],
  [53.2548417, 30.992217],
  [53.2550086, 30.9951997],
  [53.2557403, 30.998826],
  [53.2567288, 31.0000706],
  [53.2598095, 31.0018515],
  [53.2637498, 31.0052848],
  [53.2654529, 31.0110139],
  [53.2557629, 31.0216351],
  [53.2572422, 31.0269141],
  [53.2562795, 31.0357761],
  [53.2559971, 31.0357117],
  [53.2544527, 31.043457],
  [53.2498975, 31.0419987],
  [53.2453703, 31.0380069],
  [53.2417972, 31.0362052],
  [53.2355816, 31.0346174],
  [53.2345542, 31.0354113],
  [53.2339248, 31.0354113],
  [53.2331799, 31.0357332],
  [53.2327946, 31.0366344],
  [53.2320496, 31.0392093],
  [53.2302386, 31.0432004],
  [53.2298019, 31.0475349],
  [53.229712, 31.0526633],
  [53.2246637, 31.0540581],
  [53.224602, 31.0623185],
  [53.1943131, 31.0622327],
  [53.1962928, 31.0658803],
  [53.1981665, 31.0755586],
  [53.1979737, 31.0804081],
  [53.2015984, 31.0819101],
  [53.2023825, 31.0830688],
  [53.2027514, 31.0867804],
  [53.1981524, 31.0927455],
  [53.1955844, 31.0999902],
  [53.1927288, 31.1080456],
  [53.1908133, 31.1078095],
  [53.187607, 31.1070368],
  [53.185537, 31.1244601],
  [53.1836131, 31.1236667],
  [53.1812599, 31.1232161],
  [53.176656, 31.121521],
  [53.1732864, 31.1208129],
  [53.170675, 31.1283225],
  [53.1624684, 31.1207485],
  [53.1638964, 31.1169505],
  [53.1566275, 31.1027232],
  [53.1495278, 31.1114142],
  [53.1386813, 31.120393],
  [53.1403584, 31.1467025],
  [53.1422641, 31.17453],
  [53.1443122, 31.2065777],
  [53.1444739, 31.2101298],
  [53.1443297, 31.2101175],
  [53.1442373, 31.2101298],
  [53.1442115, 31.2102777],
  [53.1441856, 31.2105488],
  [53.1440932, 31.2106905],
  [53.1438271, 31.2108631],
  [53.1435868, 31.2110541],
  [53.1434944, 31.2109678],
  [53.1434649, 31.210746],
  [53.1433836, 31.2106905],
  [53.1432024, 31.2107213],
  [53.1429992, 31.2109863],
  [53.1429031, 31.2111958],
  [53.1428402, 31.2115594],
  [53.142685, 31.2116457],
  [53.1425482, 31.2113499],
  [53.1425076, 31.211165],
  [53.1424262, 31.2111465],
  [53.1424004, 31.2112266],
  [53.1424299, 31.2113869],
  [53.1423708, 31.2116025],
  [53.1424152, 31.2117689],
  [53.1423819, 31.2119599],
  [53.1422119, 31.2122434],
  [53.1420936, 31.2122557],
  [53.1420086, 31.2121017],
  [53.1419901, 31.2119476],
  [53.1420123, 31.2117997],
  [53.1419494, 31.2116333],
  [53.1417498, 31.211584],
  [53.1415281, 31.2114177],
  [53.1413506, 31.2114362],
  [53.1412139, 31.2115902],
  [53.1412287, 31.2117936],
  [53.1411436, 31.2119784],
  [53.1409773, 31.2119599],
  [53.1409256, 31.2120832],
  [53.1409551, 31.2122249],
  [53.1408701, 31.2124775],
  [53.1408923, 31.2128781],
  [53.1407777, 31.2130013],
  [53.1405929, 31.2129274],
  [53.1402085, 31.2127302],
  [53.1400273, 31.2126624],
  [53.1397797, 31.2128658],
  [53.1396207, 31.2131184],
  [53.1394507, 31.2131677],
  [53.1392955, 31.2129767],
  [53.1392141, 31.2129828],
  [53.1388925, 31.2130999],
  [53.1387373, 31.2129274],
  [53.138534, 31.2124159],
  [53.1384822, 31.2122372],
  [53.1383787, 31.2121263],
  [53.1381458, 31.2122249],
  [53.1379166, 31.2124652],
  [53.1377614, 31.2123605],
  [53.1376838, 31.2124467],
  [53.1375026, 31.2127302],
  [53.137255, 31.2126378],
  [53.1371921, 31.2123913],
  [53.1371825, 31.2123385],
  [53.1370055, 31.2124288],
  [53.1368539, 31.2122317],
  [53.1366654, 31.2120961],
  [53.1363401, 31.2122317],
  [53.1361959, 31.2122563],
  [53.1360628, 31.2119913],
  [53.1358743, 31.2118804],
  [53.1357412, 31.2120037],
  [53.135671, 31.2121885],
  [53.135597, 31.2124227],
  [53.1355453, 31.2126014],
  [53.1354307, 31.2125151],
  [53.1354122, 31.2123611],
  [53.1354528, 31.2122871],
  [53.1354196, 31.2120653],
  [53.1351756, 31.2118989],
  [53.1350425, 31.2119482],
  [53.134971, 31.2117937],
  [53.1348395, 31.212023],
  [53.1347249, 31.2121155],
  [53.1346214, 31.2123373],
  [53.1344809, 31.2123681],
  [53.1344106, 31.2121524],
  [53.1342554, 31.2121031],
  [53.1341851, 31.2118443],
  [53.1340927, 31.2118443],
  [53.1340299, 31.212134],
  [53.1340557, 31.2124051],
  [53.1339079, 31.2127194],
  [53.133919, 31.2129658],
  [53.133845, 31.2128611],
  [53.1337526, 31.2128796],
  [53.1337341, 31.2131261],
  [53.1336713, 31.2131076],
  [53.1336121, 31.2129289],
  [53.1335308, 31.2129104],
  [53.1335123, 31.2132123],
  [53.1334347, 31.2132431],
  [53.1333718, 31.2131753],
  [53.1333533, 31.2130521],
  [53.1331685, 31.2130644],
  [53.1331204, 31.2131507],
  [53.1330576, 31.2129597],
  [53.1330687, 31.2126824],
  [53.132943, 31.2126454],
  [53.132832, 31.2128672],
  [53.1327581, 31.2130213],
  [53.1326102, 31.2130398],
  [53.1324993, 31.2131261],
  [53.1323625, 31.2131384],
  [53.1322923, 31.2131199],
  [53.1321851, 31.2131261],
  [53.1322035, 31.2132863],
  [53.1320372, 31.2133048],
  [53.1319669, 31.2132616],
  [53.1318449, 31.2130275],
  [53.1317821, 31.2131014],
  [53.1317155, 31.213391],
  [53.1316231, 31.2132924],
  [53.1314974, 31.2134157],
  [53.1313643, 31.2134711],
  [53.1313233, 31.2134826],
  [53.1311422, 31.2136181],
  [53.1310682, 31.2137907],
  [53.1309647, 31.2137907],
  [53.1308944, 31.2139139],
  [53.130754, 31.2139262],
  [53.1307022, 31.2138276],
  [53.1305765, 31.2138646],
  [53.1304249, 31.2140864],
  [53.1301883, 31.2142282],
  [53.1299517, 31.2144192],
  [53.1298814, 31.2145794],
  [53.1296965, 31.2147335],
  [53.1295819, 31.2149368],
  [53.1294784, 31.2150046],
  [53.1294155, 31.2149368],
  [53.1292898, 31.2147396],
  [53.1289386, 31.2148875],
  [53.1289091, 31.2149109],
  [53.1287907, 31.2150046],
  [53.1287796, 31.2152757],
  [53.1287241, 31.2154852],
  [53.1285984, 31.2154359],
  [53.1283655, 31.2152203],
  [53.1280475, 31.2152634],
  [53.1279625, 31.2152388],
  [53.1278737, 31.2153805],
  [53.1277813, 31.2155962],
  [53.1276889, 31.2156701],
  [53.1275816, 31.2157564],
  [53.1275816, 31.2158426],
  [53.1276519, 31.2159597],
  [53.1276815, 31.216009],
  [53.1276334, 31.2161692],
  [53.1276186, 31.2165759],
  [53.1275373, 31.2166684],
  [53.1275373, 31.2167361],
  [53.1276482, 31.2168779],
  [53.127711, 31.2170196],
  [53.1276186, 31.2173092],
  [53.1275398, 31.2173941],
  [53.1272563, 31.2173832],
  [53.127101, 31.2174448],
  [53.1269734, 31.2176612],
  [53.1265195, 31.2179048],
  [53.1262587, 31.2180996],
  [53.1241658, 31.2194912],
  [53.1233612, 31.220045],
  [53.1187151, 31.2225821],
  [53.1179713, 31.2229789],
  [53.1163035, 31.2239224],
  [53.1161411, 31.2259252],
  [53.1174908, 31.2271269],
  [53.118861, 31.2272127],
  [53.1202518, 31.2265947],
  [53.122679, 31.2289458],
  [53.1231305, 31.2311525],
  [53.1224488, 31.2391269],
  [53.1193754, 31.2430596],
  [53.1176076, 31.2431111],
  [53.1178245, 31.2469366],
  [53.1215984, 31.2468586],
  [53.1221124, 31.2484642],
  [53.1193661, 31.2507686],
  [53.1147528, 31.250421],
  [53.1146936, 31.252436],
  [53.1119455, 31.3034566],
  [53.1118265, 31.312357],
  [53.1143406, 31.3127859],
  [53.1138632, 31.3274457],
  [53.113508, 31.3307423],
  [53.1106621, 31.3302947],
  [53.1100687, 31.338729],
  [53.0939543, 31.3409881],
  [53.0958467, 31.3606592],
  [53.09624, 31.37335],
  [53.09658, 31.38365],
  [53.096492, 31.3912003],
  [53.1078464, 31.3891731],
  [53.109694, 31.3987906],
  [53.1124576, 31.3968851],
  [53.1157551, 31.3950068],
  [53.12113, 31.38588],
  [53.1231409, 31.3839164],
  [53.12653, 31.37601],
  [53.1259144, 31.369945],
  [53.1250968, 31.3672507],
  [53.1267311, 31.3655295],
  [53.1286569, 31.3647527],
  [53.1297957, 31.366016],
  [53.1322181, 31.3665997],
  [53.1335077, 31.3659712],
  [53.13392, 31.36648],
  [53.13881, 31.36391],
  [53.14396, 31.36356],
  [53.14353, 31.36897],
  [53.14653, 31.37335],
  [53.14773, 31.37507],
  [53.15297, 31.38425],
  [53.15615, 31.39446],
  [53.16112, 31.39738],
  [53.16507, 31.39352],
  [53.17091, 31.39858],
  [53.1752, 31.41232],
  [53.17829, 31.41489],
  [53.17924, 31.41523],
  [53.18318, 31.41644],
  [53.18764, 31.41841],
  [53.19013, 31.4142],
  [53.19331, 31.4136],
  [53.19769, 31.40502],
  [53.20275, 31.40725],
  [53.20618, 31.40528],
  [53.21185, 31.40184],
  [53.21202, 31.4088],
  [53.21048, 31.41618],
  [53.20953, 31.42665],
  [53.20996, 31.44038],
  [53.20919, 31.44708],
  [53.20842, 31.45377],
  [53.21048, 31.45918],
  [53.20953, 31.46587],
  [53.20636, 31.47223],
  [53.2054625, 31.4778705],
  [53.20464, 31.48304],
  [53.2045994, 31.4871606],
  [53.20447, 31.50029],
  [53.19992, 31.51179],
  [53.19769, 31.51969],
  [53.19794, 31.52089],
  [53.20009, 31.53214],
  [53.19881, 31.53849],
  [53.1908194, 31.5433397],
  [53.1917009, 31.5558246],
  [53.192279, 31.5640135],
  [53.19374, 31.56655],
  [53.19357, 31.57771],
  [53.19597, 31.58664],
  [53.20112, 31.59239],
  [53.20541, 31.59428],
  [53.20576, 31.59471],
  [53.2062814, 31.5953928],
  [53.208635, 31.5985843],
  [53.20996, 31.60037],
  [53.21314, 31.60895],
  [53.21674, 31.61496],
  [53.2208694, 31.6180198],
  [53.22369, 31.62011],
  [53.2279442, 31.6248535],
  [53.2287349, 31.6257352],
  [53.2312325, 31.6284578],
  [53.2306763, 31.6293123],
  [53.2294336, 31.6327497],
  [53.2289601, 31.633331],
  [53.2287311, 31.6343207],
  [53.22811, 31.634963],
  [53.226693, 31.6351451],
  [53.2257756, 31.6358734],
  [53.2246765, 31.6364803],
  [53.2238862, 31.6373907],
  [53.2232958, 31.6383466],
  [53.2224237, 31.6400307],
  [53.2222456, 31.6404119],
  [53.2218423, 31.6412749],
  [53.2214861, 31.6421681],
  [53.2214938, 31.6429336],
  [53.2212722, 31.6434312],
  [53.220791, 31.6434057],
  [53.2203174, 31.643597],
  [53.2196145, 31.6452812],
  [53.2192479, 31.6477054],
  [53.2192258, 31.6497654],
  [53.2193439, 31.6508578],
  [53.2196346, 31.652542],
  [53.2196618, 31.6534979],
  [53.219253, 31.6547876],
  [53.2188714, 31.6552732],
  [53.2188714, 31.6563656],
  [53.2185807, 31.6572456],
  [53.2180265, 31.6583684],
  [53.2183718, 31.659385],
  [53.2182173, 31.6603409],
  [53.2173179, 31.6610692],
  [53.2168091, 31.6611602],
  [53.2162186, 31.6608871],
  [53.2158097, 31.6612664],
  [53.2149012, 31.6623741],
  [53.2142015, 31.6629506],
  [53.2126755, 31.6653965],
  [53.2124827, 31.6658149],
  [53.2125277, 31.6662548],
  [53.2125617, 31.6666033],
  [53.212279, 31.6669733],
  [53.2119581, 31.6673178],
  [53.2116525, 31.6678665],
  [53.2117136, 31.6689892],
  [53.2120263, 31.6706007],
  [53.2120062, 31.6722563],
  [53.212113, 31.6757178],
  [53.2114452, 31.6795758],
  [53.21048, 31.68603],
  [53.2086967, 31.6942771],
  [53.20818, 31.6966663],
  [53.2061586, 31.7068978],
  [53.2043421, 31.7104547],
  [53.2033055, 31.7125259],
  [53.1997022, 31.7196181],
  [53.1951175, 31.7245295],
  [53.1950871, 31.7249521],
  [53.1950354, 31.7255006],
  [53.1948619, 31.7258641],
  [53.1946699, 31.7261414],
  [53.1943451, 31.7269487],
  [53.1941457, 31.7272814],
  [53.193998, 31.7276203],
  [53.1937322, 31.7281256],
  [53.193699, 31.7286494],
  [53.1937913, 31.7289575],
  [53.1937322, 31.7291609],
  [53.1935735, 31.7294628],
  [53.1935772, 31.7296908],
  [53.1937396, 31.7299003],
  [53.193939, 31.7298449],
  [53.1940128, 31.7298633],
  [53.194035, 31.7302762],
  [53.1940387, 31.730572],
  [53.1942122, 31.7313238],
  [53.1942675, 31.7317736],
  [53.1942823, 31.7322111],
  [53.1944632, 31.7325069],
  [53.1946146, 31.7329752],
  [53.1947512, 31.7336222],
  [53.1947844, 31.7340474],
  [53.1947069, 31.7345157],
  [53.1948324, 31.735021],
  [53.1948471, 31.7353168],
  [53.1948841, 31.7356126],
  [53.1950022, 31.7356249],
  [53.1950945, 31.7354339],
  [53.1952126, 31.735095],
  [53.1953418, 31.7350457],
  [53.1955006, 31.7352059],
  [53.1955922, 31.7356855],
  [53.1957529, 31.7357069],
  [53.1960421, 31.7358249],
  [53.1962446, 31.7359429],
  [53.1963346, 31.7362755],
  [53.1965467, 31.7366189],
  [53.1966334, 31.7366671],
  [53.1967813, 31.7365384],
  [53.1969291, 31.7364687],
  [53.197138, 31.7366296],
  [53.1972537, 31.7367852],
  [53.1972569, 31.7370748],
  [53.1972858, 31.7374074],
  [53.1973822, 31.7376166],
  [53.1975975, 31.7376864],
  [53.1977614, 31.7376864],
  [53.1978932, 31.7379117],
  [53.1979832, 31.7380941],
  [53.1981535, 31.7380941],
  [53.1983206, 31.7379278],
  [53.1985198, 31.7378151],
  [53.1987223, 31.7380082],
  [53.198899, 31.7383945],
  [53.1988958, 31.7386573],
  [53.1987898, 31.7388773],
  [53.1988122, 31.7393011],
  [53.198854, 31.7397517],
  [53.198944, 31.7399126],
  [53.199095, 31.740095],
  [53.1991754, 31.7405242],
  [53.1991657, 31.7409426],
  [53.1990693, 31.7413986],
  [53.1989697, 31.7419243],
  [53.1989054, 31.7424178],
  [53.1989119, 31.7430079],
  [53.1990115, 31.7432815],
  [53.1991111, 31.7436999],
  [53.1992497, 31.7442331],
  [53.1996986, 31.7447654],
  [53.1972943, 31.7474579],
  [53.1953466, 31.7503941],
  [53.1953113, 31.7513687],
  [53.1944735, 31.7527191],
  [53.1881029, 31.7580814],
  [53.1842099, 31.766152],
  [53.1831869, 31.7672116],
  [53.181423, 31.7700373],
  [53.1803646, 31.7739227],
  [53.1797273, 31.7863992],
  [53.1771536, 31.790634],
  [53.1752526, 31.7903829],
  [53.1736704, 31.7918445],
  [53.1730847, 31.7923855],
  [53.1713503, 31.7923252],
  [53.1704108, 31.7912703],
  [53.1632193, 31.791146],
  [53.1597618, 31.7924812],
  [53.1588756, 31.7928234],
  [53.1588234, 31.7928435],
  [53.158617, 31.7928605],
  [53.1564016, 31.793043],
  [53.1536905, 31.7943692],
  [53.1529303, 31.7950425],
  [53.1496642, 31.7979352],
  [53.1458273, 31.7957556],
  [53.1416733, 31.7976631],
  [53.1415607, 31.7977148],
  [53.1401686, 31.79883],
  [53.1387764, 31.8000959],
  [53.1371671, 31.8012413],
  [53.1349246, 31.8048469],
  [53.1346176, 31.8053404],
  [53.1333879, 31.8065762],
  [53.1323029, 31.808234],
  [53.1286467, 31.8084262],
  [53.1281977, 31.8084498],
  [53.1268128, 31.8091697],
  [53.1255692, 31.8098161],
  [53.1241464, 31.8110217],
  [53.1242604, 31.8130119],
  [53.1244232, 31.8146745],
  [53.1225789, 31.8179339],
  [53.1202271, 31.8202497],
  [53.119926, 31.8205461],
  [53.1178036, 31.8230377],
  [53.1150057, 31.8253685],
  [53.1130036, 31.8260517],
  [53.1115897, 31.8284446],
  [53.1110658, 31.8295311],
  [53.1103793, 31.8309548],
  [53.1100937, 31.8479838],
  [53.1097247, 31.8512014],
  [53.1092554, 31.8571683],
  [53.1079831, 31.8644316],
  [53.1077361, 31.867271],
  [53.1070814, 31.8696784],
  [53.1101941, 31.8742051],
  [53.1097124, 31.8760157],
  [53.1149094, 31.8802104],
  [53.1134673, 31.8862851],
  [53.1145239, 31.8870946],
  [53.1117859, 31.8974117],
  [53.10654, 31.91743],
  [53.1049855, 31.9225449],
  [53.0888734, 31.9134806],
  [53.0863464, 31.921356],
  [53.084884, 31.928043],
  [53.0830637, 31.9346743],
  [53.0831704, 31.9352426],
  [53.0836432, 31.9377618],
  [53.0848634, 31.9442632],
  [53.0849934, 31.9464199],
  [53.0854195, 31.9534879],
  [53.0849458, 31.960072],
  [53.084987, 31.965353],
  [53.0854401, 31.9709769],
  [53.0853577, 31.9790699],
  [53.0849252, 31.9864427],
  [53.0853371, 31.9925811],
  [53.0932864, 31.9925857],
  [53.0944481, 31.9969687],
  [53.0967887, 32.0058001],
  [53.0986199, 32.0131008],
  [53.0987601, 32.0136597],
  [53.0991222, 32.0151032],
  [53.1001155, 32.0190637],
  [53.0986916, 32.0186125],
  [53.0950686, 32.0174538],
  [53.0908507, 32.0180363],
  [53.0891406, 32.0281171],
  [53.0885166, 32.0320744],
  [53.087166, 32.0367917],
  [53.0863655, 32.0415483],
  [53.0855373, 32.0443783],
  [53.0853317, 32.0452734],
  [53.0844814, 32.0498557],
  [53.0849085, 32.0510551],
  [53.0851824, 32.0519921],
  [53.08545, 32.056315],
  [53.0812457, 32.0637133],
  [53.0793606, 32.0683841],
  [53.0783157, 32.077361],
  [53.0773583, 32.0813276],
  [53.0761908, 32.0947528],
  [53.0769753, 32.1028964],
  [53.0777734, 32.10906],
  [53.0781333, 32.1113984],
  [53.0796726, 32.1207615],
  [53.0815951, 32.1307289],
  [53.0820692, 32.1369039],
  [53.0831605, 32.1428453],
  [53.083188, 32.1512582],
  [53.0859068, 32.1603112],
  [53.0869503, 32.1677182],
  [53.0886801, 32.1726891],
  [53.0906524, 32.1728622],
  [53.0915302, 32.1720732],
  [53.0941633, 32.1718775],
  [53.0953356, 32.1729649],
  [53.0961474, 32.1728148],
  [53.0969615, 32.1728606],
  [53.0977091, 32.1732157],
  [53.099553, 32.1742108],
  [53.1016857, 32.175536],
  [53.1046735, 32.1769166],
  [53.1078017, 32.1850057],
  [53.1088553, 32.1875689],
  [53.1083672, 32.191595],
  [53.1076187, 32.1977691],
  [53.1078811, 32.2027115],
  [53.1044084, 32.2121047],
  [53.1038354, 32.21911],
  [53.0989677, 32.2351012],
  [53.0991687, 32.236073],
  [53.1013737, 32.235574],
  [53.1033396, 32.2342934],
  [53.1036534, 32.2342675],
  [53.105655, 32.2344268],
  [53.106209, 32.23449],
  [53.1068172, 32.2349953],
  [53.108683, 32.2368984],
  [53.1098264, 32.2370822],
  [53.1100542, 32.2369741],
  [53.1106286, 32.2365592],
  [53.1117842, 32.2365243],
  [53.1146435, 32.2364385],
  [53.1165062, 32.2351184],
  [53.1186952, 32.2356541],
  [53.1208636, 32.2395997],
  [53.1223327, 32.2409597],
  [53.1237, 32.241248],
  [53.1249805, 32.2412015],
  [53.1271242, 32.2421541],
  [53.1273792, 32.2424544],
  [53.1279909, 32.2438308],
  [53.1291705, 32.245244],
  [53.1305975, 32.24889],
  [53.131443, 32.2547306],
  [53.1303395, 32.2591433],
  [53.1284649, 32.2615264],
  [53.1274831, 32.2664668],
  [53.1267131, 32.2716888],
  [53.1260983, 32.276399],
  [53.127147, 32.283209],
  [53.1263331, 32.2873969],
  [53.1276644, 32.3022191],
  [53.1316537, 32.3076892],
  [53.1346211, 32.3106014],
  [53.1401635, 32.3231488],
  [53.1419356, 32.3260146],
  [53.1443374, 32.3326213],
  [53.1511013, 32.3337691],
  [53.1553488, 32.3393904],
  [53.1574825, 32.3422956],
  [53.1588264, 32.3441254],
  [53.1638704, 32.3421011],
  [53.1648617, 32.3417032],
  [53.1717917, 32.3388948],
  [53.1762187, 32.3451062],
  [53.17651, 32.3455194],
  [53.1851246, 32.3577383],
  [53.1873546, 32.3689312],
  [53.1890413, 32.3775737],
  [53.1916322, 32.3787818],
  [53.1909676, 32.3857641],
  [53.1897499, 32.3925444],
  [53.1897286, 32.3926998],
  [53.1896264, 32.3934469],
  [53.1882783, 32.4016765],
  [53.187833, 32.4042602],
  [53.186095, 32.4143451],
  [53.1939473, 32.4225227],
  [53.1959329, 32.4265003],
  [53.1979988, 32.4312377],
  [53.2030324, 32.4311867],
  [53.2041754, 32.4311751],
  [53.2060537, 32.4332112],
  [53.2074684, 32.4357218],
  [53.2079076, 32.4407566],
  [53.2079908, 32.4468194],
  [53.2082543, 32.4483149],
  [53.2092472, 32.4493476],
  [53.2100706, 32.4497682],
  [53.2102272, 32.4498482],
  [53.2130389, 32.4512846],
  [53.2136714, 32.452247],
  [53.2145994, 32.453659],
  [53.2159788, 32.4534181],
  [53.2165826, 32.4533126],
  [53.2170891, 32.4532241],
  [53.2185737, 32.4540945],
  [53.2197725, 32.4545984],
  [53.2208373, 32.4550459],
  [53.2234374, 32.4596611],
  [53.2258284, 32.4632185],
  [53.228476, 32.4667724],
  [53.2308699, 32.4693883],
  [53.2325757, 32.4692944],
  [53.2343589, 32.4698886],
  [53.235598, 32.4712377],
  [53.2367501, 32.4733511],
  [53.2378653, 32.4757828],
  [53.2385532, 32.4770884],
  [53.2398397, 32.4788129],
  [53.2402453, 32.4789238],
  [53.2422809, 32.4811204],
  [53.2431598, 32.4821693],
  [53.2458035, 32.4838908],
  [53.2475715, 32.48511],
  [53.2488066, 32.4861804],
  [53.2495229, 32.4873775],
  [53.2502286, 32.4873247],
  [53.2515347, 32.4903351],
  [53.2536587, 32.4925703],
  [53.2561677, 32.4934202],
  [53.2575486, 32.4938208],
  [53.259832, 32.4937581],
  [53.2609818, 32.4946835],
  [53.262592, 32.4949284],
  [53.2652626, 32.4964648],
  [53.26884, 32.49893],
  [53.27202, 32.49927],
  [53.27511, 32.50048],
  [53.27519, 32.50056],
  [53.28163, 32.50949],
  [53.29468, 32.51009],
  [53.29785, 32.49421],
  [53.2988, 32.48588],
  [53.30352, 32.48846],
  [53.3048, 32.49421],
  [53.30463, 32.50279],
  [53.30524, 32.51103],
  [53.30712, 32.51584],
  [53.30669, 32.52254],
  [53.29656, 32.52193],
  [53.29803, 32.53687],
  [53.30068, 32.5396236],
  [53.3029762, 32.5421841],
  [53.3022464, 32.5484097],
  [53.30146, 32.55386],
  [53.3011242, 32.5584998],
  [53.2998616, 32.5623217],
  [53.2970657, 32.5707843],
  [53.2979372, 32.5733228],
  [53.2930129, 32.5787832],
  [53.2919513, 32.5805515],
  [53.2905245, 32.5833072],
  [53.292577, 32.5868143],
  [53.296495, 32.587053],
  [53.3010382, 32.5887056],
  [53.303562, 32.5928921],
  [53.30828, 32.5924147],
  [53.3117029, 32.5933328],
  [53.3147403, 32.5987774],
  [53.31519, 32.60794],
  [53.31605, 32.60991],
  [53.31691, 32.6118],
  [53.32051, 32.61558],
  [53.32446, 32.61523],
  [53.3255995, 32.6148066],
  [53.3303, 32.6124],
  [53.33373, 32.61017],
  [53.3365885, 32.6116652],
  [53.33914, 32.613],
  [53.34034, 32.61652],
  [53.33974, 32.6208587],
  [53.33485, 32.62321],
  [53.33047, 32.62673],
  [53.33253, 32.66244],
  [53.338708, 32.6752744],
  [53.34103, 32.67995],
  [53.3418, 32.6857],
  [53.33819, 32.68759],
  [53.3358528, 32.6877752],
  [53.3339, 32.68793],
  [53.33141, 32.69428],
  [53.33107, 32.70141],
  [53.33107, 32.70192],
  [53.33313, 32.7093],
  [53.3324539, 32.712303],
  [53.33141, 32.71694],
  [53.33141, 32.72389],
  [53.33253, 32.7335],
  [53.3391794, 32.735966],
  [53.3412008, 32.7367157],
  [53.34806, 32.73926],
  [53.35519, 32.73316],
  [53.36145, 32.72938],
  [53.3640594, 32.7282067],
  [53.3655242, 32.7275255],
  [53.36857, 32.72613],
  [53.3695345, 32.7255724],
  [53.3709856, 32.7247334],
  [53.3716855, 32.7243287],
  [53.37407, 32.72295],
  [53.37725, 32.72518],
  [53.38068, 32.72999],
  [53.38729, 32.74209],
  [53.39029, 32.74269],
  [53.3934126, 32.7390755],
  [53.39467, 32.73762],
  [53.39613, 32.73891],
  [53.3969, 32.7408],
  [53.3963, 32.74269],
  [53.39561, 32.74913],
  [53.39707, 32.75136],
  [53.39707, 32.75548],
  [53.39913, 32.75291],
  [53.40034, 32.74784],
  [53.40446, 32.74338],
  [53.4084, 32.73986],
  [53.41123, 32.73986],
  [53.4130167, 32.7415398],
  [53.41424, 32.74269],
  [53.41724, 32.74372],
  [53.4181516, 32.7415688],
  [53.41913, 32.73926],
  [53.42256, 32.73926],
  [53.4248, 32.74595],
  [53.4260562, 32.7484625],
  [53.42686, 32.75007],
  [53.42239, 32.7548745],
  [53.4225639, 32.7593377],
  [53.4242773, 32.7627809],
  [53.426855, 32.7625134],
  [53.4312376, 32.7564195],
  [53.43252, 32.75513],
  [53.43484, 32.75291],
  [53.44085, 32.75041],
  [53.44522, 32.74879],
  [53.44874, 32.75325],
  [53.454024, 32.75325],
  [53.45484, 32.75325],
  [53.45818, 32.75711],
  [53.46162, 32.74114],
  [53.4599, 32.73831],
  [53.46007, 32.72613],
  [53.46196, 32.7099],
  [53.46282, 32.70141],
  [53.46333, 32.69651],
  [53.46385, 32.68922],
  [53.46256, 32.68407],
  [53.46368, 32.67514],
  [53.4685553, 32.6599708],
  [53.469859, 32.6559142],
  [53.4735081, 32.6589913],
  [53.4789568, 32.6603752],
  [53.4790624, 32.6617591],
  [53.477204, 32.66694],
  [53.4779642, 32.6708433],
  [53.4774574, 32.6741079],
  [53.4799493, 32.676379],
  [53.4813904, 32.6870468],
  [53.484806, 32.6802113],
  [53.4891977, 32.6731853],
  [53.4950477, 32.6540733],
  [53.5041217, 32.6470684],
  [53.5025233, 32.6384236],
  [53.5011011, 32.6381806],
  [53.48986, 32.63626],
  [53.4862418, 32.6369906],
  [53.4806276, 32.633956],
  [53.47715, 32.62759],
  [53.4769, 32.62733],
  [53.475, 32.6251],
  [53.47878, 32.61746],
  [53.47878, 32.615414],
  [53.47878, 32.6051],
  [53.4788138, 32.6042425],
  [53.4914486, 32.6098359],
  [53.4939722, 32.6064904],
  [53.4933557, 32.6033878],
  [53.4956043, 32.603029],
  [53.4973825, 32.6029268],
  [53.4996377, 32.6040985],
  [53.5030334, 32.6051924],
  [53.5043144, 32.6036199],
  [53.506218, 32.6035646],
  [53.5128687, 32.603302],
  [53.51801, 32.58819],
  [53.5155513, 32.5828885],
  [53.51707, 32.57858],
  [53.518719, 32.5724035],
  [53.5192596, 32.5676778],
  [53.5183102, 32.5663294],
  [53.5183966, 32.5647766],
  [53.5186283, 32.5606136],
  [53.5186218, 32.5580774],
  [53.5185422, 32.5560033],
  [53.5178343, 32.5528664],
  [53.5173818, 32.5484095],
  [53.5174029, 32.5450029],
  [53.5167911, 32.5423076],
  [53.5171333, 32.5420086],
  [53.5171188, 32.5417891],
  [53.5173122, 32.5415126],
  [53.5174089, 32.5412199],
  [53.5175587, 32.5412362],
  [53.517757, 32.5415126],
  [53.517931, 32.5418785],
  [53.5181582, 32.5420005],
  [53.5185401, 32.5420249],
  [53.5187722, 32.5416752],
  [53.5190961, 32.5414313],
  [53.519449, 32.5415207],
  [53.5198841, 32.5418216],
  [53.5200339, 32.5419598],
  [53.5199952, 32.5423582],
  [53.5201789, 32.5425778],
  [53.5204351, 32.5426428],
  [53.5204545, 32.5429681],
  [53.5204158, 32.5435941],
  [53.5205077, 32.5442853],
  [53.5206527, 32.544643],
  [53.5212134, 32.5446268],
  [53.5216533, 32.5442365],
  [53.5221222, 32.5437812],
  [53.5224219, 32.5437324],
  [53.5227506, 32.5439031],
  [53.5228521, 32.5442202],
  [53.522828, 32.544765],
  [53.5229343, 32.5449683],
  [53.5231663, 32.544952],
  [53.5233935, 32.5452041],
  [53.5235471, 32.5454644],
  [53.5237413, 32.545754],
  [53.5237559, 32.5460806],
  [53.5236607, 32.5463086],
  [53.5235471, 32.5467769],
  [53.5234958, 32.5470604],
  [53.5236497, 32.5472822],
  [53.5238036, 32.5476766],
  [53.5239684, 32.5482189],
  [53.5241955, 32.5486132],
  [53.5243824, 32.5488782],
  [53.5246461, 32.5490754],
  [53.524745, 32.5492418],
  [53.524734, 32.5495129],
  [53.5248476, 32.5500921],
  [53.5249721, 32.5504742],
  [53.5251736, 32.550733],
  [53.5254117, 32.5510349],
  [53.5256132, 32.5510596],
  [53.5256352, 32.5508193],
  [53.5256681, 32.5506282],
  [53.5257634, 32.5506036],
  [53.5259172, 32.5506467],
  [53.526126, 32.5508193],
  [53.5262726, 32.5510288],
  [53.5262542, 32.5515649],
  [53.5262652, 32.5518052],
  [53.5263971, 32.5518607],
  [53.526474, 32.5516327],
  [53.5265107, 32.5514047],
  [53.5266323, 32.5514153],
  [53.5267249, 32.5509355],
  [53.5270307, 32.5512994],
  [53.5271948, 32.5511739],
  [53.5270531, 32.5504839],
  [53.5271276, 32.5499444],
  [53.5268988, 32.5497438],
  [53.5268488, 32.5495803],
  [53.5270555, 32.5493765],
  [53.5272021, 32.5495344],
  [53.5272768, 32.5494175],
  [53.5271649, 32.5486146],
  [53.5274194, 32.5487546],
  [53.5275619, 32.5486879],
  [53.5276953, 32.5483707],
  [53.5278138, 32.5477991],
  [53.5276199, 32.5471969],
  [53.5279704, 32.5467954],
  [53.5278436, 32.5456036],
  [53.5279331, 32.5440981],
  [53.5285148, 32.5440604],
  [53.528992, 32.5442612],
  [53.5294742, 32.5440201],
  [53.5308324, 32.5412514],
  [53.5311009, 32.5410758],
  [53.5313246, 32.5402728],
  [53.5318913, 32.538115],
  [53.5327501, 32.5339638],
  [53.533666, 32.5324191],
  [53.5336068, 32.530563],
  [53.5340172, 32.5301211],
  [53.5342709, 32.5289031],
  [53.5343266, 32.5282368],
  [53.5346855, 32.5283826],
  [53.5348525, 32.5270292],
  [53.5349425, 32.5266916],
  [53.5351787, 32.5265517],
  [53.5357063, 32.5270917],
  [53.5358053, 32.5269251],
  [53.5357409, 32.5264707],
  [53.535789, 32.5263124],
  [53.5359028, 32.5262352],
  [53.535975, 32.5263345],
  [53.5359684, 32.5265222],
  [53.5360405, 32.5267481],
  [53.5362369, 32.5265257],
  [53.5363862, 32.5263672],
  [53.5368062, 32.5264555],
  [53.5371212, 32.5260433],
  [53.5371256, 32.5253366],
  [53.5371956, 32.5250716],
  [53.5373749, 32.5251894],
  [53.5374843, 32.5254912],
  [53.5375805, 32.5255133],
  [53.5379611, 32.5252851],
  [53.5382411, 32.525447],
  [53.5383724, 32.5252409],
  [53.538438, 32.5244459],
  [53.5385299, 32.5242545],
  [53.5387792, 32.5241809],
  [53.5390461, 32.5244827],
  [53.5391686, 32.5242803],
  [53.5391161, 32.5239858],
  [53.5392473, 32.5237024],
  [53.5393348, 32.5241294],
  [53.5394988, 32.5240042],
  [53.5397722, 32.5232828],
  [53.5402731, 32.5235957],
  [53.5403645, 32.5235323],
  [53.5405434, 32.5231161],
  [53.540729, 32.5231526],
  [53.5408218, 32.5234909],
  [53.5410661, 32.5234805],
  [53.5411991, 32.5230693],
  [53.5410568, 32.52258],
  [53.5411218, 32.5223353],
  [53.5413307, 32.5223998],
  [53.541725, 32.5226945],
  [53.5418644, 32.522471],
  [53.54185, 32.5221735],
  [53.5417314, 32.5219917],
  [53.5416918, 32.5217388],
  [53.5419976, 32.5215215],
  [53.5420371, 32.5207737],
  [53.5422005, 32.5204924],
  [53.5425195, 32.5205324],
  [53.5426539, 32.52059],
  [53.5426961, 32.5204303],
  [53.542675, 32.5202751],
  [53.5425696, 32.5201838],
  [53.5426328, 32.5193632],
  [53.5427883, 32.5192372],
  [53.5428252, 32.5194146],
  [53.542928, 32.5195077],
  [53.5430223, 32.5192485],
  [53.5429201, 32.5186871],
  [53.5430598, 32.5183873],
  [53.5433234, 32.5185825],
  [53.5434473, 32.5185629],
  [53.5434815, 32.5182898],
  [53.5431441, 32.5177575],
  [53.543102, 32.517447],
  [53.5434446, 32.5174736],
  [53.5435273, 32.5170146],
  [53.5434552, 32.5166752],
  [53.5431863, 32.5168792],
  [53.5428839, 32.5163676],
  [53.5431216, 32.5148165],
  [53.543664, 32.5128142],
  [53.5449762, 32.5123431],
  [53.5448713, 32.5109297],
  [53.5453437, 32.5073668],
  [53.5493089, 32.4942368],
  [53.5489851, 32.4922526],
  [53.5492761, 32.48842],
  [53.5493343, 32.4860691],
  [53.5490656, 32.4825381],
  [53.5485721, 32.4794291],
  [53.5488798, 32.4779157],
  [53.5540493, 32.475279],
  [53.559309, 32.4755325],
  [53.5640051, 32.4806455],
  [53.5658278, 32.481899],
  [53.5673681, 32.4818125],
  [53.5688056, 32.4783978],
  [53.5702431, 32.4742482],
  [53.5715265, 32.4677644],
  [53.5737443, 32.461703],
  [53.5750171, 32.4591627],
  [53.576711, 32.457693],
  [53.5779686, 32.4563531],
  [53.5795854, 32.4570879],
  [53.5816079, 32.4557682],
  [53.5824339, 32.4552292],
  [53.58555, 32.44804],
  [53.5861419, 32.4503197],
  [53.58873, 32.4464],
  [53.59363, 32.44263],
  [53.5940859, 32.4381134],
  [53.5997974, 32.4307592],
  [53.60744, 32.4258],
  [53.6108412, 32.4323583],
  [53.6122566, 32.4348625],
  [53.6142609, 32.4381547],
  [53.6192, 32.43816],
  [53.6226984, 32.440565],
  [53.6253498, 32.4407456],
  [53.6279835, 32.441092],
  [53.6307472, 32.4401227],
  [53.6373457, 32.4497967],
  [53.6407597, 32.4427589],
  [53.6431639, 32.4376836],
  [53.6499332, 32.433737],
  [53.6519486, 32.4319136],
  [53.651306, 32.430041],
  [53.6499917, 32.4295482],
  [53.647246, 32.4306324],
  [53.6448798, 32.4289569],
  [53.6433528, 32.4314327],
  [53.6414707, 32.4300543],
  [53.6403152, 32.4338551],
  [53.6388617, 32.4327832],
  [53.6390651, 32.4293384],
  [53.6338551, 32.4298535],
  [53.6332518, 32.4308049],
  [53.6309055, 32.4321326],
  [53.6349761, 32.4183583],
  [53.6397344, 32.4195275],
  [53.6409229, 32.4168934],
  [53.6449687, 32.4192219],
  [53.6476626, 32.4210639],
  [53.6494631, 32.4195669],
  [53.6508971, 32.4167849],
  [53.6506627, 32.4138982],
  [53.6552581, 32.4143676],
  [53.6629829, 32.4148683],
  [53.6649624, 32.4149966],
  [53.66469, 32.41868],
  [53.6643439, 32.4258141],
  [53.6652426, 32.4260396],
  [53.665373, 32.4260723],
  [53.6654358, 32.4260881],
  [53.6700488, 32.4272454],
  [53.6707596, 32.4274237],
  [53.67066, 32.4277179],
  [53.6706711, 32.4279701],
  [53.6707458, 32.428199],
  [53.6708315, 32.4284044],
  [53.6709505, 32.4285585],
  [53.6710916, 32.4287033],
  [53.6711856, 32.428708],
  [53.6712465, 32.4287313],
  [53.6712935, 32.4288854],
  [53.6712935, 32.4292871],
  [53.6712576, 32.4293898],
  [53.6711967, 32.4297821],
  [53.6712271, 32.4300529],
  [53.6712133, 32.4303005],
  [53.6710943, 32.4304686],
  [53.6709892, 32.4305106],
  [53.670862, 32.4305386],
  [53.6707707, 32.4306834],
  [53.6707292, 32.4308842],
  [53.6706711, 32.4311551],
  [53.6705438, 32.4313979],
  [53.6704221, 32.431552],
  [53.6704442, 32.4319069],
  [53.6704193, 32.4324066],
  [53.6704276, 32.4327429],
  [53.6705521, 32.432981],
  [53.6705964, 32.4331912],
  [53.670577, 32.4334153],
  [53.6704746, 32.4336348],
  [53.6703916, 32.4339244],
  [53.6704276, 32.434284],
  [53.6705383, 32.4347229],
  [53.6706185, 32.4351012],
  [53.67079, 32.4354468],
  [53.6709975, 32.435797],
  [53.6711275, 32.4360025],
  [53.6712244, 32.4360866],
  [53.671418, 32.4362173],
  [53.6715757, 32.4362921],
  [53.671703, 32.4363201],
  [53.6717722, 32.436278],
  [53.6718662, 32.4361333],
  [53.671869, 32.4359138],
  [53.6719299, 32.435769],
  [53.6720267, 32.4356009],
  [53.6721207, 32.4356196],
  [53.6721595, 32.4357597],
  [53.6722231, 32.4359605],
  [53.672284, 32.4361846],
  [53.6723061, 32.4363808],
  [53.6723393, 32.4364929],
  [53.67245, 32.4367124],
  [53.6725219, 32.4370953],
  [53.6725302, 32.4373942],
  [53.6723974, 32.4376604],
  [53.6722729, 32.4379639],
  [53.6721595, 32.4384076],
  [53.6721097, 32.4387018],
  [53.6720405, 32.43908],
  [53.6720239, 32.4393556],
  [53.6719326, 32.4395797],
  [53.671739, 32.4399954],
  [53.6716006, 32.4403503],
  [53.6715204, 32.440836],
  [53.6715259, 32.4410975],
  [53.6715453, 32.441387],
  [53.6714678, 32.44184],
  [53.6712825, 32.442279],
  [53.6711109, 32.4425405],
  [53.6707928, 32.4428254],
  [53.6704553, 32.4430169],
  [53.6702284, 32.4431103],
  [53.6700126, 32.4434138],
  [53.6698632, 32.4436707],
  [53.6697885, 32.4439602],
  [53.6696723, 32.444586],
  [53.6696557, 32.4448989],
  [53.6696585, 32.4452538],
  [53.669664, 32.4455667],
  [53.6697249, 32.445973],
  [53.669866, 32.4462765],
  [53.6700292, 32.4463279],
  [53.6702312, 32.4463512],
  [53.6703944, 32.4462532],
  [53.6705023, 32.4461084],
  [53.6705908, 32.4461271],
  [53.6706849, 32.4462065],
  [53.6707707, 32.4463606],
  [53.6707541, 32.4467015],
  [53.6706628, 32.4471405],
  [53.6705549, 32.4475001],
  [53.6704193, 32.4476728],
  [53.6702505, 32.4476448],
  [53.6700624, 32.4475234],
  [53.669877, 32.4474113],
  [53.6697387, 32.4474113],
  [53.6695589, 32.4476075],
  [53.6694648, 32.4479577],
  [53.6693873, 32.4485181],
  [53.6693624, 32.4490925],
  [53.6692905, 32.4493681],
  [53.6691577, 32.4495642],
  [53.6690027, 32.4496202],
  [53.6688782, 32.4495595],
  [53.6687122, 32.4494428],
  [53.6685628, 32.4494054],
  [53.6684079, 32.4494568],
  [53.6683, 32.4496156],
  [53.6681976, 32.4500218],
  [53.6680925, 32.4504982],
  [53.6680482, 32.4508438],
  [53.6681008, 32.4511286],
  [53.6682253, 32.451194],
  [53.6683221, 32.4512874],
  [53.6684743, 32.4513435],
  [53.6686486, 32.4513902],
  [53.6687399, 32.4515116],
  [53.6688865, 32.4514976],
  [53.6690276, 32.451675],
  [53.6691577, 32.4521],
  [53.6692158, 32.4524596],
  [53.6691964, 32.4527024],
  [53.6690636, 32.4530807],
  [53.6689861, 32.4533142],
  [53.6687316, 32.453487],
  [53.6683747, 32.4535524],
  [53.6681312, 32.4535524],
  [53.6679403, 32.4536037],
  [53.6678628, 32.4537392],
  [53.6677051, 32.4540287],
  [53.6676443, 32.4542902],
  [53.6676941, 32.4545844],
  [53.6677964, 32.4548506],
  [53.6679071, 32.454902],
  [53.6680786, 32.4549113],
  [53.6682585, 32.4550468],
  [53.6684383, 32.4552055],
  [53.6686071, 32.4552336],
  [53.6686652, 32.4551028],
  [53.6688201, 32.4548786],
  [53.668964, 32.4547572],
  [53.6690774, 32.4548366],
  [53.6693652, 32.4550888],
  [53.6697166, 32.4554297],
  [53.6700015, 32.4557706],
  [53.670162, 32.4560835],
  [53.6702976, 32.4564711],
  [53.6704027, 32.4570642],
  [53.6706268, 32.4584185],
  [53.6707983, 32.4593899],
  [53.6709311, 32.4601557],
  [53.6711552, 32.4608516],
  [53.671418, 32.4613373],
  [53.6715481, 32.4618136],
  [53.6718303, 32.4624674],
  [53.6721567, 32.4630091],
  [53.6724361, 32.463322],
  [53.6726298, 32.4636676],
  [53.6729701, 32.464228],
  [53.673208, 32.4646109],
  [53.67367, 32.465162],
  [53.6739162, 32.4654282],
  [53.6740517, 32.4656103],
  [53.6741486, 32.465685],
  [53.674439, 32.4656804],
  [53.6747046, 32.4657738],
  [53.6748125, 32.4658578],
  [53.6749427, 32.4661782],
  [53.6749454, 32.4663463],
  [53.6749454, 32.4665611],
  [53.6749012, 32.4667526],
  [53.6747601, 32.4669254],
  [53.6746384, 32.4670281],
  [53.6744973, 32.4670655],
  [53.6744558, 32.4672056],
  [53.6744254, 32.4673597],
  [53.6744254, 32.4675698],
  [53.6744835, 32.467808],
  [53.6745747, 32.4679387],
  [53.6746771, 32.4679995],
  [53.674868, 32.4680041],
  [53.6750229, 32.4678967],
  [53.6751833, 32.4676539],
  [53.6752829, 32.4674391],
  [53.6753493, 32.4672616],
  [53.6754793, 32.4671495],
  [53.6756121, 32.4670561],
  [53.6757172, 32.4670888],
  [53.6758694, 32.4671448],
  [53.675969, 32.4672102],
  [53.676063, 32.4673316],
  [53.6762179, 32.4674344],
  [53.6763479, 32.4674717],
  [53.6765029, 32.4675558],
  [53.6765775, 32.4677893],
  [53.6765554, 32.4680462],
  [53.6765056, 32.468233],
  [53.6764918, 32.4683544],
  [53.676572, 32.4686066],
  [53.6766965, 32.468826],
  [53.6768044, 32.4689568],
  [53.6768929, 32.4692137],
  [53.6769095, 32.4694378],
  [53.6769012, 32.4698021],
  [53.6769621, 32.4700636],
  [53.6770755, 32.4702691],
  [53.6771612, 32.4703765],
  [53.677247, 32.4703345],
  [53.677341, 32.4702037],
  [53.6774489, 32.4701196],
  [53.677601, 32.4699609],
  [53.6776398, 32.4697927],
  [53.6776398, 32.4696246],
  [53.6776287, 32.4694472],
  [53.6777338, 32.4693724],
  [53.6778057, 32.4694518],
  [53.6779053, 32.4696433],
  [53.6779994, 32.4698301],
  [53.6780326, 32.4699795],
  [53.6779938, 32.4701196],
  [53.6779219, 32.4702084],
  [53.6778749, 32.4703345],
  [53.6779247, 32.4704932],
  [53.6779911, 32.47061],
  [53.6780298, 32.47068],
  [53.6780104, 32.4708482],
  [53.6780049, 32.471063],
  [53.6779219, 32.4712778],
  [53.677897, 32.4715253],
  [53.6779136, 32.4716981],
  [53.6779828, 32.4717681],
  [53.6781155, 32.4717588],
  [53.6782234, 32.4716888],
  [53.6782428, 32.4717448],
  [53.6782456, 32.4719176],
  [53.678229, 32.4720437],
  [53.6782677, 32.4721277],
  [53.6783341, 32.4721978],
  [53.6784447, 32.4722772],
  [53.6784834, 32.4723239],
  [53.6784834, 32.4723846],
  [53.6784447, 32.472464],
  [53.6783756, 32.4724827],
  [53.6782428, 32.4724733],
  [53.67811, 32.4724967],
  [53.6780298, 32.4725387],
  [53.6779496, 32.4727021],
  [53.6779136, 32.4729543],
  [53.6778638, 32.4730197],
  [53.6777974, 32.4730057],
  [53.67772, 32.4730197],
  [53.6776813, 32.4731365],
  [53.6777089, 32.4733092],
  [53.6778279, 32.4735708],
  [53.6779109, 32.4737762],
  [53.6778943, 32.473893],
  [53.6778085, 32.4739864],
  [53.6778251, 32.4740985],
  [53.6780381, 32.4742106],
  [53.6781736, 32.4742199],
  [53.6782926, 32.4742713],
  [53.6783866, 32.474402],
  [53.6784309, 32.4746635],
  [53.6784945, 32.4750185],
  [53.6785277, 32.4753734],
  [53.6784641, 32.4755041],
  [53.6784032, 32.4756162],
  [53.6784115, 32.475817],
  [53.6785249, 32.4759758],
  [53.6786881, 32.4761346],
  [53.6787766, 32.4763541],
  [53.6788486, 32.4765129],
  [53.6789564, 32.4765969],
  [53.679056, 32.4767417],
  [53.6791418, 32.4771013],
  [53.6792275, 32.4775543],
  [53.6792911, 32.4779512],
  [53.6792939, 32.4781474],
  [53.6792082, 32.4782781],
  [53.6791058, 32.4783435],
  [53.6790035, 32.4783855],
  [53.6790035, 32.478563],
  [53.679056, 32.4788432],
  [53.6791639, 32.4791094],
  [53.6792773, 32.4792635],
  [53.6794018, 32.4793055],
  [53.6794931, 32.4795297],
  [53.679612, 32.4799079],
  [53.6798499, 32.4801881],
  [53.6800629, 32.4802489],
  [53.6802565, 32.4802022],
  [53.6803339, 32.4803189],
  [53.6803505, 32.4805617],
  [53.6803422, 32.4809634],
  [53.6802427, 32.4815284],
  [53.6801541, 32.481888],
  [53.680132, 32.4823223],
  [53.6801873, 32.4825698],
  [53.6802952, 32.482808],
  [53.6803505, 32.4830835],
  [53.6804363, 32.4831723],
  [53.6804971, 32.4833077],
  [53.6805137, 32.4835926],
  [53.6804916, 32.4840175],
  [53.680558, 32.484195],
  [53.6807212, 32.4842931],
  [53.6809535, 32.4844425],
  [53.6810005, 32.4845499],
  [53.6810337, 32.484704],
  [53.681031, 32.4848908],
  [53.6813103, 32.4849656],
  [53.6815786, 32.4849609],
  [53.6818524, 32.4848955],
  [53.6819658, 32.4848628],
  [53.6821097, 32.4849609],
  [53.6822922, 32.4852738],
  [53.6823254, 32.4854933],
  [53.6823199, 32.4857968],
  [53.6823141, 32.4859983],
  [53.6820148, 32.4862191],
  [53.6806095, 32.4872562],
  [53.6772566, 32.4893427],
  [53.6811348, 32.4989513],
  [53.6835261, 32.497178],
  [53.683783, 32.4970227],
  [53.6838425, 32.4970866],
  [53.6839453, 32.4971369],
  [53.6841481, 32.4970592],
  [53.6843049, 32.4970775],
  [53.6843482, 32.4971551],
  [53.684386, 32.4973834],
  [53.6844239, 32.4975021],
  [53.6845321, 32.4975478],
  [53.6846159, 32.4974884],
  [53.6846862, 32.4974976],
  [53.6847078, 32.4976482],
  [53.6847376, 32.4979085],
  [53.6847565, 32.4981048],
  [53.6846402, 32.4983011],
  [53.6846835, 32.4984838],
  [53.6847646, 32.4986664],
  [53.6848565, 32.4987166],
  [53.6850431, 32.4987623],
  [53.6852594, 32.4989952],
  [53.6855352, 32.4992965],
  [53.6859138, 32.4993787],
  [53.6861788, 32.4994609],
  [53.6861544, 32.4997577],
  [53.6861058, 32.4999449],
  [53.6861409, 32.5001001],
  [53.6863437, 32.5002508],
  [53.6864708, 32.5002416],
  [53.6866547, 32.4999586],
  [53.6868629, 32.5000544],
  [53.6869115, 32.5003695],
  [53.6869283, 32.500819],
  [53.6869575, 32.5008489],
  [53.6870544, 32.5009931],
  [53.6870862, 32.5010832],
  [53.6870738, 32.5013601],
  [53.6871408, 32.5014101],
  [53.6872229, 32.5014162],
  [53.6873216, 32.5012916],
  [53.6875245, 32.5013403],
  [53.6875615, 32.5012442],
  [53.6876144, 32.5012143],
  [53.6877799, 32.5012157],
  [53.6880493, 32.5009854],
  [53.6881135, 32.5009525],
  [53.6882386, 32.5007982],
  [53.6883585, 32.5008374],
  [53.6885407, 32.500966],
  [53.6886227, 32.5010893],
  [53.6886804, 32.5012122],
  [53.6887575, 32.5012556],
  [53.6889151, 32.5011368],
  [53.6889261, 32.5010502],
  [53.6889204, 32.5008982],
  [53.6889366, 32.5007426],
  [53.6889958, 32.500457],
  [53.6891166, 32.5002208],
  [53.6891822, 32.500022],
  [53.6892383, 32.4999575],
  [53.6893497, 32.499865],
  [53.6895449, 32.4998482],
  [53.6895895, 32.4997584],
  [53.6899542, 32.4995974],
  [53.690115, 32.4996979],
  [53.6901948, 32.4996632],
  [53.6903853, 32.4996659],
  [53.6904479, 32.4996336],
  [53.6906156, 32.4994238],
  [53.6907388, 32.4992997],
  [53.6909883, 32.499377],
  [53.6912076, 32.4996506],
  [53.6912775, 32.4998029],
  [53.6913709, 32.4997998],
  [53.6914587, 32.4996659],
  [53.6915659, 32.4996057],
  [53.6917837, 32.4996108],
  [53.6917998, 32.4998076],
  [53.6919146, 32.4999004],
  [53.6920857, 32.5000997],
  [53.6920505, 32.5002662],
  [53.6920042, 32.50033],
  [53.6920348, 32.5004786],
  [53.6921562, 32.5005197],
  [53.692392, 32.5003832],
  [53.6926156, 32.50022],
  [53.6927915, 32.500054],
  [53.6929845, 32.5001474],
  [53.6931943, 32.5002549],
  [53.6933254, 32.500266],
  [53.6934985, 32.5002063],
  [53.6936132, 32.5000033],
  [53.6938295, 32.4999325],
  [53.694005, 32.4998553],
  [53.6941093, 32.4993816],
  [53.6942356, 32.4992824],
  [53.6945001, 32.4990769],
  [53.6946009, 32.4989074],
  [53.6946683, 32.4985822],
  [53.6950299, 32.4983587],
  [53.6953327, 32.4982277],
  [53.695522, 32.498319],
  [53.6957677, 32.4988189],
  [53.6959077, 32.4994728],
  [53.6959232, 32.4997136],
  [53.6959639, 32.4998837],
  [53.6961857, 32.5000968],
  [53.6967668, 32.5004455],
  [53.6969732, 32.5006069],
  [53.697074, 32.5008187],
  [53.6971243, 32.5010632],
  [53.6971829, 32.5011945],
  [53.6972836, 32.5011553],
  [53.6974429, 32.5008329],
  [53.6974544, 32.5004584],
  [53.6976685, 32.5001743],
  [53.6979819, 32.5001613],
  [53.6981348, 32.50051],
  [53.6981425, 32.5007296],
  [53.6980584, 32.5009879],
  [53.6981387, 32.5011557],
  [53.6983107, 32.5013043],
  [53.6985324, 32.5014463],
  [53.6987465, 32.5014786],
  [53.6988421, 32.501414],
  [53.698972, 32.5013365],
  [53.6991097, 32.5014011],
  [53.6992893, 32.5014205],
  [53.6993574, 32.5014285],
  [53.699511, 32.5012978],
  [53.6997226, 32.5012308],
  [53.699928, 32.5012292],
  [53.700104, 32.5012842],
  [53.7003864, 32.5011945],
  [53.7007902, 32.5010382],
  [53.7009745, 32.5007935],
  [53.7013727, 32.5006069],
  [53.7015103, 32.5002259],
  [53.7017588, 32.5001936],
  [53.7018849, 32.5002969],
  [53.7021295, 32.5002195],
  [53.702271, 32.4998902],
  [53.7024124, 32.499832],
  [53.7024774, 32.4999935],
  [53.7026417, 32.5004907],
  [53.702722, 32.5007167],
  [53.7027435, 32.5009627],
  [53.7028067, 32.5010578],
  [53.7028698, 32.5010172],
  [53.7029175, 32.5008845],
  [53.7029326, 32.5007767],
  [53.702862, 32.5006042],
  [53.7028486, 32.5004424],
  [53.7028765, 32.5002057],
  [53.7029587, 32.4998634],
  [53.7030334, 32.4997426],
  [53.7031086, 32.4997546],
  [53.7032371, 32.49993],
  [53.7033022, 32.5001377],
  [53.7033633, 32.5002195],
  [53.7034297, 32.5001613],
  [53.7035962, 32.5000127],
  [53.7037691, 32.4997354],
  [53.7038665, 32.4993016],
  [53.7040069, 32.4991605],
  [53.704305, 32.4993348],
  [53.7045631, 32.4994576],
  [53.7048898, 32.4995092],
  [53.7050083, 32.4994317],
  [53.7051897, 32.4991856],
  [53.7052567, 32.4991218],
  [53.7053388, 32.4991514],
  [53.7054463, 32.4992562],
  [53.7055279, 32.4994764],
  [53.7055872, 32.4994759],
  [53.7057613, 32.499393],
  [53.7060415, 32.4992015],
  [53.7063237, 32.4993091],
  [53.7064404, 32.4994436],
  [53.7065625, 32.4998417],
  [53.7067015, 32.5001599],
  [53.706885, 32.5002259],
  [53.7076188, 32.5003486],
  [53.7079475, 32.5002517],
  [53.7080163, 32.4999935],
  [53.7078863, 32.4997546],
  [53.7076455, 32.4995996],
  [53.7074544, 32.4994511],
  [53.7073003, 32.4994231],
  [53.7071589, 32.4993521],
  [53.7071123, 32.4991016],
  [53.7072174, 32.4986365],
  [53.7072825, 32.4983469],
  [53.7073906, 32.498131],
  [53.7123301, 32.4916401],
  [53.71902, 32.48116],
  [53.71911, 32.48005],
  [53.719552, 32.4747752],
  [53.71988, 32.47086],
  [53.721, 32.46254],
  [53.72692, 32.45876],
  [53.7294586, 32.4601316],
  [53.7376525, 32.4606829],
  [53.7365707, 32.4461669],
  [53.7331902, 32.4396518],
  [53.7325817, 32.433594],
  [53.7289, 32.42297],
  [53.72829, 32.41421],
  [53.7315123, 32.4130706],
  [53.729842, 32.3951153],
  [53.7273889, 32.3897474],
  [53.7201529, 32.3761477],
  [53.7181831, 32.3724093],
  [53.7173989, 32.3691746],
  [53.7178468, 32.367613],
  [53.7207306, 32.3583613],
  [53.7293713, 32.3545473],
  [53.7402414, 32.3558739],
  [53.7415073, 32.3506264],
  [53.7452887, 32.3470613],
  [53.7459277, 32.3481907],
  [53.7512853, 32.3414009],
  [53.7504294, 32.3380474],
  [53.7517317, 32.3339389],
  [53.7594658, 32.3315046],
  [53.7585001, 32.3153395],
  [53.7570725, 32.309115],
  [53.7577244, 32.3093421],
  [53.7597061, 32.3100327],
  [53.7608385, 32.3055418],
  [53.7597318, 32.2952846],
  [53.7617459, 32.288174],
  [53.7612024, 32.2869102],
  [53.7625452, 32.2835937],
  [53.7584989, 32.2723561],
  [53.7627298, 32.2684226],
  [53.76881, 32.28641],
  [53.7699687, 32.2906956],
  [53.7736942, 32.2869856],
  [53.7759304, 32.2848442],
  [53.7725819, 32.2614218],
  [53.7659826, 32.2569248],
  [53.7655741, 32.2512315],
  [53.7656563, 32.2453698],
  [53.7660412, 32.2398839],
  [53.7661262, 32.229368],
  [53.7696072, 32.2217216],
  [53.7710494, 32.2194875],
  [53.77959, 32.2162487],
  [53.7818002, 32.2190741],
  [53.7816761, 32.224226],
  [53.783885, 32.2235143],
  [53.7850868, 32.2204674],
  [53.7995665, 32.2080495],
  [53.7987668, 32.2053129],
  [53.7974227, 32.2035318],
  [53.7969555, 32.2018107],
  [53.7952293, 32.2003573],
  [53.7943775, 32.1997458],
  [53.79438, 32.197547],
  [53.7952849, 32.1970442],
  [53.7954589, 32.1963057],
  [53.7956671, 32.1956353],
  [53.7957986, 32.1950449],
  [53.795956, 32.194994],
  [53.7961562, 32.1945471],
  [53.7962748, 32.1939682],
  [53.7962639, 32.1932272],
  [53.7960864, 32.1927124],
  [53.7956832, 32.1922222],
  [53.7955289, 32.1912566],
  [53.7956239, 32.1905513],
  [53.7958773, 32.1900479],
  [53.7966665, 32.1893279],
  [53.7969752, 32.1891131],
  [53.7973276, 32.1891327],
  [53.7975371, 32.1892525],
  [53.7977467, 32.1895695],
  [53.7983199, 32.1861266],
  [53.7946373, 32.1801652],
  [53.7927188, 32.1774221],
  [53.795621, 32.1763175],
  [53.7995665, 32.1750171],
  [53.8011445, 32.148861],
  [53.805206, 32.1522678],
  [53.8056814, 32.1470392],
  [53.8051846, 32.1407221],
  [53.8126529, 32.1418916],
  [53.8131598, 32.1316285],
  [53.8143637, 32.13284],
  [53.818147, 32.1265321],
  [53.8210624, 32.1185282],
  [53.8206645, 32.1131215],
  [53.8147799, 32.1043741],
  [53.8145905, 32.1001084],
  [53.8059406, 32.0953542],
  [53.8088511, 32.0898952],
  [53.80657, 32.0881955],
  [53.802843, 32.0830474],
  [53.80348, 32.0805],
  [53.80443, 32.07493],
  [53.80494, 32.06909],
  [53.80417, 32.06411],
  [53.80606, 32.05364],
  [53.8065279, 32.0493155],
  [53.8056755, 32.0428261],
  [53.801149, 32.048907],
  [53.7988804, 32.0496362],
  [53.7984979, 32.0483288],
  [53.79928, 32.04068],
  [53.79962, 32.03733],
  [53.8001085, 32.0340766],
  [53.8026188, 32.0243545],
  [53.8009567, 32.0207392],
  [53.80116, 32.01733],
  [53.80099, 32.0111403],
  [53.8036107, 32.0102518],
  [53.8037782, 32.0023689],
  [53.8046628, 32.0016184],
  [53.8033578, 31.9930574],
  [53.804133, 31.9896938],
  [53.8019672, 31.9852317],
  [53.8025575, 31.9836083],
  [53.8003805, 31.9822614],
  [53.7991789, 31.980319],
  [53.797144, 31.9795676],
  [53.7966834, 31.9777244],
  [53.7953603, 31.9775543],
  [53.7927453, 31.9773648],
  [53.7928144, 31.972351],
  [53.7924794, 31.9687356],
  [53.7912455, 31.9685332],
  [53.7899507, 31.9687772],
  [53.7905167, 31.9725011],
  [53.7900218, 31.9730771],
  [53.7898778, 31.9725869],
  [53.7894621, 31.9723809],
  [53.7889652, 31.9724496],
  [53.7887015, 31.971866],
  [53.7887826, 31.9708188],
  [53.7887725, 31.969188],
  [53.7886305, 31.9674886],
  [53.7885694, 31.9666932],
  [53.7885938, 31.9659992],
  [53.7887637, 31.9654284],
  [53.7891376, 31.9649263],
  [53.7894678, 31.9647446],
  [53.7897723, 31.9647468],
  [53.7900913, 31.9646011],
  [53.790278, 31.9644083],
  [53.7903511, 31.9638557],
  [53.7903295, 31.9633525],
  [53.7902104, 31.9630184],
  [53.790004, 31.9628076],
  [53.7898095, 31.9623367],
  [53.7896032, 31.9610462],
  [53.7893415, 31.9604607],
  [53.7890956, 31.9600115],
  [53.7888934, 31.9594143],
  [53.788824, 31.9583556],
  [53.7888842, 31.9577506],
  [53.7891483, 31.9572935],
  [53.7896158, 31.9571168],
  [53.7897922, 31.9568538],
  [53.7898475, 31.9564418],
  [53.789669, 31.95597],
  [53.7894906, 31.9555722],
  [53.7890805, 31.9552261],
  [53.7888015, 31.9546459],
  [53.7887278, 31.9539894],
  [53.7888736, 31.9534072],
  [53.7890849, 31.9531578],
  [53.78967, 31.9525772],
  [53.7896778, 31.9522006],
  [53.7896127, 31.9519102],
  [53.7894783, 31.9518305],
  [53.7889943, 31.9518371],
  [53.7886886, 31.9513587],
  [53.7884838, 31.9513726],
  [53.7881188, 31.9521259],
  [53.7878112, 31.9523507],
  [53.7862291, 31.9520502],
  [53.78566, 31.9518417],
  [53.7852512, 31.951436],
  [53.7848595, 31.9508657],
  [53.7844751, 31.9504925],
  [53.7839689, 31.9503852],
  [53.7834845, 31.9505244],
  [53.7833668, 31.9503948],
  [53.7832928, 31.9500433],
  [53.7834304, 31.9495806],
  [53.7838474, 31.9492351],
  [53.7839804, 31.9489142],
  [53.7839586, 31.9484465],
  [53.7835764, 31.9472918],
  [53.7832274, 31.9458161],
  [53.7831794, 31.9451877],
  [53.7832552, 31.9447442],
  [53.7836106, 31.9443245],
  [53.7840491, 31.9441306],
  [53.7844489, 31.9443109],
  [53.7847648, 31.9448907],
  [53.7848868, 31.9457027],
  [53.7851335, 31.9460845],
  [53.7854458, 31.9463062],
  [53.7857583, 31.9462496],
  [53.7859858, 31.9457627],
  [53.7860066, 31.9453279],
  [53.7861149, 31.9448191],
  [53.7861433, 31.9443725],
  [53.7860698, 31.9440244],
  [53.7853208, 31.9429877],
  [53.7849785, 31.9429112],
  [53.7845747, 31.9426006],
  [53.7843103, 31.9419261],
  [53.7842642, 31.9412656],
  [53.7845607, 31.9402761],
  [53.7849521, 31.939891],
  [53.7854272, 31.9396642],
  [53.7858587, 31.9395853],
  [53.7863924, 31.939785],
  [53.7864931, 31.9394458],
  [53.7864483, 31.9381947],
  [53.7865855, 31.9375802],
  [53.7870212, 31.9371259],
  [53.7872664, 31.9365131],
  [53.7873433, 31.9356906],
  [53.7873038, 31.9326005],
  [53.7875811, 31.9315205],
  [53.7878874, 31.9310691],
  [53.7882672, 31.9308317],
  [53.7886882, 31.9296311],
  [53.7892953, 31.9275263],
  [53.7892023, 31.9264215],
  [53.7889001, 31.9258795],
  [53.7886015, 31.9253435],
  [53.7882273, 31.9248624],
  [53.787774, 31.924966],
  [53.7874066, 31.9252816],
  [53.7867918, 31.9256115],
  [53.7866627, 31.9250223],
  [53.7867702, 31.9245701],
  [53.7870508, 31.9241986],
  [53.7875977, 31.9237967],
  [53.7879791, 31.9242656],
  [53.7884144, 31.9240647],
  [53.7886734, 31.9234435],
  [53.7888405, 31.9219813],
  [53.7889364, 31.9210282],
  [53.7889763, 31.9206318],
  [53.7888233, 31.9194074],
  [53.7886303, 31.918669],
  [53.7879611, 31.9182183],
  [53.7876017, 31.9180491],
  [53.7869033, 31.9176946],
  [53.7863564, 31.9177189],
  [53.7860794, 31.9172683],
  [53.7857992, 31.9149911],
  [53.7859463, 31.914473],
  [53.78645, 31.9139615],
  [53.7866946, 31.9133525],
  [53.7867666, 31.9125486],
  [53.7867306, 31.9118361],
  [53.786522, 31.9111357],
  [53.7858679, 31.9106546],
  [53.785545, 31.9098069],
  [53.7856548, 31.9087972],
  [53.7860542, 31.9082004],
  [53.786665, 31.9079492],
  [53.7868692, 31.907339],
  [53.7869933, 31.9065317],
  [53.7869407, 31.9060991],
  [53.7867717, 31.9056665],
  [53.7860218, 31.9046987],
  [53.7849139, 31.9037913],
  [53.7843616, 31.9035029],
  [53.7837875, 31.903313],
  [53.7829036, 31.9033229],
  [53.7825591, 31.903069],
  [53.7819069, 31.9012785],
  [53.7817288, 31.9009867],
  [53.7814275, 31.9006515],
  [53.7811606, 31.9008531],
  [53.78072, 31.9016587],
  [53.7802272, 31.9022639],
  [53.7799378, 31.9023043],
  [53.7792796, 31.901942],
  [53.7781939, 31.9013708],
  [53.7775134, 31.9010021],
  [53.7767904, 31.9004702],
  [53.776084, 31.8999227],
  [53.7754602, 31.8996137],
  [53.7750727, 31.8993634],
  [53.7748534, 31.8991089],
  [53.7746195, 31.8986642],
  [53.774532, 31.8981702],
  [53.7745566, 31.8978218],
  [53.7748072, 31.897213],
  [53.7753563, 31.8963701],
  [53.776081, 31.8952253],
  [53.7768847, 31.8946984],
  [53.7771499, 31.8945291],
  [53.7775607, 31.8938176],
  [53.7778171, 31.8928594],
  [53.7779861, 31.8911864],
  [53.7780044, 31.8904406],
  [53.7779495, 31.8890011],
  [53.7779958, 31.8884952],
  [53.7781878, 31.8877922],
  [53.7785429, 31.8873583],
  [53.779051, 31.8870231],
  [53.7794243, 31.886968],
  [53.7798268, 31.887147],
  [53.7802894, 31.8875069],
  [53.781125, 31.8876327],
  [53.7816593, 31.8875994],
  [53.7823374, 31.886307],
  [53.7832937, 31.8848153],
  [53.7836148, 31.8841594],
  [53.7837831, 31.8834048],
  [53.783781, 31.8825418],
  [53.7835246, 31.8813943],
  [53.7835158, 31.8809369],
  [53.7836162, 31.8804826],
  [53.7840079, 31.8794121],
  [53.7842088, 31.8784542],
  [53.7840867, 31.8778615],
  [53.7838918, 31.8773427],
  [53.7836471, 31.8767398],
  [53.7835942, 31.8759809],
  [53.7837911, 31.8752355],
  [53.784116, 31.8747675],
  [53.7846157, 31.8742256],
  [53.7851218, 31.8738523],
  [53.7854678, 31.8737009],
  [53.7860288, 31.873804],
  [53.7865176, 31.8737216],
  [53.7866352, 31.8733921],
  [53.7866582, 31.8730256],
  [53.7865304, 31.872666],
  [53.7859505, 31.8722806],
  [53.7852679, 31.8717879],
  [53.7848168, 31.8710748],
  [53.7845888, 31.8702407],
  [53.7846486, 31.8696564],
  [53.7847445, 31.8690421],
  [53.7845646, 31.8687558],
  [53.7841964, 31.8689716],
  [53.7839853, 31.8692004],
  [53.7834456, 31.8691695],
  [53.7831209, 31.8690594],
  [53.7827869, 31.8687908],
  [53.7825755, 31.8685225],
  [53.7824203, 31.8680932],
  [53.7824745, 31.8672493],
  [53.7826411, 31.866829],
  [53.7829023, 31.8666305],
  [53.7833359, 31.8657051],
  [53.7835354, 31.8647482],
  [53.7834819, 31.8636575],
  [53.7834309, 31.8618234],
  [53.7836284, 31.8614002],
  [53.7840105, 31.8608267],
  [53.7847905, 31.860549],
  [53.7855901, 31.8604058],
  [53.7868265, 31.8606352],
  [53.7872118, 31.8604139],
  [53.7872974, 31.8599623],
  [53.7872739, 31.85956],
  [53.7869609, 31.858945],
  [53.786827, 31.8584355],
  [53.7868386, 31.8574347],
  [53.7862338, 31.8562585],
  [53.7862411, 31.8557733],
  [53.7864012, 31.855399],
  [53.786613, 31.8552894],
  [53.7879653, 31.8545355],
  [53.788575, 31.8540035],
  [53.7893324, 31.8532593],
  [53.7898859, 31.8529342],
  [53.7907584, 31.8527183],
  [53.7914907, 31.8520313],
  [53.792313, 31.8507318],
  [53.7928984, 31.8494114],
  [53.7929649, 31.8483996],
  [53.7928258, 31.8477485],
  [53.7925702, 31.8472947],
  [53.7921563, 31.8471161],
  [53.7914876, 31.8469869],
  [53.7902977, 31.8473371],
  [53.7900954, 31.8470854],
  [53.7900147, 31.8466974],
  [53.790175, 31.8459865],
  [53.7903403, 31.8452157],
  [53.7907583, 31.8444088],
  [53.7911569, 31.8441994],
  [53.7930151, 31.8436158],
  [53.7933213, 31.8432959],
  [53.7935765, 31.8426802],
  [53.7935914, 31.841729],
  [53.7935336, 31.8409504],
  [53.7933212, 31.8402615],
  [53.7933054, 31.8396096],
  [53.7934258, 31.8392075],
  [53.7936823, 31.8390102],
  [53.7938952, 31.839047],
  [53.7941745, 31.8394283],
  [53.7945037, 31.8399354],
  [53.7947918, 31.8399452],
  [53.7949342, 31.8395113],
  [53.7948597, 31.8388057],
  [53.7946469, 31.8383343],
  [53.7946815, 31.8380692],
  [53.7948181, 31.8378041],
  [53.7951413, 31.8376024],
  [53.7952195, 31.8374617],
  [53.7951155, 31.8372239],
  [53.7946235, 31.8369692],
  [53.794466, 31.8364831],
  [53.7944061, 31.8356956],
  [53.7944663, 31.834786],
  [53.7948046, 31.8340755],
  [53.7951546, 31.8331337],
  [53.7953091, 31.8327179],
  [53.796925, 31.8310735],
  [53.798275, 31.8287693],
  [53.8002323, 31.8259274],
  [53.8009529, 31.8249921],
  [53.8016355, 31.8235375],
  [53.8021862, 31.8213351],
  [53.8023279, 31.8195548],
  [53.8021598, 31.8187127],
  [53.8018198, 31.8184848],
  [53.8014059, 31.8187409],
  [53.801026, 31.8201871],
  [53.8007811, 31.8202722],
  [53.8005799, 31.8201354],
  [53.8002972, 31.8196567],
  [53.8001769, 31.8191858],
  [53.8001532, 31.8183937],
  [53.7997421, 31.8172974],
  [53.7996441, 31.8160499],
  [53.7997135, 31.8150858],
  [53.799912, 31.8146063],
  [53.8003575, 31.8144691],
  [53.8007311, 31.8145839],
  [53.8010392, 31.8145384],
  [53.8012432, 31.8141454],
  [53.8011706, 31.8137276],
  [53.8009864, 31.8135232],
  [53.8005883, 31.8132842],
  [53.8001988, 31.8128556],
  [53.7999684, 31.8109986],
  [53.8000772, 31.8097025],
  [53.8001459, 31.8087273],
  [53.8004024, 31.8084029],
  [53.8012228, 31.8079648],
  [53.8014013, 31.8077912],
  [53.8015798, 31.8074204],
  [53.8017466, 31.8067185],
  [53.8018973, 31.8063847],
  [53.8021208, 31.806322],
  [53.8023137, 31.8065088],
  [53.8025212, 31.8068312],
  [53.8025074, 31.807546],
  [53.8020425, 31.8083599],
  [53.8019166, 31.808792],
  [53.8018925, 31.8091747],
  [53.8020116, 31.8098699],
  [53.8022252, 31.8102693],
  [53.8027328, 31.8108476],
  [53.803335, 31.8112174],
  [53.8042067, 31.8112751],
  [53.8051485, 31.8120617],
  [53.8059752, 31.8122122],
  [53.8063083, 31.8119289],
  [53.8065308, 31.8114071],
  [53.8065933, 31.8107743],
  [53.8064453, 31.8097103],
  [53.8061612, 31.808225],
  [53.8058479, 31.8070849],
  [53.8058909, 31.8066531],
  [53.8068984, 31.805417],
  [53.8072737, 31.804075],
  [53.8073935, 31.8023048],
  [53.8073319, 31.8001767],
  [53.8070863, 31.7990733],
  [53.8063516, 31.7979654],
  [53.8063056, 31.7973832],
  [53.8066307, 31.7959013],
  [53.8066697, 31.7947615],
  [53.8062949, 31.7923699],
  [53.806487, 31.7914727],
  [53.8067227, 31.790822],
  [53.8068555, 31.7902913],
  [53.80677, 31.7895387],
  [53.8064801, 31.7890454],
  [53.8061903, 31.7887987],
  [53.8057019, 31.7887051],
  [53.8053008, 31.7878967],
  [53.8048189, 31.7876602],
  [53.8043354, 31.7877296],
  [53.8039275, 31.7879494],
  [53.8033741, 31.7885142],
  [53.8028495, 31.7886827],
  [53.8025321, 31.7885068],
  [53.8022439, 31.7882077],
  [53.8020031, 31.7874568],
  [53.8019184, 31.7868466],
  [53.8018098, 31.7861797],
  [53.8017548, 31.7858174],
  [53.8018061, 31.7855235],
  [53.8020189, 31.7853856],
  [53.802459, 31.7855855],
  [53.803132, 31.7857114],
  [53.8033363, 31.7854496],
  [53.8033805, 31.7851631],
  [53.8032875, 31.7844222],
  [53.8030343, 31.7833855],
  [53.80315, 31.7824156],
  [53.8033629, 31.780779],
  [53.8036589, 31.780022],
  [53.8041121, 31.7794261],
  [53.8045884, 31.7794656],
  [53.8049969, 31.7799819],
  [53.8052278, 31.7798215],
  [53.8052601, 31.7792891],
  [53.8047749, 31.7788591],
  [53.8041888, 31.7787188],
  [53.80395, 31.778253],
  [53.8038567, 31.7778119],
  [53.8038276, 31.7763027],
  [53.8034961, 31.7755708],
  [53.8032529, 31.7755236],
  [53.803046, 31.7758215],
  [53.8033303, 31.7773052],
  [53.8031601, 31.7784481],
  [53.8027207, 31.7790515],
  [53.8020435, 31.7790139],
  [53.8016469, 31.7787234],
  [53.8012939, 31.7782851],
  [53.8011409, 31.777529],
  [53.8008962, 31.77708],
  [53.8004649, 31.7771721],
  [53.8003242, 31.7776394],
  [53.8003145, 31.7781067],
  [53.800644, 31.779226],
  [53.8005543, 31.7796251],
  [53.8004063, 31.7798517],
  [53.7998, 31.7797902],
  [53.7995143, 31.7793824],
  [53.7993888, 31.7789993],
  [53.7996025, 31.7781149],
  [53.7996527, 31.7774273],
  [53.7994806, 31.7768642],
  [53.7991711, 31.7767707],
  [53.7988907, 31.7768744],
  [53.7985683, 31.7776329],
  [53.7983594, 31.777674],
  [53.7981505, 31.7775919],
  [53.7976514, 31.7761159],
  [53.797323, 31.77642],
  [53.7971428, 31.7787126],
  [53.7969605, 31.7792775],
  [53.7966172, 31.7795469],
  [53.7963199, 31.7794051],
  [53.7960603, 31.7788876],
  [53.7954824, 31.7786041],
  [53.7950597, 31.778188],
  [53.7950391, 31.7772776],
  [53.7954577, 31.7770413],
  [53.79578, 31.7740743],
  [53.7960666, 31.7730152],
  [53.7960221, 31.7721196],
  [53.7957643, 31.7718826],
  [53.7956313, 31.7708514],
  [53.7956433, 31.769576],
  [53.7955243, 31.7688676],
  [53.7949103, 31.7685508],
  [53.7943396, 31.7680261],
  [53.7938459, 31.7683651],
  [53.7931376, 31.7697536],
  [53.7932503, 31.7710187],
  [53.7930433, 31.7719032],
  [53.7927105, 31.7721272],
  [53.7924199, 31.7719709],
  [53.7920601, 31.7704879],
  [53.7919579, 31.7700557],
  [53.7920916, 31.7688755],
  [53.7925365, 31.7682466],
  [53.7928237, 31.7674163],
  [53.7930661, 31.766442],
  [53.7953596, 31.7627922],
  [53.7961618, 31.7612195],
  [53.7967589, 31.7607833],
  [53.7971284, 31.760674],
  [53.7974498, 31.7607435],
  [53.7983646, 31.7610099],
  [53.7982809, 31.7619559],
  [53.7981426, 31.7628166],
  [53.7978494, 31.764165],
  [53.7974379, 31.7658154],
  [53.797415, 31.7662513],
  [53.79755, 31.7667072],
  [53.7977917, 31.7669668],
  [53.7983889, 31.7671452],
  [53.7993253, 31.7671587],
  [53.7999843, 31.7665247],
  [53.8001873, 31.7661368],
  [53.8002738, 31.765832],
  [53.800293, 31.7655677],
  [53.800143, 31.7649991],
  [53.7999827, 31.7646611],
  [53.7998742, 31.7643555],
  [53.7998521, 31.7637978],
  [53.8000075, 31.763494],
  [53.8002012, 31.7634499],
  [53.800445, 31.7634908],
  [53.8009151, 31.7635077],
  [53.8014737, 31.7634587],
  [53.8017295, 31.7635703],
  [53.8020141, 31.7638932],
  [53.8020976, 31.7641798],
  [53.8021619, 31.7645965],
  [53.8021167, 31.765058],
  [53.8020332, 31.7656658],
  [53.8018528, 31.7660759],
  [53.8013843, 31.7667136],
  [53.8011191, 31.7673519],
  [53.8009307, 31.7680552],
  [53.8010036, 31.7685134],
  [53.8011781, 31.7690982],
  [53.8014006, 31.7695367],
  [53.8017921, 31.769922],
  [53.8022593, 31.7702121],
  [53.8025876, 31.7701777],
  [53.8029447, 31.770127],
  [53.8037942, 31.7697907],
  [53.8047508, 31.7689859],
  [53.8052274, 31.7684073],
  [53.8053245, 31.7680152],
  [53.8053881, 31.7673683],
  [53.805895, 31.7669573],
  [53.8070978, 31.7669223],
  [53.8078541, 31.7672918],
  [53.8082887, 31.7678349],
  [53.8084407, 31.7687637],
  [53.8083065, 31.7695316],
  [53.80782, 31.7701503],
  [53.8074349, 31.7702327],
  [53.8068385, 31.770222],
  [53.8060287, 31.7697392],
  [53.8057765, 31.76975],
  [53.8056417, 31.769927],
  [53.8055262, 31.7702667],
  [53.8056444, 31.7711427],
  [53.8059527, 31.7716837],
  [53.8063919, 31.7720028],
  [53.8070633, 31.7722157],
  [53.8085118, 31.7719472],
  [53.8091135, 31.7720832],
  [53.8100003, 31.7727106],
  [53.8106939, 31.7737523],
  [53.811121, 31.7740965],
  [53.8115668, 31.7739013],
  [53.8121422, 31.772917],
  [53.8127597, 31.7721242],
  [53.8133651, 31.7717228],
  [53.8140114, 31.7716617],
  [53.8146213, 31.7716744],
  [53.8153952, 31.7716738],
  [53.816077, 31.771482],
  [53.8165916, 31.771019],
  [53.8171268, 31.7708655],
  [53.8175748, 31.7709709],
  [53.8179593, 31.7714501],
  [53.8183169, 31.7721602],
  [53.8188731, 31.7727021],
  [53.819623, 31.7727207],
  [53.8206936, 31.7723548],
  [53.8220576, 31.771965],
  [53.8228636, 31.7713787],
  [53.8233808, 31.7704978],
  [53.8235728, 31.7692002],
  [53.8233731, 31.7679368],
  [53.8228349, 31.7671385],
  [53.8223229, 31.7666778],
  [53.8219583, 31.7662646],
  [53.8217186, 31.7658841],
  [53.8215992, 31.7652455],
  [53.8215454, 31.7641508],
  [53.8216422, 31.7634601],
  [53.8219427, 31.7626955],
  [53.82276, 31.7616658],
  [53.8236147, 31.7610032],
  [53.8241399, 31.7608841],
  [53.8244178, 31.7609868],
  [53.8246599, 31.7613967],
  [53.8250188, 31.7635283],
  [53.8251354, 31.7640562],
  [53.8253102, 31.7644115],
  [53.8258877, 31.7644898],
  [53.8265524, 31.7643463],
  [53.8268812, 31.7641276],
  [53.8272337, 31.7632522],
  [53.8275421, 31.7621527],
  [53.8283577, 31.7603444],
  [53.8289522, 31.7596549],
  [53.829823, 31.7586204],
  [53.8303317, 31.7577345],
  [53.8307364, 31.7569488],
  [53.8312257, 31.7562923],
  [53.8318188, 31.7561907],
  [53.8322512, 31.7562917],
  [53.8326015, 31.7565747],
  [53.8327995, 31.7570101],
  [53.8329218, 31.7576795],
  [53.8328968, 31.75837],
  [53.8326623, 31.759266],
  [53.8324631, 31.7605059],
  [53.8323521, 31.7617085],
  [53.8325188, 31.7634282],
  [53.8330835, 31.7650299],
  [53.8345912, 31.7669859],
  [53.8357469, 31.7690776],
  [53.8360892, 31.7714999],
  [53.8360286, 31.7724412],
  [53.8357254, 31.7732704],
  [53.8358708, 31.7740185],
  [53.8360989, 31.7750376],
  [53.836155, 31.7757901],
  [53.8360677, 31.7764865],
  [53.8357642, 31.7775444],
  [53.8353534, 31.7780929],
  [53.8349206, 31.7783612],
  [53.8331842, 31.778538],
  [53.8327486, 31.7787709],
  [53.8322399, 31.7793779],
  [53.8319793, 31.7801531],
  [53.8318398, 31.781357],
  [53.8321185, 31.7836626],
  [53.832345, 31.7842222],
  [53.8326551, 31.7846402],
  [53.8331075, 31.7846649],
  [53.8339748, 31.7842291],
  [53.8342072, 31.7842888],
  [53.8344877, 31.7845578],
  [53.8348099, 31.7852799],
  [53.8348572, 31.7862376],
  [53.834698, 31.7870233],
  [53.8345055, 31.7876674],
  [53.8338294, 31.7890829],
  [53.8336994, 31.7895645],
  [53.83382, 31.7898904],
  [53.8347873, 31.7899111],
  [53.8353773, 31.7901799],
  [53.8360266, 31.790967],
  [53.8366061, 31.7929749],
  [53.8378438, 31.7943318],
  [53.8382351, 31.7944543],
  [53.8388435, 31.7944069],
  [53.8396225, 31.7942191],
  [53.839828, 31.7940529],
  [53.8400502, 31.7936036],
  [53.8401536, 31.7928715],
  [53.8400983, 31.7917571],
  [53.8403426, 31.7898963],
  [53.8409057, 31.7890805],
  [53.8414453, 31.7888897],
  [53.841974, 31.7889784],
  [53.8423858, 31.7888122],
  [53.8425863, 31.7884094],
  [53.8425112, 31.7878367],
  [53.8423067, 31.7868052],
  [53.8421307, 31.785799],
  [53.8418128, 31.7850194],
  [53.8412212, 31.7842433],
  [53.8406379, 31.7834107],
  [53.8404835, 31.7829261],
  [53.8405212, 31.7824699],
  [53.8407329, 31.7819446],
  [53.8411566, 31.7816144],
  [53.8434012, 31.7814257],
  [53.8446152, 31.7813989],
  [53.8451092, 31.7816638],
  [53.8454815, 31.7826032],
  [53.8458872, 31.7840806],
  [53.8465672, 31.7854362],
  [53.8476815, 31.7866926],
  [53.8490641, 31.7878432],
  [53.8496058, 31.7879979],
  [53.8501475, 31.7877563],
  [53.8508532, 31.7870562],
  [53.8513417, 31.7867525],
  [53.8525301, 31.7869076],
  [53.8550237, 31.788962],
  [53.8553824, 31.7890415],
  [53.8557304, 31.7894151],
  [53.8553402, 31.795403],
  [53.8541226, 31.8058805],
  [53.8533321, 31.8118881],
  [53.8568697, 31.8137678],
  [53.8589843, 31.8140595],
  [53.8614102, 31.8193974],
  [53.8603315, 31.8218493],
  [53.8582076, 31.8249684],
  [53.8577845, 31.8276457],
  [53.8585901, 31.8329352],
  [53.8655014, 31.838343],
  [53.8660494, 31.8368211],
  [53.8645356, 31.8263925],
  [53.8647317, 31.8174619],
  [53.8651872, 31.8177225],
  [53.8655119, 31.8180571],
  [53.865816, 31.8184996],
  [53.8662073, 31.8188188],
  [53.8664856, 31.8187865],
  [53.8668802, 31.8186803],
  [53.8671607, 31.8184679],
  [53.8672695, 31.8177599],
  [53.8672507, 31.8168965],
  [53.8672901, 31.815688],
  [53.8675577, 31.814947],
  [53.8680234, 31.8145954],
  [53.8683001, 31.8144779],
  [53.8690344, 31.8148325],
  [53.8699605, 31.8159827],
  [53.8712143, 31.8176134],
  [53.8715946, 31.8181885],
  [53.8720227, 31.8185034],
  [53.8724782, 31.8184978],
  [53.8729331, 31.8180576],
  [53.8732119, 31.8170419],
  [53.8729958, 31.81596],
  [53.8725309, 31.8144453],
  [53.872108, 31.8137519],
  [53.8710836, 31.8134037],
  [53.8705779, 31.8128702],
  [53.8701698, 31.8120924],
  [53.8700014, 31.8112334],
  [53.8700727, 31.8103564],
  [53.8703074, 31.8097429],
  [53.8720761, 31.8082513],
  [53.8724529, 31.8076416],
  [53.8729864, 31.8061009],
  [53.8734241, 31.8045602],
  [53.87423, 31.8037832],
  [53.8748647, 31.8029417],
  [53.8750498, 31.8021814],
  [53.874957, 31.8003153],
  [53.875011, 31.7993914],
  [53.8751656, 31.7987621],
  [53.8755401, 31.7985775],
  [53.8757996, 31.7986043],
  [53.8764043, 31.7992151],
  [53.8766069, 31.7994904],
  [53.876779, 31.7997241],
  [53.877328, 31.8004615],
  [53.8776056, 31.8015225],
  [53.877634, 31.8026485],
  [53.8776579, 31.8039572],
  [53.8774052, 31.8056555],
  [53.8774562, 31.8073826],
  [53.8772503, 31.8088942],
  [53.8773354, 31.8098417],
  [53.8780362, 31.8112522],
  [53.878377, 31.8122989],
  [53.8784686, 31.813118],
  [53.8789226, 31.8139984],
  [53.879597, 31.8173182],
  [53.8810831, 31.8236429],
  [53.8820466, 31.8271467],
  [53.8825979, 31.8300488],
  [53.8831064, 31.8306449],
  [53.8835427, 31.8309429],
  [53.8839407, 31.8312084],
  [53.8845243, 31.8309533],
  [53.8851505, 31.8303936],
  [53.8858054, 31.8298502],
  [53.886241, 31.8296409],
  [53.8869641, 31.8295293],
  [53.8879313, 31.8295209],
  [53.8888026, 31.8297076],
  [53.8899595, 31.8298567],
  [53.8904707, 31.8295106],
  [53.8908605, 31.8289798],
  [53.8913429, 31.8281778],
  [53.891632, 31.827354],
  [53.892017, 31.8269855],
  [53.8926616, 31.8268149],
  [53.8934726, 31.8268759],
  [53.8941944, 31.8266137],
  [53.8959128, 31.8270346],
  [53.8964046, 31.8267395],
  [53.8969449, 31.8263174],
  [53.8975121, 31.8260414],
  [53.8980985, 31.826058],
  [53.8988341, 31.8264796],
  [53.8997901, 31.8272101],
  [53.9004777, 31.82786],
  [53.9009269, 31.828868],
  [53.9012229, 31.8298922],
  [53.9017616, 31.8307829],
  [53.9025111, 31.8312507],
  [53.9037428, 31.8313899],
  [53.9045503, 31.8312319],
  [53.9055302, 31.8308787],
  [53.9048653, 31.8373304],
  [53.9042818, 31.8415484],
  [53.9057355, 31.843912],
  [53.9068336, 31.8454212],
  [53.9080787, 31.8458878],
  [53.910695, 31.8438705],
  [53.9108776, 31.8423174],
  [53.9110694, 31.8423003],
  [53.9112486, 31.8420901],
  [53.9114128, 31.8415518],
  [53.9113685, 31.8411432],
  [53.9111536, 31.8403483],
  [53.9110032, 31.8395701],
  [53.9109849, 31.8387518],
  [53.9112194, 31.8379979],
  [53.9114238, 31.8377863],
  [53.9116661, 31.8377248],
  [53.9120823, 31.8379092],
  [53.9123978, 31.8384198],
  [53.9127862, 31.8394529],
  [53.9134843, 31.8407972],
  [53.9139942, 31.8411498],
  [53.9144536, 31.8413737],
  [53.9149846, 31.8412255],
  [53.9155823, 31.8408791],
  [53.9163146, 31.8403833],
  [53.9170191, 31.8407692],
  [53.9174364, 31.8412649],
  [53.9175253, 31.841916],
  [53.9178079, 31.8433342],
  [53.9177161, 31.8448164],
  [53.9170815, 31.845178],
  [53.9165847, 31.8453127],
  [53.9163269, 31.8464956],
  [53.9149013, 31.8482943],
  [53.91434, 31.8507392],
  [53.9144132, 31.8521274],
  [53.9146168, 31.8533563],
  [53.9144887, 31.854266],
  [53.9149981, 31.8546488],
  [53.9158498, 31.8543369],
  [53.9160889, 31.8551927],
  [53.9170978, 31.8568306],
  [53.9178422, 31.8570171],
  [53.9196603, 31.8539299],
  [53.9210694, 31.851916],
  [53.9220421, 31.8524372],
  [53.9239676, 31.8549947],
  [53.9244632, 31.8554803],
  [53.9251686, 31.8554156],
  [53.9258358, 31.8549947],
  [53.9294385, 31.8515631],
  [53.9312326, 31.8506507],
  [53.9311705, 31.8511986],
  [53.93126, 31.8520254],
  [53.9315167, 31.8529219],
  [53.9319882, 31.8537755],
  [53.9326217, 31.8544703],
  [53.9333942, 31.8550578],
  [53.9337707, 31.8552028],
  [53.934207, 31.8550849],
  [53.9344665, 31.8547418],
  [53.9348304, 31.8536471],
  [53.9350172, 31.8531379],
  [53.9353802, 31.8525494],
  [53.9358761, 31.8518458],
  [53.9361842, 31.8514435],
  [53.9365302, 31.850612],
  [53.9368558, 31.8495713],
  [53.9370413, 31.8494319],
  [53.9372961, 31.8494855],
  [53.9375912, 31.8497644],
  [53.9378769, 31.8505208],
  [53.9380112, 31.8515628],
  [53.9382259, 31.8526108],
  [53.9384737, 31.8535542],
  [53.9386683, 31.8540007],
  [53.9389876, 31.8544118],
  [53.9392817, 31.8544614],
  [53.9395682, 31.8542958],
  [53.9398081, 31.8540021],
  [53.9406209, 31.852582],
  [53.9408909, 31.8519644],
  [53.9409351, 31.851322],
  [53.9408273, 31.8507199],
  [53.9406694, 31.8500515],
  [53.9406378, 31.849625],
  [53.9407677, 31.8491724],
  [53.9410045, 31.8488137],
  [53.9414414, 31.8485977],
  [53.9416683, 31.8485796],
  [53.9420101, 31.8486829],
  [53.9424707, 31.8492005],
  [53.9429557, 31.8499536],
  [53.9434147, 31.8506938],
  [53.9437545, 31.8509567],
  [53.9439475, 31.8510438],
  [53.9442123, 31.8510813],
  [53.9446624, 31.8511628],
  [53.9462839, 31.8508266],
  [53.9475066, 31.8511073],
  [53.9479529, 31.8512297],
  [53.9489385, 31.8513303],
  [53.9492336, 31.8503915],
  [53.9498713, 31.8490406],
  [53.9499103, 31.8484693],
  [53.9498064, 31.8478794],
  [53.9496032, 31.8474559],
  [53.9492022, 31.8470136],
  [53.9488577, 31.8467617],
  [53.9486393, 31.8464888],
  [53.9485309, 31.8459919],
  [53.9489699, 31.8449833],
  [53.9494561, 31.8446116],
  [53.9497854, 31.8445585],
  [53.9500927, 31.8447294],
  [53.9504249, 31.8451964],
  [53.9505269, 31.8459664],
  [53.9510711, 31.8467461],
  [53.951427, 31.8475109],
  [53.9514035, 31.8485605],
  [53.9512064, 31.8491053],
  [53.9511005, 31.8497751],
  [53.9509623, 31.8512296],
  [53.9509128, 31.8516361],
  [53.9516494, 31.8529422],
  [53.9526169, 31.8539494],
  [53.9530586, 31.8547],
  [53.9536044, 31.8559345],
  [53.9539034, 31.8568424],
  [53.9542005, 31.8577434],
  [53.9545244, 31.8584659],
  [53.9548567, 31.8585902],
  [53.9552236, 31.8586054],
  [53.9555868, 31.8581562],
  [53.9558698, 31.8571494],
  [53.9560599, 31.856787],
  [53.9563479, 31.8563245],
  [53.956909, 31.8558141],
  [53.9573047, 31.85539],
  [53.9575553, 31.8552698],
  [53.9578902, 31.8554073],
  [53.9581873, 31.8558882],
  [53.9583712, 31.8565844],
  [53.9584603, 31.8572591],
  [53.9584492, 31.8581579],
  [53.9582724, 31.858989],
  [53.9581928, 31.8599627],
  [53.958161, 31.8609802],
  [53.9582002, 31.8620913],
  [53.9583194, 31.8634078],
  [53.958375, 31.8643529],
  [53.9584859, 31.8651573],
  [53.9587072, 31.8656103],
  [53.9589135, 31.8658626],
  [53.9591197, 31.865945],
  [53.9592691, 31.8665962],
  [53.9593316, 31.8667661],
  [53.9596148, 31.8668581],
  [53.9598855, 31.8668298],
  [53.9604019, 31.8669785],
  [53.9608308, 31.8672758],
  [53.9612223, 31.8677996],
  [53.961443, 31.8679411],
  [53.9616346, 31.8681039],
  [53.9617637, 31.8684225],
  [53.9617553, 31.8686348],
  [53.9616262, 31.8687481],
  [53.9616512, 31.8690029],
  [53.9616346, 31.8692152],
  [53.961722, 31.869371],
  [53.9618511, 31.8694984],
  [53.9618511, 31.8696966],
  [53.9619178, 31.8698311],
  [53.9621676, 31.8698523],
  [53.9623259, 31.8698806],
  [53.96238, 31.8699585],
  [53.9623175, 31.8701779],
  [53.9623425, 31.8703903],
  [53.9622801, 31.8705389],
  [53.9623092, 31.8708433],
  [53.9621718, 31.8708433],
  [53.9621759, 31.870999],
  [53.9622426, 31.8712184],
  [53.9621968, 31.8714095],
  [53.9622342, 31.8715016],
  [53.9623342, 31.8715157],
  [53.9625341, 31.8715794],
  [53.9626132, 31.8715157],
  [53.962634, 31.8713317],
  [53.9626757, 31.871268],
  [53.9628256, 31.8713104],
  [53.9630171, 31.8714237],
  [53.9631879, 31.8715299],
  [53.9633128, 31.8714095],
  [53.9634252, 31.8713954],
  [53.9636251, 31.8714591],
  [53.9636626, 31.8715723],
  [53.9636709, 31.8718767],
  [53.9636043, 31.8720041],
  [53.9634877, 31.871905],
  [53.9634211, 31.8719758],
  [53.9634336, 31.8721315],
  [53.963521, 31.8723368],
  [53.9636543, 31.872259],
  [53.9637209, 31.8724005],
  [53.9636876, 31.8725492],
  [53.9636876, 31.8727474],
  [53.9638125, 31.8727049],
  [53.963875, 31.8728677],
  [53.963875, 31.8731154],
  [53.9640124, 31.8731862],
  [53.9640249, 31.8730447],
  [53.9641331, 31.8729102],
  [53.9643705, 31.8729172],
  [53.964458, 31.8730447],
  [53.9644371, 31.8731579],
  [53.9643705, 31.8734269],
  [53.9643663, 31.8736251],
  [53.9644871, 31.8736605],
  [53.9646703, 31.8736605],
  [53.9647245, 31.8739082],
  [53.9647703, 31.8740144],
  [53.9649118, 31.874071],
  [53.9649077, 31.8741701],
  [53.9647453, 31.8741347],
  [53.9646703, 31.8742126],
  [53.9647687, 31.8746126],
  [53.9648728, 31.8754196],
  [53.9649769, 31.8756744],
  [53.9649977, 31.8763115],
  [53.9650685, 31.8767928],
  [53.9651768, 31.8771538],
  [53.9650852, 31.8773945],
  [53.9651227, 31.8776351],
  [53.9652476, 31.8777908],
  [53.9652892, 31.8781094],
  [53.9654599, 31.8784067],
  [53.9655724, 31.8785907],
  [53.9655724, 31.8787464],
  [53.9653767, 31.8789517],
  [53.9652434, 31.8791499],
  [53.965081, 31.8803886],
  [53.9649727, 31.8811814],
  [53.9650519, 31.8814716],
  [53.9650227, 31.8818538],
  [53.9650435, 31.8824413],
  [53.9650185, 31.8828236],
  [53.9651601, 31.8829722],
  [53.9652143, 31.8831917],
  [53.9651018, 31.8833969],
  [53.9648437, 31.8835527],
  [53.9648062, 31.8838783],
  [53.9648645, 31.8841968],
  [53.9648603, 31.8845719],
  [53.9649686, 31.8848834],
  [53.9650019, 31.8852019],
  [53.9650602, 31.8854072],
  [53.9652601, 31.8857682],
  [53.9652767, 31.8860301],
  [53.9653767, 31.8860089],
  [53.9654641, 31.886115],
  [53.9655349, 31.8863415],
  [53.9654974, 31.8865256],
  [53.9655224, 31.886745],
  [53.9655432, 31.8869078],
  [53.9655266, 31.8871556],
  [53.9653059, 31.8873891],
  [53.9652059, 31.8876298],
  [53.96531, 31.8877714],
  [53.9654849, 31.8879696],
  [53.9656015, 31.888189],
  [53.9656182, 31.8885712],
  [53.9656432, 31.8887128],
  [53.9657681, 31.8886562],
  [53.9659596, 31.8886986],
  [53.966122, 31.8889322],
  [53.9661262, 31.8891304],
  [53.9660179, 31.8891871],
  [53.9659138, 31.8891304],
  [53.9658389, 31.889272],
  [53.9658638, 31.8894914],
  [53.9659929, 31.8895834],
  [53.9661553, 31.8898029],
  [53.9661886, 31.8900223],
  [53.9661595, 31.8901639],
  [53.9660346, 31.8901851],
  [53.9659305, 31.8900435],
  [53.9658722, 31.8898029],
  [53.9658139, 31.889725],
  [53.9657306, 31.8898737],
  [53.9657597, 31.8902347],
  [53.9658347, 31.8904116],
  [53.9659513, 31.890532],
  [53.9659471, 31.8907585],
  [53.9659971, 31.8909],
  [53.9661387, 31.8909354],
  [53.966172, 31.8909779],
  [53.966147, 31.8912398],
  [53.9660096, 31.8912752],
  [53.9660096, 31.8914309],
  [53.9660637, 31.8916503],
  [53.9661886, 31.8918768],
  [53.9663177, 31.8919193],
  [53.9939916, 31.8909434],
  [53.9963111, 31.8739707],
  [53.999745, 31.8653582],
  [54.00287, 31.85752],
  [54.0045012, 31.8539901],
  [54.0056566, 31.8539663],
  [54.0062785, 31.8540768],
  [54.0063944, 31.8541449],
  [54.0068239, 31.8545362],
  [54.0070096, 31.8549876],
  [54.0071954, 31.8556504],
  [54.0071514, 31.856854],
  [54.007175, 31.8577424],
  [54.0073753, 31.8586795],
  [54.0082017, 31.8598899],
  [54.0089084, 31.8602763],
  [54.0095104, 31.8602381],
  [54.0103927, 31.8597689],
  [54.010929, 31.8595193],
  [54.0111451, 31.8596243],
  [54.0112752, 31.859767],
  [54.011492, 31.8606233],
  [54.0119775, 31.8612925],
  [54.0120664, 31.8617176],
  [54.0120606, 31.8622354],
  [54.0119186, 31.8626366],
  [54.0113991, 31.8629891],
  [54.0112005, 31.8636623],
  [54.0112084, 31.8640325],
  [54.011325, 31.864357],
  [54.0115755, 31.8645496],
  [54.0122032, 31.8646705],
  [54.012942, 31.8648933],
  [54.0140136, 31.865513],
  [54.0146577, 31.8665157],
  [54.0159268, 31.8679993],
  [54.016376, 31.8685222],
  [54.0164736, 31.8689965],
  [54.016447, 31.8695846],
  [54.016247, 31.8700532],
  [54.0157127, 31.8704408],
  [54.0151259, 31.8706982],
  [54.0147311, 31.8710807],
  [54.0146318, 31.8712257],
  [54.0143326, 31.8712345],
  [54.0141498, 31.8713566],
  [54.0139861, 31.8717641],
  [54.0140897, 31.872241],
  [54.0143225, 31.8725023],
  [54.0147188, 31.8724311],
  [54.0151726, 31.8720922],
  [54.0156398, 31.8716466],
  [54.0161897, 31.8714127],
  [54.0167855, 31.8713398],
  [54.0174133, 31.8710974],
  [54.0180674, 31.8708419],
  [54.0183107, 31.8709117],
  [54.0188492, 31.8714765],
  [54.0194896, 31.8718606],
  [54.0201904, 31.8722972],
  [54.0203622, 31.8725596],
  [54.0203719, 31.8728428],
  [54.0202574, 31.8733536],
  [54.020315, 31.8738875],
  [54.0206024, 31.8749727],
  [54.020843, 31.8754476],
  [54.0210638, 31.8756024],
  [54.0217114, 31.875664],
  [54.02188, 31.8758411],
  [54.0220198, 31.8761646],
  [54.0220331, 31.8765238],
  [54.0219126, 31.8768993],
  [54.0215974, 31.8770336],
  [54.0212935, 31.8770945],
  [54.0210708, 31.8773831],
  [54.0209763, 31.8778244],
  [54.0211453, 31.8783078],
  [54.0213715, 31.8786448],
  [54.0217618, 31.8787212],
  [54.0221712, 31.8786187],
  [54.022646, 31.8787227],
  [54.0231896, 31.8790994],
  [54.0235764, 31.8791005],
  [54.0239769, 31.878671],
  [54.0242856, 31.8784617],
  [54.0246038, 31.8784963],
  [54.0248122, 31.8788102],
  [54.0250192, 31.8797902],
  [54.0252155, 31.8804236],
  [54.025482, 31.8806957],
  [54.0259085, 31.88095],
  [54.0260954, 31.8812692],
  [54.0262632, 31.881751],
  [54.0263088, 31.8824259],
  [54.0263279, 31.8831868],
  [54.0265116, 31.8835976],
  [54.0268535, 31.8839881],
  [54.0273101, 31.8842973],
  [54.0275149, 31.8847963],
  [54.0276165, 31.88536],
  [54.0278041, 31.8856716],
  [54.0281475, 31.8855786],
  [54.0284579, 31.8851801],
  [54.0285524, 31.8844867],
  [54.0284454, 31.8822556],
  [54.0283137, 31.8818019],
  [54.0281343, 31.8813645],
  [54.0276135, 31.8809044],
  [54.0271486, 31.8808591],
  [54.0269702, 31.8805861],
  [54.026885, 31.8801329],
  [54.0268803, 31.8797384],
  [54.0270102, 31.8794276],
  [54.027207, 31.8792145],
  [54.0291324, 31.8791403],
  [54.0299145, 31.8795371],
  [54.0302647, 31.8793428],
  [54.0305481, 31.8793029],
  [54.0307431, 31.8794582],
  [54.0309286, 31.879711],
  [54.0310321, 31.8801238],
  [54.0311069, 31.8806342],
  [54.0310547, 31.8813203],
  [54.0307744, 31.8821964],
  [54.0304964, 31.8834455],
  [54.0304959, 31.8845696],
  [54.0307219, 31.8854517],
  [54.0315791, 31.886648],
  [54.0322224, 31.8872713],
  [54.0332575, 31.8874278],
  [54.0343265, 31.8873946],
  [54.0345205, 31.8875581],
  [54.0347718, 31.8879981],
  [54.0347598, 31.8889699],
  [54.0350312, 31.8901225],
  [54.0352828, 31.8906222],
  [54.0358702, 31.8911232],
  [54.036358, 31.8911586],
  [54.0375717, 31.8910152],
  [54.0396571, 31.8922109],
  [54.0404968, 31.8922974],
  [54.0413555, 31.8925466],
  [54.0418587, 31.8926387],
  [54.0435173, 31.8926821],
  [54.043927, 31.8931176],
  [54.0441457, 31.893553],
  [54.0443314, 31.8937847],
  [54.044494, 31.8939004],
  [54.0446732, 31.8940279],
  [54.0455745, 31.8943079],
  [54.0457596, 31.8944172],
  [54.0465309, 31.8952579],
  [54.0468247, 31.8958058],
  [54.0470168, 31.8959995],
  [54.047419, 31.8959656],
  [54.0478415, 31.8958001],
  [54.0481146, 31.895369],
  [54.0487197, 31.894205],
  [54.0492579, 31.8933175],
  [54.0493978, 31.8931347],
  [54.0496428, 31.8929519],
  [54.0500945, 31.8927977],
  [54.0505015, 31.892782],
  [54.0507341, 31.8928776],
  [54.0509763, 31.8930625],
  [54.0511933, 31.8934975],
  [54.0514974, 31.894628],
  [54.0517013, 31.8958724],
  [54.0518226, 31.8969952],
  [54.0519289, 31.8976609],
  [54.0522643, 31.8986438],
  [54.0525028, 31.8990589],
  [54.0569994, 31.8848142],
  [54.0590593, 31.8892417],
  [54.0602023, 31.8918924],
  [54.0606821, 31.8917513],
  [54.063464, 31.8909469],
  [54.0659506, 31.8868981],
  [54.0663154, 31.883805],
  [54.0675877, 31.8826109],
  [54.0694673, 31.8817119],
  [54.070409, 31.8826358],
  [54.0829484, 31.8981045],
  [54.0868176, 31.8947885],
  [54.0841498, 31.8732489],
  [54.0787301, 31.8649384],
  [54.0833648, 31.8582945],
  [54.0866794, 31.8564313],
  [54.0881485, 31.852766],
  [54.0876647, 31.8480012],
  [54.0831856, 31.8422895],
  [54.0816665, 31.8383153],
  [54.0827377, 31.8352949],
  [54.0851027, 31.8316907],
  [54.0873243, 31.8288806],
  [54.0892234, 31.8206338],
  [54.0927859, 31.8246948],
  [54.0954931, 31.8277811],
  [54.0968415, 31.823476],
  [54.0918747, 31.8199618],
  [54.0895817, 31.8150747],
  [54.0874677, 31.8136697],
  [54.0872492, 31.8129216],
  [54.0860029, 31.8055299],
  [54.0856761, 31.8030404],
  [54.085278, 31.8026879],
  [54.0828418, 31.8005309],
  [54.0810534, 31.7989475],
  [54.0822002, 31.7952211],
  [54.0761145, 31.7857862],
  [54.07797, 31.78637],
  [54.07951, 31.78405],
  [54.08037, 31.78165],
  [54.08037, 31.77924],
  [54.07814, 31.77555],
  [54.07814, 31.7553],
  [54.078444, 31.7533635],
  [54.0831026, 31.7534403],
  [54.084275, 31.7545584],
  [54.0845662, 31.7567991],
  [54.08552, 31.76414],
  [54.0896047, 31.767538],
  [54.09016, 31.768],
  [54.0959185, 31.7700841],
  [54.1021075, 31.7712576],
  [54.1075891, 31.7725476],
  [54.1105, 31.77383],
  [54.1127549, 31.7742933],
  [54.11316, 31.77298],
  [54.11384, 31.76929],
  [54.11342, 31.76345],
  [54.11384, 31.75873],
  [54.1104083, 31.7548294],
  [54.1118459, 31.7478738],
  [54.1105, 31.74491],
  [54.10835, 31.74225],
  [54.1070167, 31.7435136],
  [54.1061292, 31.7409265],
  [54.1045081, 31.7362015],
  [54.1057626, 31.7271235],
  [54.1150943, 31.7276211],
  [54.1124637, 31.7154445],
  [54.1120012, 31.7133036],
  [54.1117374, 31.7120826],
  [54.1115213, 31.7100935],
  [54.111389, 31.7088762],
  [54.1111934, 31.707076],
  [54.1109553, 31.7048844],
  [54.1085245, 31.6964771],
  [54.1066619, 31.6936522],
  [54.1061627, 31.688144],
  [54.1060161, 31.6865259],
  [54.1055993, 31.6848752],
  [54.10329, 31.67573],
  [54.1040454, 31.6744702],
  [54.1052657, 31.6727573],
  [54.1056491, 31.671903],
  [54.10624, 31.6714451],
  [54.1068911, 31.6713622],
  [54.1077312, 31.6715897],
  [54.1083888, 31.6713501],
  [54.1089467, 31.6716925],
  [54.1090629, 31.6722316],
  [54.1089385, 31.6729966],
  [54.1090962, 31.6732944],
  [54.1097747, 31.6733165],
  [54.1105694, 31.6736784],
  [54.111479, 31.6742585],
  [54.1125095, 31.674291],
  [54.1132449, 31.6740424],
  [54.1137288, 31.6741163],
  [54.1139306, 31.6745866],
  [54.1138159, 31.675003],
  [54.1138837, 31.6755468],
  [54.1146482, 31.675825],
  [54.1152135, 31.675636],
  [54.1157657, 31.6757069],
  [54.1162516, 31.6758628],
  [54.1166507, 31.6758205],
  [54.1169194, 31.6758014],
  [54.1172363, 31.6760467],
  [54.1174196, 31.6762968],
  [54.1176361, 31.6764052],
  [54.1179975, 31.6761997],
  [54.1186097, 31.6756014],
  [54.1190061, 31.6753996],
  [54.1191187, 31.6750894],
  [54.1193807, 31.674751],
  [54.119687, 31.674666],
  [54.1199563, 31.6749209],
  [54.1202256, 31.6750058],
  [54.1203609, 31.67469],
  [54.1203468, 31.6743318],
  [54.1200853, 31.673821],
  [54.1200624, 31.6733391],
  [54.1202553, 31.6723475],
  [54.1204716, 31.6718994],
  [54.1208787, 31.6714656],
  [54.1212803, 31.6714454],
  [54.1216001, 31.6711011],
  [54.1217043, 31.6706435],
  [54.1221569, 31.6689845],
  [54.1223358, 31.6679909],
  [54.1225231, 31.6676129],
  [54.1231394, 31.6672682],
  [54.1237225, 31.6666404],
  [54.1240093, 31.6665967],
  [54.1241859, 31.6668156],
  [54.1243531, 31.6674347],
  [54.1246031, 31.668705],
  [54.1247506, 31.6690182],
  [54.1249487, 31.6689625],
  [54.1252216, 31.6686236],
  [54.1254342, 31.6681621],
  [54.1256136, 31.6673891],
  [54.1257112, 31.6666871],
  [54.125618, 31.66624],
  [54.125608, 31.6658052],
  [54.1258603, 31.6652481],
  [54.1260793, 31.6650024],
  [54.1262525, 31.6648517],
  [54.126445, 31.6650796],
  [54.1265681, 31.665669],
  [54.1268738, 31.6663291],
  [54.1271668, 31.6663417],
  [54.127388, 31.6661074],
  [54.1281235, 31.6652643],
  [54.1285333, 31.6649889],
  [54.1288519, 31.6645577],
  [54.1289719, 31.6637699],
  [54.1292678, 31.6632195],
  [54.1298458, 31.662754],
  [54.1303315, 31.6629368],
  [54.1305923, 31.6629773],
  [54.1308366, 31.6625365],
  [54.1310182, 31.6620937],
  [54.131065, 31.6614507],
  [54.1309806, 31.6608744],
  [54.1308548, 31.6603547],
  [54.1308909, 31.6598365],
  [54.1310265, 31.6591484],
  [54.13135, 31.6585651],
  [54.1319719, 31.6581193],
  [54.1321957, 31.6580558],
  [54.1326157, 31.6584545],
  [54.1327702, 31.6589097],
  [54.1329389, 31.6594037],
  [54.1331739, 31.6595862],
  [54.1335172, 31.6595896],
  [54.1340844, 31.659324],
  [54.1342022, 31.6590735],
  [54.1343155, 31.6585337],
  [54.1343292, 31.6580789],
  [54.1342844, 31.6577251],
  [54.1341068, 31.6575129],
  [54.1338324, 31.6574194],
  [54.1329773, 31.6575807],
  [54.1327819, 31.657548],
  [54.1327108, 31.6573596],
  [54.1327178, 31.6570754],
  [54.132899, 31.6567629],
  [54.1333621, 31.6564246],
  [54.133518, 31.6562111],
  [54.1335347, 31.6556615],
  [54.1332661, 31.6546695],
  [54.1332531, 31.6542225],
  [54.1333563, 31.6534924],
  [54.1339934, 31.6520778],
  [54.1342284, 31.6515867],
  [54.1350426, 31.6505059],
  [54.1352679, 31.6501895],
  [54.1359485, 31.6488401],
  [54.1365161, 31.6484876],
  [54.1366926, 31.6486457],
  [54.1368773, 31.6489453],
  [54.1368704, 31.6492844],
  [54.1366147, 31.6500624],
  [54.1366064, 31.6505535],
  [54.1367983, 31.6506726],
  [54.1372634, 31.6501092],
  [54.1375913, 31.6497284],
  [54.1379192, 31.6495459],
  [54.1383419, 31.6495488],
  [54.1386401, 31.6499907],
  [54.1388237, 31.6505545],
  [54.1387751, 31.6510617],
  [54.1386504, 31.652107],
  [54.1383888, 31.6525778],
  [54.1381439, 31.65336],
  [54.1380097, 31.65378],
  [54.1380458, 31.6541558],
  [54.1381495, 31.6543526],
  [54.1382953, 31.6544819],
  [54.1386318, 31.6544133],
  [54.1388988, 31.653904],
  [54.1393433, 31.6534241],
  [54.1396816, 31.653255],
  [54.1399947, 31.6528446],
  [54.140319, 31.6528159],
  [54.1404921, 31.6529866],
  [54.1405308, 31.6533646],
  [54.1406483, 31.654953],
  [54.1408883, 31.6553755],
  [54.1412952, 31.6558025],
  [54.14158, 31.6558476],
  [54.1418687, 31.6557194],
  [54.1420191, 31.6555671],
  [54.1421322, 31.6552733],
  [54.142223, 31.6545748],
  [54.1423908, 31.6531889],
  [54.1424314, 31.6523684],
  [54.1423387, 31.6522168],
  [54.1371061, 31.6436647],
  [54.1354941, 31.6410302],
  [54.13376, 31.63024],
  [54.1347, 31.6238],
  [54.1352662, 31.6212318],
  [54.13608, 31.61754],
  [54.1359938, 31.6155188],
  [54.1359271, 31.6139529],
  [54.13582, 31.61144],
  [54.1349736, 31.6069138],
  [54.13444, 31.60406],
  [54.13299, 31.59471],
  [54.1329, 31.59419],
  [54.1337833, 31.5927325],
  [54.1341026, 31.5922055],
  [54.13633, 31.58853],
  [54.13805, 31.58338],
  [54.13814, 31.576],
  [54.1371022, 31.5733885],
  [54.13599, 31.57059],
  [54.1367031, 31.5660506],
  [54.1367077, 31.5641981],
  [54.1389124, 31.5605598],
  [54.1396549, 31.5595526],
  [54.1411801, 31.558188],
  [54.14432, 31.5572],
  [54.14801, 31.55677],
  [54.1486008, 31.5560351],
  [54.1504072, 31.5561098],
  [54.1520464, 31.5546748],
  [54.1524175, 31.5492003],
  [54.1529475, 31.5463445],
  [54.1529589, 31.5427425],
  [54.15393, 31.539],
  [54.1533486, 31.5362155],
  [54.15298, 31.53445],
  [54.15144, 31.5293],
  [54.15272, 31.52493],
  [54.15599, 31.52089],
  [54.15616, 31.52063],
  [54.15745, 31.51368],
  [54.15719, 31.5033],
  [54.1589, 31.49514],
  [54.16148, 31.49248],
  [54.16492, 31.49274],
  [54.16698, 31.49446],
  [54.17126, 31.49514],
  [54.17504, 31.49815],
  [54.17831, 31.49943],
  [54.18191, 31.49514],
  [54.1830493, 31.4930395],
  [54.1851931, 31.4910664],
  [54.1852263, 31.4909249],
  [54.1852925, 31.4908258],
  [54.1853505, 31.490571],
  [54.1854417, 31.4905285],
  [54.1855452, 31.4905922],
  [54.1855825, 31.4903515],
  [54.1855866, 31.4901746],
  [54.1856446, 31.4900472],
  [54.1855949, 31.4896083],
  [54.1855286, 31.4895092],
  [54.1854292, 31.4895446],
  [54.1853547, 31.4893181],
  [54.1853505, 31.489127],
  [54.1852801, 31.4889642],
  [54.1851099, 31.4888418],
  [54.1850523, 31.4886138],
  [54.1849513, 31.4885769],
  [54.1848467, 31.4886385],
  [54.1847746, 31.4884844],
  [54.1847061, 31.4883612],
  [54.1846232, 31.4881085],
  [54.1845438, 31.4881209],
  [54.1845438, 31.4882133],
  [54.1846051, 31.4883242],
  [54.184551, 31.4884906],
  [54.1844609, 31.4885276],
  [54.1842626, 31.4884598],
  [54.1841832, 31.4882996],
  [54.1839741, 31.4879422],
  [54.183902, 31.4877696],
  [54.1837217, 31.4875231],
  [54.1836135, 31.4873383],
  [54.1834296, 31.4869932],
  [54.1832817, 31.4867898],
  [54.1831627, 31.4863708],
  [54.1830798, 31.4858286],
  [54.183069, 31.4856252],
  [54.1830906, 31.4854342],
  [54.1829283, 31.4850953],
  [54.1828418, 31.4849412],
  [54.1828129, 31.4847933],
  [54.1826723, 31.4848365],
  [54.1826038, 31.4845715],
  [54.1825028, 31.4843373],
  [54.182373, 31.4843743],
  [54.1823081, 31.48459],
  [54.1822215, 31.4842942],
  [54.1821675, 31.4841894],
  [54.1819763, 31.4841771],
  [54.1818754, 31.4840107],
  [54.1817167, 31.4836595],
  [54.1817564, 31.4834746],
  [54.1817672, 31.4833083],
  [54.1816446, 31.4831296],
  [54.1815436, 31.4830618],
  [54.1814282, 31.4829201],
  [54.1813669, 31.4827845],
  [54.1814174, 31.4825873],
  [54.1814967, 31.4823162],
  [54.1814462, 31.4820697],
  [54.1813416, 31.4820512],
  [54.1812515, 31.4821744],
  [54.1811145, 31.4824641],
  [54.1810099, 31.4824086],
  [54.1808548, 31.4821621],
  [54.1807899, 31.4819957],
  [54.1807899, 31.4818725],
  [54.180844, 31.481663],
  [54.1808909, 31.4814103],
  [54.180826, 31.4812686],
  [54.1806024, 31.4810344],
  [54.180523, 31.4807572],
  [54.180368, 31.4805538],
  [54.1801768, 31.4804121],
  [54.1800975, 31.4802334],
  [54.1801227, 31.4799376],
  [54.1800831, 31.4796048],
  [54.1800795, 31.4794015],
  [54.1800182, 31.4791488],
  [54.1799208, 31.4791304],
  [54.179827, 31.4792659],
  [54.1797369, 31.4791304],
  [54.1797188, 31.4789825],
  [54.1798306, 31.4787483],
  [54.1798883, 31.4783971],
  [54.1799821, 31.4782184],
  [54.1801336, 31.478089],
  [54.1803391, 31.4780458],
  [54.180368, 31.4779164],
  [54.180523, 31.4777254],
  [54.1808151, 31.4776761],
  [54.1810423, 31.4773988],
  [54.181403, 31.4773803],
  [54.1818357, 31.4772941],
  [54.1820953, 31.4770044],
  [54.1823189, 31.4768442],
  [54.1825497, 31.4767888],
  [54.1827841, 31.4765977],
  [54.1829969, 31.4763821],
  [54.1832601, 31.4763636],
  [54.1835161, 31.4765361],
  [54.1836063, 31.4764498],
  [54.1836351, 31.4762034],
  [54.1837361, 31.476],
  [54.183819, 31.4759692],
  [54.1839669, 31.4760863],
  [54.1843347, 31.4760986],
  [54.1845366, 31.4760062],
  [54.1846051, 31.475846],
  [54.1845907, 31.4754208],
  [54.1847061, 31.4753283],
  [54.1848143, 31.4754578],
  [54.1849297, 31.4753653],
  [54.1849801, 31.4752667],
  [54.1851027, 31.4752236],
  [54.1853155, 31.4750634],
  [54.1853551, 31.4749093],
  [54.1853768, 31.4745766],
  [54.1854381, 31.4745273],
  [54.1855787, 31.4745581],
  [54.1858636, 31.4744102],
  [54.1860222, 31.473948],
  [54.1861268, 31.4737447],
  [54.1861773, 31.4734982],
  [54.1863612, 31.4730669],
  [54.1865847, 31.4728142],
  [54.1867055, 31.4725464],
  [54.1869649, 31.4642108],
  [54.1891271, 31.4617841],
  [54.1919038, 31.4588774],
  [54.1930043, 31.4579642],
  [54.1944029, 31.4616914],
  [54.1945302, 31.4611837],
  [54.194549, 31.4608082],
  [54.1947185, 31.4605936],
  [54.1948754, 31.4605936],
  [54.1948879, 31.4603147],
  [54.1951013, 31.4599606],
  [54.195321, 31.4598962],
  [54.1955336, 31.4597254],
  [54.1955717, 31.4596441],
  [54.1957144, 31.4594815],
  [54.1956668, 31.4593432],
  [54.1957144, 31.4591644],
  [54.1957952, 31.4591644],
  [54.1958666, 31.4592294],
  [54.1959284, 31.4589692],
  [54.1960141, 31.4589773],
  [54.1960949, 31.4590424],
  [54.1961948, 31.4588391],
  [54.1962234, 31.4586602],
  [54.196328, 31.4586115],
  [54.1962899, 31.458457],
  [54.1962709, 31.4582862],
  [54.196309, 31.458148],
  [54.1962573, 31.4579947],
  [54.1963857, 31.4578532],
  [54.1964105, 31.4575559],
  [54.1966217, 31.4573931],
  [54.1966093, 31.4571736],
  [54.1967625, 31.4570392],
  [54.1967873, 31.4567985],
  [54.1966755, 31.4566357],
  [54.1965348, 31.4565507],
  [54.1965016, 31.456303],
  [54.1965596, 31.4562251],
  [54.1966921, 31.4562039],
  [54.1967087, 31.4559066],
  [54.1967501, 31.4556872],
  [54.1966507, 31.4554819],
  [54.1966093, 31.4551917],
  [54.1967377, 31.454944],
  [54.1968991, 31.4547387],
  [54.1970358, 31.4546679],
  [54.1970524, 31.4544697],
  [54.1970151, 31.454137],
  [54.1970979, 31.4537831],
  [54.1970731, 31.4534787],
  [54.197131, 31.4529903],
  [54.1970606, 31.4526859],
  [54.1971062, 31.4525868],
  [54.1972718, 31.4524877],
  [54.1974416, 31.4522542],
  [54.1975286, 31.4519286],
  [54.197483, 31.4516171],
  [54.1973422, 31.4514685],
  [54.1973712, 31.4512986],
  [54.1975079, 31.4510579],
  [54.1976942, 31.4508172],
  [54.1980006, 31.4508243],
  [54.1981538, 31.4508668],
  [54.1982822, 31.4508456],
  [54.1983567, 31.4509305],
  [54.1984975, 31.4509447],
  [54.198659, 31.4506757],
  [54.1987294, 31.4503713],
  [54.1987666, 31.4499749],
  [54.1986631, 31.4498758],
  [54.1986673, 31.4497909],
  [54.1987873, 31.4495785],
  [54.1987998, 31.4493803],
  [54.1987087, 31.4492034],
  [54.1985099, 31.4490618],
  [54.1984768, 31.4488141],
  [54.1983733, 31.4485168],
  [54.1983733, 31.4480921],
  [54.1982946, 31.4478585],
  [54.1980673, 31.4476464],
  [54.1980466, 31.447342],
  [54.1981253, 31.447073],
  [54.1980673, 31.4468748],
  [54.1980921, 31.4463794],
  [54.1982164, 31.4461387],
  [54.1982164, 31.445898],
  [54.1981377, 31.4454875],
  [54.1981087, 31.4450345],
  [54.1981791, 31.4448504],
  [54.1983861, 31.4446168],
  [54.1986263, 31.4443408],
  [54.1988664, 31.44427],
  [54.19909, 31.4441921],
  [54.1993468, 31.4442771],
  [54.1999099, 31.4442134],
  [54.2002121, 31.4438807],
  [54.2004075, 31.4435822],
  [54.2008745, 31.443324],
  [54.20302, 31.44219],
  [54.20654, 31.43721],
  [54.20826, 31.43223],
  [54.20903, 31.42442],
  [54.21058, 31.41232],
  [54.21135, 31.40039],
  [54.21152, 31.39043],
  [54.2092, 31.38416],
  [54.21006, 31.38047],
  [54.21306, 31.37901],
  [54.21598, 31.38159],
  [54.21933, 31.38416],
  [54.22156, 31.38914],
  [54.21993, 31.39541],
  [54.2171, 31.40236],
  [54.21676, 31.40648],
  [54.21839, 31.4106],
  [54.22233, 31.4106],
  [54.22414, 31.40588],
  [54.22311, 31.40408],
  [54.22182, 31.40124],
  [54.22216, 31.39669],
  [54.22414, 31.39635],
  [54.22457, 31.39627],
  [54.22517, 31.39326],
  [54.22414, 31.38863],
  [54.22328, 31.38485],
  [54.22414, 31.38434],
  [54.22671, 31.3827],
  [54.23246, 31.38288],
  [54.23813, 31.36108],
  [54.23847, 31.35738],
  [54.24182, 31.35223],
  [54.24251, 31.34614],
  [54.24457, 31.34168],
  [54.24705, 31.33919],
  [54.24877, 31.33644],
  [54.24808, 31.33249],
  [54.24491, 31.32794],
  [54.24362, 31.32451],
  [54.2440424, 31.3190752],
  [54.24414, 31.31782],
  [54.24851, 31.31352],
  [54.25246, 31.31198],
  [54.25881, 31.31155],
  [54.26988, 31.30898],
  [54.27701, 31.30941],
  [54.27718, 31.30941],
  [54.2825, 31.31044],
  [54.29366, 31.31936],
  [54.29589, 31.32039],
  [54.29813, 31.31756],
  [54.30336, 31.31155],
  [54.30568, 31.31112],
  [54.30928, 31.31756],
  [54.31194, 31.32022],
  [54.31529, 31.31756],
  [54.31623, 31.31258],
  [54.31469, 31.30657],
  [54.31392, 31.29962],
  [54.31392, 31.29953],
  [54.31477, 31.28906],
  [54.31658, 31.2858],
  [54.31967, 31.2858],
  [54.32327, 31.29095],
  [54.32859, 31.29953],
  [54.32876, 31.29988],
  [54.33615, 31.31455],
  [54.3405871, 31.3227195],
  [54.3406899, 31.3222696],
  [54.3407641, 31.3220784],
  [54.3407187, 31.3218944],
  [54.3406568, 31.3216183],
  [54.3406775, 31.321406],
  [54.3407806, 31.3212927],
  [54.3409209, 31.3212432],
  [54.3409663, 31.3212149],
  [54.3409787, 31.3210733],
  [54.3410365, 31.3207194],
  [54.3411231, 31.3205],
  [54.3411809, 31.3201036],
  [54.3412634, 31.3199691],
  [54.3413501, 31.3195727],
  [54.3413377, 31.3194665],
  [54.3412139, 31.3194878],
  [54.3411273, 31.3197213],
  [54.340987, 31.3197284],
  [54.3408979, 31.3196389],
  [54.3409792, 31.3192312],
  [54.340998, 31.3190059],
  [54.3411043, 31.3186519],
  [54.3412606, 31.3186988],
  [54.3413756, 31.318668],
  [54.3414546, 31.3186064],
  [54.3414618, 31.3183167],
  [54.3414546, 31.318021],
  [54.341469, 31.3178669],
  [54.3417348, 31.3178299],
  [54.3418749, 31.3178792],
  [54.341997, 31.3179224],
  [54.3421659, 31.3177313],
  [54.34227, 31.3172384],
  [54.3423491, 31.316807],
  [54.3424317, 31.3167701],
  [54.3425179, 31.3168317],
  [54.3426005, 31.3164866],
  [54.3427298, 31.3163264],
  [54.3428771, 31.3163387],
  [54.3429525, 31.3165914],
  [54.3431573, 31.3168317],
  [54.3432148, 31.3170104],
  [54.3434339, 31.3170227],
  [54.343538, 31.317109],
  [54.3437572, 31.3172137],
  [54.3439942, 31.3173247],
  [54.3440732, 31.3175403],
  [54.3441559, 31.3175896],
  [54.3442528, 31.3175773],
  [54.3443247, 31.3176636],
  [54.3443893, 31.3176328],
  [54.3444324, 31.3174602],
  [54.3444971, 31.3174232],
  [54.3445977, 31.3172692],
  [54.3448204, 31.3170104],
  [54.344982, 31.3166653],
  [54.3451903, 31.316616],
  [54.345413, 31.3165606],
  [54.345528, 31.3163079],
  [54.3454777, 31.3160491],
  [54.3455711, 31.3159197],
  [54.345686, 31.3158149],
  [54.345783, 31.3160121],
  [54.3458943, 31.3159813],
  [54.3460452, 31.3158766],
  [54.3460524, 31.3155746],
  [54.3459698, 31.3153343],
  [54.3458297, 31.3149461],
  [54.3458441, 31.3147551],
  [54.3459015, 31.3146811],
  [54.3459913, 31.3144654],
  [54.3459698, 31.3142744],
  [54.3460416, 31.3141635],
  [54.3460057, 31.3137814],
  [54.3460227, 31.3135504],
  [54.3460309, 31.3133098],
  [54.3461465, 31.3130974],
  [54.3463899, 31.3130762],
  [54.3466746, 31.3130479],
  [54.3468602, 31.3128001],
  [54.3470748, 31.3126515],
  [54.3471862, 31.3126727],
  [54.3471697, 31.3127435],
  [54.3472151, 31.3128638],
  [54.347343, 31.3127789],
  [54.3474337, 31.3125665],
  [54.3474048, 31.3123329],
  [54.3473306, 31.3123613],
  [54.3472192, 31.3124745],
  [54.347149, 31.3123613],
  [54.3471697, 31.3121631],
  [54.347149, 31.3119224],
  [54.3473471, 31.3116322],
  [54.3475616, 31.3113703],
  [54.3477762, 31.3109385],
  [54.3479536, 31.3106341],
  [54.3480525, 31.3106361],
  [54.3483166, 31.3106412],
  [54.3484775, 31.3107545],
  [54.3488035, 31.3107191],
  [54.3490056, 31.3110022],
  [54.3491871, 31.3110093],
  [54.3493604, 31.3107191],
  [54.3494924, 31.3107545],
  [54.3495956, 31.3109456],
  [54.3496698, 31.3113703],
  [54.3497647, 31.3113844],
  [54.3498844, 31.3112924],
  [54.3500246, 31.3111013],
  [54.3501278, 31.3109385],
  [54.3502144, 31.3110376],
  [54.3502515, 31.3112146],
  [54.350268, 31.3114552],
  [54.3502845, 31.3115756],
  [54.3504372, 31.311434],
  [54.3505568, 31.311434],
  [54.3506393, 31.3116605],
  [54.3506517, 31.3118233],
  [54.350627, 31.3119578],
  [54.3507507, 31.3121206],
  [54.3508951, 31.3123188],
  [54.3510973, 31.3123966],
  [54.3511921, 31.3122692],
  [54.3512738, 31.3121835],
  [54.351546, 31.3121742],
  [54.3515568, 31.3124637],
  [54.3516167, 31.3125104],
  [54.3517855, 31.3124917],
  [54.3518454, 31.3125478],
  [54.3518562, 31.3127346],
  [54.3519488, 31.3127626],
  [54.3520141, 31.3129307],
  [54.3520631, 31.3133136],
  [54.3520631, 31.3136499],
  [54.3521447, 31.3139861],
  [54.3522427, 31.3143784],
  [54.3524278, 31.3143784],
  [54.3525965, 31.3142943],
  [54.3526238, 31.3141916],
  [54.3527381, 31.3140889],
  [54.3531082, 31.3141075],
  [54.3531899, 31.3140328],
  [54.3533205, 31.3140795],
  [54.3534892, 31.3143691],
  [54.3537178, 31.314341],
  [54.3538594, 31.3144998],
  [54.3540444, 31.3147053],
  [54.3542622, 31.3146586],
  [54.3543656, 31.3150509],
  [54.3544908, 31.3152937],
  [54.3545778, 31.3152564],
  [54.3546105, 31.3150042],
  [54.3546377, 31.3147427],
  [54.3547792, 31.3147053],
  [54.3548935, 31.3148361],
  [54.3548772, 31.3151723],
  [54.3549099, 31.3154712],
  [54.3551276, 31.3154151],
  [54.3553072, 31.3153404],
  [54.3554868, 31.3150789],
  [54.3556175, 31.3150882],
  [54.3556828, 31.315275],
  [54.3557862, 31.3153778],
  [54.355944, 31.3153031],
  [54.3560801, 31.3154338],
  [54.3562978, 31.3152937],
  [54.3565101, 31.3151163],
  [54.3567278, 31.3148454],
  [54.3571414, 31.3144064],
  [54.3573047, 31.3138927],
  [54.3575333, 31.3134911],
  [54.3577802, 31.3129346],
  [54.3580115, 31.3121728],
  [54.3582053, 31.3120441],
  [54.3584241, 31.3121084],
  [54.3585679, 31.3120226],
  [54.3585742, 31.3118402],
  [54.3586429, 31.3116042],
  [54.3589743, 31.3115076],
  [54.3591806, 31.3112287],
  [54.3592881, 31.3108062],
  [54.3593835, 31.3104896],
  [54.3593773, 31.310318],
  [54.3594335, 31.3101034],
  [54.359471, 31.3099532],
  [54.3595867, 31.3099371],
  [54.3597649, 31.3099371],
  [54.359818, 31.3098942],
  [54.359868, 31.3097333],
  [54.3598774, 31.309406],
  [54.3597992, 31.3092558],
  [54.3598493, 31.3090573],
  [54.3598555, 31.3089554],
  [54.3600243, 31.3089232],
  [54.3601775, 31.3090198],
  [54.3604119, 31.308993],
  [54.3604622, 31.3089995],
  [54.3605369, 31.3090091],
  [54.3606432, 31.309111],
  [54.3607401, 31.3091217],
  [54.3609308, 31.3088964],
  [54.3611902, 31.3087462],
  [54.361359, 31.3087945],
  [54.3614997, 31.3087677],
  [54.3615403, 31.3086711],
  [54.361434, 31.3085155],
  [54.3614403, 31.3083063],
  [54.3615997, 31.3081937],
  [54.3618341, 31.3081615],
  [54.3620091, 31.3080757],
  [54.3622686, 31.3080006],
  [54.3624217, 31.3080649],
  [54.3625999, 31.3080864],
  [54.362703, 31.3080274],
  [54.3627655, 31.3078664],
  [54.3627687, 31.3076572],
  [54.3628218, 31.3074963],
  [54.3630156, 31.3073944],
  [54.3630937, 31.3072603],
  [54.3632187, 31.3067346],
  [54.3633375, 31.3065575],
  [54.3634782, 31.3063644],
  [54.3636844, 31.3063054],
  [54.3638251, 31.3061176],
  [54.3638939, 31.3059031],
  [54.3639032, 31.3055436],
  [54.3639407, 31.3052647],
  [54.3640189, 31.3051574],
  [54.3642158, 31.3050877],
  [54.3645189, 31.3050126],
  [54.3647221, 31.3050287],
  [54.3648096, 31.3048785],
  [54.3648752, 31.3045781],
  [54.364869, 31.3043635],
  [54.3647815, 31.3041006],
  [54.3646815, 31.3040362],
  [54.3647377, 31.3039182],
  [54.3648377, 31.3038002],
  [54.3649878, 31.3036876],
  [54.3650534, 31.3035642],
  [54.3651878, 31.3036286],
  [54.3652378, 31.3037948],
  [54.3653097, 31.303827],
  [54.3654003, 31.3037251],
  [54.3654816, 31.3035803],
  [54.3656628, 31.3033818],
  [54.3658222, 31.303296],
  [54.366066, 31.3031887],
  [54.3661629, 31.3030331],
  [54.3661535, 31.3028936],
  [54.3660316, 31.3025825],
  [54.3658785, 31.3024269],
  [54.3658941, 31.3023733],
  [54.366141, 31.3021855],
  [54.3662817, 31.302148],
  [54.3663129, 31.3019495],
  [54.3663848, 31.3017832],
  [54.3664473, 31.3017725],
  [54.3665129, 31.3016652],
  [54.3666848, 31.3016276],
  [54.3668036, 31.3017242],
  [54.3669161, 31.3018047],
  [54.3670036, 31.3016974],
  [54.3671411, 31.3014721],
  [54.3672067, 31.3011556],
  [54.3672568, 31.3007479],
  [54.3673255, 31.3005279],
  [54.3673036, 31.3003992],
  [54.3673693, 31.3003992],
  [54.3673911, 31.3002329],
  [54.3675411, 31.2999593],
  [54.3676537, 31.299455],
  [54.3677224, 31.2992887],
  [54.3677849, 31.2993102],
  [54.3679631, 31.2992941],
  [54.3681068, 31.299219],
  [54.3681756, 31.2992512],
  [54.3682662, 31.2992458],
  [54.3683162, 31.2991707],
  [54.3683287, 31.2989937],
  [54.3682974, 31.2988113],
  [54.3682287, 31.2986718],
  [54.3681881, 31.2984519],
  [54.3682256, 31.2981622],
  [54.3681756, 31.2979798],
  [54.3681381, 31.2976901],
  [54.3682068, 31.2975238],
  [54.3683287, 31.297084],
  [54.3684318, 31.2967728],
  [54.3683725, 31.2966334],
  [54.3683443, 31.2964724],
  [54.3684193, 31.296172],
  [54.3685631, 31.2958984],
  [54.3685568, 31.2956087],
  [54.368635, 31.2953888],
  [54.3687943, 31.2952654],
  [54.3688537, 31.295142],
  [54.3688787, 31.2950133],
  [54.3688006, 31.2948792],
  [54.3687256, 31.2947129],
  [54.3686443, 31.2946646],
  [54.3686006, 31.2945466],
  [54.3684943, 31.2945949],
  [54.3684443, 31.2945037],
  [54.3683818, 31.2943588],
  [54.3683474, 31.2941496],
  [54.3684131, 31.2939619],
  [54.3685725, 31.2936346],
  [54.3686037, 31.2935327],
  [54.3686131, 31.2933289],
  [54.3685006, 31.2931518],
  [54.3684131, 31.2930606],
  [54.3684412, 31.2928246],
  [54.3685131, 31.2927495],
  [54.368485, 31.2925832],
  [54.3685756, 31.2923096],
  [54.3686975, 31.292036],
  [54.3688412, 31.2917464],
  [54.3688193, 31.291564],
  [54.3688568, 31.2914352],
  [54.3689506, 31.2912797],
  [54.3689537, 31.2909471],
  [54.3690037, 31.2906788],
  [54.3691381, 31.2903409],
  [54.3692506, 31.2900673],
  [54.3692975, 31.2895791],
  [54.3693756, 31.2891178],
  [54.3694287, 31.2890105],
  [54.3694381, 31.2888281],
  [54.36956, 31.2884848],
  [54.3696631, 31.2883668],
  [54.3697006, 31.2882059],
  [54.3697006, 31.2880771],
  [54.3696819, 31.2879323],
  [54.3697944, 31.287766],
  [54.3699319, 31.2877767],
  [54.3700163, 31.2878196],
  [54.3703975, 31.2877338],
  [54.3705819, 31.2878142],
  [54.37081, 31.2878196],
  [54.3708819, 31.287648],
  [54.3710569, 31.2875836],
  [54.3712537, 31.2875836],
  [54.3713662, 31.2875192],
  [54.3714225, 31.2874709],
  [54.3714037, 31.2872778],
  [54.3714225, 31.2871866],
  [54.3716694, 31.2871276],
  [54.3717475, 31.2871169],
  [54.3719037, 31.2871544],
  [54.3720287, 31.287074],
  [54.3720975, 31.2868218],
  [54.3722068, 31.2868057],
  [54.3722318, 31.2868755],
  [54.37231, 31.2868755],
  [54.3723912, 31.2866877],
  [54.3723568, 31.2866126],
  [54.3724037, 31.2864571],
  [54.3724193, 31.2863605],
  [54.3724631, 31.2862425],
  [54.3725068, 31.2861084],
  [54.3726099, 31.2861245],
  [54.3726599, 31.2860869],
  [54.3727131, 31.2859367],
  [54.3728881, 31.285824],
  [54.3730318, 31.2858562],
  [54.3731162, 31.2859206],
  [54.3731662, 31.2859689],
  [54.3731287, 31.2861245],
  [54.373263, 31.2862693],
  [54.3733786, 31.2861888],
  [54.3734036, 31.2860064],
  [54.3732974, 31.2857758],
  [54.3732787, 31.2856685],
  [54.3734099, 31.2855773],
  [54.3735255, 31.2855505],
  [54.3735161, 31.285411],
  [54.3733943, 31.2853091],
  [54.3733786, 31.2850945],
  [54.373438, 31.2851106],
  [54.3734724, 31.2850569],
  [54.3735818, 31.2849818],
  [54.3736818, 31.2847565],
  [54.3737817, 31.284601],
  [54.3738349, 31.2846707],
  [54.3738317, 31.2849067],
  [54.3739567, 31.2848906],
  [54.3740005, 31.2848155],
  [54.3739973, 31.2846492],
  [54.3740442, 31.2845312],
  [54.3741223, 31.2843757],
  [54.3741817, 31.2845044],
  [54.3742473, 31.2844078],
  [54.3743004, 31.2842308],
  [54.3742661, 31.2841557],
  [54.3741723, 31.2840967],
  [54.3741723, 31.2840001],
  [54.3742973, 31.2837051],
  [54.3743067, 31.2835925],
  [54.3744348, 31.2834852],
  [54.3745379, 31.2832277],
  [54.3747129, 31.2830185],
  [54.3747692, 31.2828146],
  [54.3748285, 31.2826161],
  [54.3749535, 31.2825303],
  [54.3750222, 31.2823908],
  [54.3750191, 31.2822084],
  [54.3750004, 31.2818329],
  [54.3749316, 31.2815647],
  [54.3749441, 31.2814091],
  [54.3749848, 31.281393],
  [54.3750472, 31.2813501],
  [54.375091, 31.2811785],
  [54.3750347, 31.2809961],
  [54.3749441, 31.2807547],
  [54.3748941, 31.280583],
  [54.3748223, 31.2804221],
  [54.374741, 31.2803953],
  [54.3746067, 31.2803792],
  [54.3745098, 31.2802451],
  [54.3744786, 31.2800519],
  [54.3744786, 31.2799232],
  [54.3745535, 31.27995],
  [54.374616, 31.27995],
  [54.374641, 31.2797086],
  [54.374641, 31.2794779],
  [54.3745723, 31.2793921],
  [54.3744817, 31.2794833],
  [54.3743879, 31.2793438],
  [54.3742192, 31.2791829],
  [54.3742005, 31.2789683],
  [54.374188, 31.2786035],
  [54.3742411, 31.2783997],
  [54.3743192, 31.2782709],
  [54.3744692, 31.2782495],
  [54.3746223, 31.2780295],
  [54.3746973, 31.2778686],
  [54.3747785, 31.2778472],
  [54.3748223, 31.2776916],
  [54.3748504, 31.2774287],
  [54.374766, 31.2772463],
  [54.3747442, 31.2770532],
  [54.3746629, 31.2769298],
  [54.3746035, 31.2766563],
  [54.3746317, 31.2765812],
  [54.3747035, 31.2765382],
  [54.3747567, 31.2764417],
  [54.3747285, 31.2763237],
  [54.3748285, 31.2761145],
  [54.3748785, 31.2761145],
  [54.3749473, 31.2761305],
  [54.3750035, 31.2761735],
  [54.3750472, 31.2761037],
  [54.3750285, 31.2760125],
  [54.3750191, 31.2758731],
  [54.3749848, 31.2757819],
  [54.3750722, 31.2755405],
  [54.3750847, 31.27546],
  [54.3751597, 31.2752991],
  [54.3752222, 31.2752186],
  [54.3753191, 31.2750308],
  [54.3756253, 31.2747787],
  [54.3757065, 31.2747626],
  [54.3757565, 31.2746446],
  [54.3758431, 31.2746567],
  [54.3760562, 31.274299],
  [54.3761368, 31.2742665],
  [54.3762267, 31.2742339],
  [54.3763451, 31.27399],
  [54.3764162, 31.2739737],
  [54.3763593, 31.2737135],
  [54.3762788, 31.2735997],
  [54.3762362, 31.2733802],
  [54.3763025, 31.2730468],
  [54.3764209, 31.2728273],
  [54.3764919, 31.2729818],
  [54.3767666, 31.2726321],
  [54.3768566, 31.2724614],
  [54.3767666, 31.2722662],
  [54.3768756, 31.2720955],
  [54.376975, 31.2720548],
  [54.3769371, 31.2719166],
  [54.3769703, 31.2716727],
  [54.3768377, 31.2714857],
  [54.376904, 31.2714044],
  [54.3769797, 31.271445],
  [54.3770697, 31.2712661],
  [54.376994, 31.2710466],
  [54.3768661, 31.2710222],
  [54.376814, 31.2707214],
  [54.3767098, 31.2705831],
  [54.3767761, 31.2703961],
  [54.3768803, 31.2702742],
  [54.3768661, 31.2700628],
  [54.3767714, 31.2701522],
  [54.3767051, 31.2700465],
  [54.3767145, 31.269518],
  [54.3767998, 31.2694529],
  [54.3768898, 31.2690383],
  [54.3769845, 31.2684203],
  [54.3768945, 31.2678186],
  [54.3769655, 31.2675666],
  [54.3770508, 31.2675584],
  [54.3771266, 31.2676723],
  [54.3772497, 31.2676316],
  [54.3773255, 31.2677536],
  [54.3774533, 31.2676885],
  [54.3775433, 31.2673308],
  [54.3774675, 31.2668266],
  [54.3775291, 31.2661436],
  [54.3776759, 31.2653631],
  [54.3776686, 31.265033],
  [54.3776617, 31.2647207],
  [54.3777659, 31.2643304],
  [54.3778748, 31.2643548],
  [54.3780074, 31.2643548],
  [54.3781874, 31.2639483],
  [54.3783247, 31.263184],
  [54.3784005, 31.2630458],
  [54.3784384, 31.2628425],
  [54.3785331, 31.2623546],
  [54.3786183, 31.2622733],
  [54.3788314, 31.2623058],
  [54.3789167, 31.2622408],
  [54.3790351, 31.2618993],
  [54.3792624, 31.2618017],
  [54.3793855, 31.2615741],
  [54.3793666, 31.261257],
  [54.3792482, 31.2611919],
  [54.3791913, 31.2613545],
  [54.3791156, 31.2614196],
  [54.3790587, 31.2612651],
  [54.3790777, 31.2611594],
  [54.3792197, 31.2609561],
  [54.3793239, 31.2605414],
  [54.3793334, 31.2603219],
  [54.3792955, 31.2601755],
  [54.3791392, 31.2601186],
  [54.3789782, 31.2601999],
  [54.3789498, 31.2600454],
  [54.3790303, 31.2599072],
  [54.3791441, 31.2596584],
  [54.3790843, 31.2590513],
  [54.3791604, 31.2588085],
  [54.3792039, 31.2585189],
  [54.3791604, 31.2581827],
  [54.3790027, 31.2579212],
  [54.3787252, 31.257725],
  [54.378698, 31.257613],
  [54.3787633, 31.2575009],
  [54.3787742, 31.2573795],
  [54.378611, 31.2571833],
  [54.3783825, 31.2572394],
  [54.378339, 31.2570806],
  [54.3784152, 31.2570152],
  [54.378426, 31.2568471],
  [54.37829, 31.2568191],
  [54.378154, 31.2565389],
  [54.3782084, 31.2563427],
  [54.378154, 31.2561746],
  [54.3781921, 31.2558664],
  [54.3784532, 31.2558477],
  [54.3785348, 31.2557543],
  [54.3785348, 31.2555301],
  [54.3783608, 31.2551939],
  [54.3782465, 31.2546989],
  [54.3783336, 31.2545214],
  [54.3785457, 31.2546895],
  [54.3787144, 31.254867],
  [54.3788395, 31.2547082],
  [54.3789428, 31.2544934],
  [54.3790516, 31.2542599],
  [54.3791713, 31.2543346],
  [54.3792475, 31.2543346],
  [54.3793726, 31.2539704],
  [54.3794759, 31.2537088],
  [54.379601, 31.2533726],
  [54.3797153, 31.252943],
  [54.379922, 31.2529336],
  [54.379922, 31.2527748],
  [54.3800906, 31.2526441],
  [54.3801831, 31.2525413],
  [54.3802864, 31.2526441],
  [54.380368, 31.2528589],
  [54.3804116, 31.2531578],
  [54.3805149, 31.2532045],
  [54.3805367, 31.2529616],
  [54.3806781, 31.2528963],
  [54.3807216, 31.2530644],
  [54.3808141, 31.2530644],
  [54.380961, 31.2528309],
  [54.3810262, 31.2525974],
  [54.3810915, 31.2526254],
  [54.3811677, 31.2525507],
  [54.3812112, 31.2522051],
  [54.3814124, 31.2522705],
  [54.3814886, 31.2524386],
  [54.3817007, 31.2525507],
  [54.382038, 31.2529149],
  [54.3823045, 31.2526067],
  [54.3824949, 31.2527095],
  [54.3826309, 31.2525227],
  [54.3827614, 31.2526628],
  [54.3828974, 31.2526628],
  [54.3829246, 31.2528869],
  [54.3830714, 31.2529897],
  [54.3833162, 31.2528496],
  [54.3834739, 31.2529803],
  [54.3834848, 31.2532138],
  [54.3835447, 31.2532885],
  [54.3837133, 31.2531671],
  [54.3838112, 31.2532138],
  [54.3838275, 31.2536154],
  [54.3837241, 31.2538583],
  [54.3838329, 31.2541385],
  [54.3838329, 31.2544467],
  [54.383958, 31.2547269],
  [54.384094, 31.2547643],
  [54.3841702, 31.2551285],
  [54.3842626, 31.255306],
  [54.3843279, 31.2551565],
  [54.3845618, 31.2550631],
  [54.3847902, 31.2551565],
  [54.3846869, 31.2554181],
  [54.3847195, 31.255745],
  [54.3848065, 31.2560999],
  [54.3849697, 31.2560999],
  [54.385073, 31.2561279],
  [54.3853885, 31.2560345],
  [54.385568, 31.2562587],
  [54.3857692, 31.2564922],
  [54.3859977, 31.2565015],
  [54.3862424, 31.2565202],
  [54.3862642, 31.2567537],
  [54.3863349, 31.2569778],
  [54.3865035, 31.2571366],
  [54.3865905, 31.2574262],
  [54.3868788, 31.2573795],
  [54.3869712, 31.2575943],
  [54.3870963, 31.2574542],
  [54.3871888, 31.2571366],
  [54.3872975, 31.2570619],
  [54.38739, 31.257146],
  [54.3874879, 31.2572861],
  [54.3876347, 31.2574168],
  [54.3877707, 31.257641],
  [54.3878686, 31.2574355],
  [54.3879991, 31.2575476],
  [54.3880644, 31.2577811],
  [54.3882711, 31.2579305],
  [54.3885375, 31.2583788],
  [54.3886898, 31.2583415],
  [54.3886844, 31.2581267],
  [54.388766, 31.2579585],
  [54.3889074, 31.2581734],
  [54.3891738, 31.2582761],
  [54.389337, 31.2581734],
  [54.3895056, 31.2582854],
  [54.3897068, 31.2583041],
  [54.3898536, 31.2584442],
  [54.3898373, 31.2585843],
  [54.3899733, 31.2587805],
  [54.3899896, 31.2589766],
  [54.3902071, 31.2592475],
  [54.3902887, 31.2592942],
  [54.3902942, 31.2590513],
  [54.3903322, 31.2589766],
  [54.3904573, 31.2591541],
  [54.3907183, 31.259948],
  [54.3908597, 31.2600507],
  [54.3909467, 31.2597798],
  [54.3910392, 31.2598639],
  [54.3911371, 31.2602188],
  [54.3912948, 31.2603216],
  [54.3914144, 31.2604243],
  [54.3914144, 31.2606018],
  [54.3914743, 31.2607792],
  [54.3916156, 31.260882],
  [54.3917063, 31.2611072],
  [54.3917996, 31.2608853],
  [54.3919216, 31.2611072],
  [54.3920292, 31.2614892],
  [54.3922301, 31.2618589],
  [54.3922875, 31.2621794],
  [54.3927109, 31.2626847],
  [54.3930051, 31.2628695],
  [54.3932347, 31.2633255],
  [54.3935934, 31.2633255],
  [54.3936939, 31.2636706],
  [54.3937872, 31.2639541],
  [54.393945, 31.2640157],
  [54.3940024, 31.2637815],
  [54.394067, 31.2634364],
  [54.3941818, 31.2634241],
  [54.3942177, 31.2634611],
  [54.3943468, 31.2637076],
  [54.3944042, 31.2635104],
  [54.394519, 31.2634241],
  [54.394885, 31.2633502],
  [54.3949424, 31.2636583],
  [54.395007, 31.2637815],
  [54.3950428, 31.2641759],
  [54.3958967, 31.2647305],
  [54.3962195, 31.2652111],
  [54.3967289, 31.2660738],
  [54.3971235, 31.2669858],
  [54.3972383, 31.2673802],
  [54.3975612, 31.2680457],
  [54.3979988, 31.2681443],
  [54.3983432, 31.2686249],
  [54.3985872, 31.2690809],
  [54.3991516, 31.2694572],
  [54.399214, 31.2696825],
  [54.3996699, 31.2699936],
  [54.3997886, 31.2701331],
  [54.3999697, 31.2701331],
  [54.4001196, 31.2703799],
  [54.4004444, 31.2702511],
  [54.4006942, 31.2701653],
  [54.4007879, 31.2703155],
  [54.4009003, 31.2702082],
  [54.4009315, 31.2698112],
  [54.4011064, 31.2698327],
  [54.4011876, 31.2696503],
  [54.4013624, 31.2695323],
  [54.4013999, 31.2692748],
  [54.4014311, 31.2691675],
  [54.4016622, 31.2686633],
  [54.4018433, 31.2686633],
  [54.402012, 31.2684594],
  [54.4020369, 31.2682556],
  [54.4020744, 31.2678586],
  [54.4023554, 31.2678157],
  [54.4024616, 31.2676011],
  [54.4024803, 31.2673436],
  [54.4025365, 31.2671612],
  [54.4026677, 31.2672149],
  [54.4028738, 31.2671612],
  [54.4028301, 31.2667857],
  [54.4029175, 31.2666784],
  [54.4031985, 31.2666462],
  [54.4032485, 31.2663351],
  [54.4035295, 31.2662922],
  [54.4037356, 31.2660669],
  [54.4039042, 31.2658738],
  [54.4042789, 31.2653588],
  [54.4044475, 31.2649833],
  [54.4044288, 31.2647365],
  [54.4046036, 31.2645434],
  [54.4048284, 31.2645863],
  [54.4049846, 31.2644039],
  [54.404997, 31.2641357],
  [54.4048035, 31.2640284],
  [54.4046536, 31.2640606],
  [54.4046473, 31.263846],
  [54.4047597, 31.2637924],
  [54.4048534, 31.2636422],
  [54.4049034, 31.263095],
  [54.4051282, 31.2628697],
  [54.4052593, 31.2622367],
  [54.4054716, 31.2620543],
  [54.4058213, 31.262065],
  [54.406171, 31.2613998],
  [54.4062397, 31.2610458],
  [54.4064833, 31.260917],
  [54.4068517, 31.2608634],
  [54.4070328, 31.2604664],
  [54.4071951, 31.2598442],
  [54.4071202, 31.259018],
  [54.4073138, 31.2580632],
  [54.4075948, 31.257398],
  [54.4079569, 31.2573658],
  [54.4085626, 31.257752],
  [54.4091621, 31.2578808],
  [54.4099576, 31.258329],
  [54.4106208, 31.2589548],
  [54.4107947, 31.2588053],
  [54.4109143, 31.2585625],
  [54.4109143, 31.2581982],
  [54.4109197, 31.257834],
  [54.4111589, 31.2572549],
  [54.4114089, 31.2565357],
  [54.4115938, 31.2558819],
  [54.4125787, 31.2551938],
  [54.4134987, 31.2543982],
  [54.4146501, 31.2541516],
  [54.4152208, 31.2535508],
  [54.4169615, 31.2529717],
  [54.4184079, 31.2527575],
  [54.4187783, 31.2521575],
  [54.4192736, 31.2512357],
  [54.42017, 31.2507371],
  [54.4217213, 31.2511031],
  [54.4234153, 31.2514286],
  [54.42369, 31.25138],
  [54.4253329, 31.2500667],
  [54.4269463, 31.2504045],
  [54.42979, 31.24838],
  [54.4308136, 31.2467932],
  [54.43228, 31.24452],
  [54.43279, 31.23842],
  [54.43434, 31.23542],
  [54.43477, 31.23525],
  [54.4364502, 31.2358913],
  [54.4402062, 31.2377984],
  [54.4431846, 31.2373326],
  [54.44996, 31.23628],
  [54.4523871, 31.2368],
  [54.4532075, 31.2365117],
  [54.4538338, 31.2372552],
  [54.4547158, 31.237058],
  [54.4557919, 31.2367545],
  [54.4562947, 31.2361779],
  [54.4583057, 31.2354193],
  [54.4595669, 31.2353434],
  [54.4601049, 31.2352524],
  [54.4609075, 31.2345393],
  [54.461763, 31.2348276],
  [54.4630153, 31.235571],
  [54.4638883, 31.235829],
  [54.4644792, 31.2356621],
  [54.4650844, 31.2356208],
  [54.466238, 31.234505],
  [54.4669599, 31.2326547],
  [54.4675753, 31.231079],
  [54.4676828, 31.2305367],
  [54.4675049, 31.2299754],
  [54.4671712, 31.2296947],
  [54.4667115, 31.2291014],
  [54.4664037, 31.2284315],
  [54.4660737, 31.2276022],
  [54.4658661, 31.2264539],
  [54.4658587, 31.2262179],
  [54.4659774, 31.2260967],
  [54.466185, 31.2261732],
  [54.4675345, 31.2259563],
  [54.4676865, 31.2258522],
  [54.4677644, 31.2256866],
  [54.4678385, 31.2255289],
  [54.4680017, 31.2254268],
  [54.4681944, 31.2255481],
  [54.468339, 31.2255353],
  [54.4684391, 31.2255672],
  [54.4685874, 31.2253375],
  [54.468606, 31.2251589],
  [54.4687543, 31.2249101],
  [54.4690138, 31.2246677],
  [54.4691472, 31.2247506],
  [54.4692473, 31.2246805],
  [54.469303, 31.2245529],
  [54.4694179, 31.2245592],
  [54.4694661, 31.2240553],
  [54.4695328, 31.2238639],
  [54.4696922, 31.2239149],
  [54.4698368, 31.2238511],
  [54.4699777, 31.2235704],
  [54.469974, 31.2233663],
  [54.4700296, 31.2233216],
  [54.4701556, 31.2234429],
  [54.470341, 31.2233089],
  [54.4704114, 31.223143],
  [54.4706932, 31.2231749],
  [54.4706635, 31.2233727],
  [54.4708489, 31.2235768],
  [54.4709404, 31.2238459],
  [54.4712085, 31.2237815],
  [54.4712433, 31.2238488],
  [54.4712598, 31.2236244],
  [54.4711569, 31.2234313],
  [54.4709917, 31.2231256],
  [54.4710447, 31.2228412],
  [54.4708857, 31.2223048],
  [54.4707361, 31.2219937],
  [54.4706581, 31.2219668],
  [54.4705896, 31.2218595],
  [54.470655, 31.221586],
  [54.4705989, 31.2212909],
  [54.4705085, 31.2212748],
  [54.4704368, 31.2213982],
  [54.4703869, 31.2214679],
  [54.4703495, 31.2212695],
  [54.4700939, 31.2212212],
  [54.470016, 31.2212212],
  [54.4699006, 31.2213821],
  [54.4696762, 31.2209637],
  [54.4695078, 31.2209583],
  [54.4694361, 31.2210388],
  [54.4693083, 31.2210334],
  [54.4692834, 31.2208832],
  [54.4693083, 31.2208081],
  [54.4692896, 31.2206847],
  [54.4691775, 31.2205921],
  [54.4686322, 31.2178494],
  [54.4686113, 31.2169653],
  [54.4685274, 31.2158827],
  [54.468412, 31.2154135],
  [54.4677304, 31.213952],
  [54.4671746, 31.2127792],
  [54.4671327, 31.2117326],
  [54.4671379, 31.2111733],
  [54.4671956, 31.2103613],
  [54.4670908, 31.2071225],
  [54.4670331, 31.2065541],
  [54.46678, 31.20495],
  [54.46953, 31.20461],
  [54.4700626, 31.2045121],
  [54.4651617, 31.1905503],
  [54.4659973, 31.1888766],
  [54.4664213, 31.1867523],
  [54.4664337, 31.1853146],
  [54.4685786, 31.1798215],
  [54.4686223, 31.1791885],
  [54.468853, 31.1780298],
  [54.4693144, 31.177504],
  [54.46957, 31.1760557],
  [54.4696344, 31.1734691],
  [54.4711599, 31.1663997],
  [54.4725564, 31.1591256],
  [54.4734292, 31.1570978],
  [54.4742664, 31.1542219],
  [54.4718956, 31.1498236],
  [54.4729804, 31.1479354],
  [54.4724193, 31.1437726],
  [54.4714111, 31.1317562],
  [54.47042, 31.1320345],
  [54.4582396, 31.1425924],
  [54.4563062, 31.144824],
  [54.4560567, 31.145339],
  [54.4551586, 31.1462402],
  [54.4548218, 31.14609],
  [54.4529241, 31.1479137],
  [54.45199, 31.1411547],
  [54.4511667, 31.1371851],
  [54.4506926, 31.1363697],
  [54.4497819, 31.1330437],
  [54.4475362, 31.13137],
  [54.4481048, 31.1296098],
  [54.4476859, 31.1281299],
  [54.4475112, 31.1261129],
  [54.4463509, 31.123259],
  [54.4458144, 31.1228299],
  [54.4450386, 31.120936],
  [54.4447538, 31.1190963],
  [54.4446166, 31.1176371],
  [54.4425827, 31.1144399],
  [54.4426575, 31.1137962],
  [54.4394007, 31.1093545],
  [54.4398374, 31.1045265],
  [54.4386394, 31.1037326],
  [54.4357574, 31.1043539],
  [54.4354821, 31.0848283],
  [54.433298, 31.0717821],
  [54.4322781, 31.0686046],
  [54.4325608, 31.0672538],
  [54.4195775, 31.0630053],
  [54.417669, 31.0530281],
  [54.416283, 31.0531568],
  [54.4118752, 31.0548091],
  [54.4115193, 31.0530174],
  [54.4113, 31.0528469],
  [54.4066427, 31.0418272],
  [54.4067301, 31.0398745],
  [54.404908, 31.034831],
  [54.3985157, 31.0365478],
  [54.3974539, 31.025356],
  [54.411742, 31.0211845],
  [54.4114551, 31.0193482],
  [54.4182807, 31.0176229],
  [54.4182006, 31.0131923],
  [54.4242717, 31.0116576],
  [54.4240236, 31.0066581],
  [54.4227253, 30.9971308],
  [54.4220387, 30.9899854],
  [54.4216624, 30.9838052],
  [54.4220761, 30.9829473],
  [54.4225505, 30.9804797],
  [54.4234619, 30.9802651],
  [54.4246104, 30.9791922],
  [54.4266826, 30.9764242],
  [54.428168, 30.9756517],
  [54.4292274, 30.9744929],
  [54.427132, 30.9642362],
  [54.4250956, 30.9546014],
  [54.426383, 30.9520054],
  [54.4279808, 30.9491086],
  [54.4315506, 30.9432936],
  [54.4327363, 30.9446025],
  [54.4335226, 30.9452462],
  [54.4373541, 30.9344959],
  [54.4380529, 30.9317064],
  [54.4458144, 30.9328437],
  [54.4480103, 30.9335089],
  [54.4488658, 30.9278863],
  [54.4469997, 30.926106],
  [54.4455773, 30.9254837],
  [54.4443171, 30.923531],
  [54.4423206, 30.9220719],
  [54.4416094, 30.9208274],
  [54.4414596, 30.9198618],
  [54.4415357, 30.9189725],
  [54.4396378, 30.9137034],
  [54.4398749, 30.9099269],
  [54.4390512, 30.9053564],
  [54.4370795, 30.9038758],
  [54.4349088, 30.9034681],
  [54.4334477, 30.904026],
  [54.4327488, 30.9037471],
  [54.432287, 30.9029317],
  [54.4310514, 30.9035969],
  [54.4295785, 30.905056],
  [54.4284426, 30.9046054],
  [54.4265686, 30.9051633],
  [54.4233995, 30.900979],
  [54.4222384, 30.8972883],
  [54.421242, 30.8931488],
  [54.4210524, 30.8919132],
  [54.4207167, 30.8908021],
  [54.4164828, 30.8927393],
  [54.4143102, 30.8932542],
  [54.4130615, 30.8859586],
  [54.4089408, 30.8897991],
  [54.4078041, 30.889349],
  [54.4072296, 30.8896279],
  [54.4068175, 30.8900571],
  [54.4061806, 30.8897352],
  [54.4047943, 30.8898425],
  [54.4033704, 30.8905935],
  [54.4023351, 30.8920305],
  [54.3967226, 30.8707363],
  [54.39737, 30.8604661],
  [54.3975247, 30.8601451],
  [54.397837, 30.8599412],
  [54.3987114, 30.8581495],
  [54.3988925, 30.8575916],
  [54.3991548, 30.8573019],
  [54.3994796, 30.8559501],
  [54.3996677, 30.8541559],
  [54.4008217, 30.8501324],
  [54.401397, 30.8481181],
  [54.4013595, 30.8471846],
  [54.4015843, 30.8450603],
  [54.4038325, 30.8332157],
  [54.403895, 30.8298039],
  [54.404346, 30.8294599],
  [54.405044, 30.8248043],
  [54.4004616, 30.8029571],
  [54.3996233, 30.8024025],
  [54.3978412, 30.7910294],
  [54.3993901, 30.7908366],
  [54.401566, 30.7883932],
  [54.4020152, 30.7883477],
  [54.4024212, 30.7885194],
  [54.4035822, 30.7887826],
  [54.404557, 30.7883906],
  [54.4060307, 30.7865238],
  [54.4080539, 30.7853651],
  [54.4083411, 30.7825541],
  [54.4150094, 30.7807088],
  [54.4158585, 30.7801723],
  [54.4163318, 30.7792707],
  [54.4147086, 30.746505],
  [54.4174692, 30.7449174],
  [54.4182183, 30.7450461],
  [54.4201036, 30.7440161],
  [54.4212085, 30.7424819],
  [54.4215019, 30.742439],
  [54.421402, 30.7403254],
  [54.4242841, 30.7290816],
  [54.4218247, 30.7180947],
  [54.4283911, 30.7109927],
  [54.4228735, 30.6833978],
  [54.4204266, 30.6847067],
  [54.4171111, 30.6838414],
  [54.4170651, 30.6830068],
  [54.4171631, 30.6817405],
  [54.4171025, 30.6808923],
  [54.4168711, 30.6787166],
  [54.4162918, 30.6770704],
  [54.4156853, 30.676799],
  [54.4116432, 30.677406],
  [54.410573, 30.6802407],
  [54.4082163, 30.6818167],
  [54.4068998, 30.6833378],
  [54.4068714, 30.6834574],
  [54.4068717, 30.6835893],
  [54.4032486, 30.6863648],
  [54.4030198, 30.6864064],
  [54.401984, 30.6866571],
  [54.3981543, 30.6874336],
  [54.3970592, 30.6883334],
  [54.3964218, 30.6888572],
  [54.3928826, 30.6910218],
  [54.3924895, 30.6909637],
  [54.392443, 30.689996],
  [54.3924187, 30.6897318],
  [54.3923853, 30.6894899],
  [54.3922952, 30.6892185],
  [54.3915802, 30.6874673],
  [54.3908597, 30.6856573],
  [54.3896494, 30.6817949],
  [54.3887466, 30.6791717],
  [54.3908698, 30.6767191],
  [54.3900941, 30.6736645],
  [54.3866823, 30.6625658],
  [54.3858557, 30.6596231],
  [54.383743, 30.653382],
  [54.3830717, 30.6514856],
  [54.3854936, 30.6453606],
  [54.3930085, 30.6266761],
  [54.3921029, 30.6256342],
  [54.3846562, 30.6307626],
  [54.3825699, 30.6299063],
  [54.3819795, 30.6300789],
  [54.3803958, 30.6207814],
  [54.3794747, 30.6212596],
  [54.3764278, 30.6134208],
  [54.3817261, 30.6102468],
  [54.3803074, 30.608983],
  [54.37835, 30.6040816],
  [54.3775955, 30.6022588],
  [54.3767613, 30.6002954],
  [54.3765082, 30.5996087],
  [54.3763957, 30.5993459],
  [54.3761739, 30.5992708],
  [54.3756677, 30.5994961],
  [54.3751646, 30.599775],
  [54.3749678, 30.5998864],
  [54.3748881, 30.5997925],
  [54.3748683, 30.5997263],
  [54.3748287, 30.599594],
  [54.3746522, 30.5989073],
  [54.3743741, 30.5983816],
  [54.3742835, 30.5979364],
  [54.3742897, 30.5976494],
  [54.3744225, 30.5971961],
  [54.3744459, 30.5960723],
  [54.3745022, 30.5954392],
  [54.3744694, 30.5952488],
  [54.3743334, 30.5952569],
  [54.3741725, 30.5948679],
  [54.3741569, 30.5945166],
  [54.3741428, 30.5940418],
  [54.3741819, 30.5937897],
  [54.3743334, 30.5936931],
  [54.3744912, 30.5933525],
  [54.3745241, 30.5929153],
  [54.3745303, 30.5924566],
  [54.374649, 30.5919792],
  [54.37481, 30.5913274],
  [54.3751474, 30.5903994],
  [54.375538, 30.5900292],
  [54.3759786, 30.5888759],
  [54.3763879, 30.5885004],
  [54.3769443, 30.587583],
  [54.3742361, 30.5795888],
  [54.3731282, 30.5771691],
  [54.3698796, 30.5663908],
  [54.3673297, 30.5694255],
  [54.364906, 30.5722063],
  [54.3626569, 30.5753134],
  [54.3622288, 30.5868599],
  [54.362445, 30.5907958],
  [54.3618838, 30.5946626],
  [54.3610498, 30.5950288],
  [54.3593632, 30.5964966],
  [54.3578849, 30.5979318],
  [54.3556297, 30.6001929],
  [54.3536955, 30.6020098],
  [54.3536247, 30.602094],
  [54.353545, 30.6021906],
  [54.3534623, 30.6022152],
  [54.353358, 30.6021844],
  [54.3532872, 30.6022263],
  [54.3532546, 30.602324],
  [54.3532178, 30.6031029],
  [54.3531273, 30.6037196],
  [54.352897, 30.6043922],
  [54.3524599, 30.6054186],
  [54.3500756, 30.6102765],
  [54.3494224, 30.6115418],
  [54.3383649, 30.6039549],
  [54.3377137, 30.5986343],
  [54.3376896, 30.5981133],
  [54.3377387, 30.5980518],
  [54.3377591, 30.5978917],
  [54.3377435, 30.5970102],
  [54.3377531, 30.5968619],
  [54.3377945, 30.596779],
  [54.3391939, 30.595784],
  [54.3409581, 30.5947307],
  [54.3362296, 30.5778128],
  [54.3357898, 30.5767094],
  [54.332549, 30.5752816],
  [54.3309271, 30.5745971],
  [54.3292317, 30.5751657],
  [54.3282057, 30.5744469],
  [54.3277239, 30.5732024],
  [54.3275688, 30.573016],
  [54.3230746, 30.5715569],
  [54.3230337, 30.5715436],
  [54.3229402, 30.5698975],
  [54.3228576, 30.5691822],
  [54.3226276, 30.5679585],
  [54.3220022, 30.5652781],
  [54.3214726, 30.5630194],
  [54.3208318, 30.5634552],
  [54.3205658, 30.5633962],
  [54.3204551, 30.5631509],
  [54.3199589, 30.5610734],
  [54.3194708, 30.5605262],
  [54.3189889, 30.5602419],
  [54.3175684, 30.5603278],
  [54.3171, 30.5602162],
  [54.3163856, 30.5595446],
  [54.3159412, 30.5594265],
  [54.3154186, 30.5590583],
  [54.3151377, 30.5581366],
  [54.3127243, 30.5557895],
  [54.3114913, 30.5556285],
  [54.3104899, 30.5551135],
  [54.310033, 30.5543303],
  [54.3099641, 30.5535149],
  [54.3104398, 30.5531824],
  [54.3104655, 30.5529651],
  [54.3077254, 30.5526438],
  [54.30537, 30.5742401],
  [54.3044208, 30.5741609],
  [54.3030567, 30.5713878],
  [54.3006507, 30.5660203],
  [54.2980031, 30.5599441],
  [54.2924302, 30.5476806],
  [54.2913645, 30.548694],
  [54.2896883, 30.5471641],
  [54.2888444, 30.5478237],
  [54.2888349, 30.5478311],
  [54.287451, 30.545722],
  [54.2870926, 30.5449233],
  [54.2870722, 30.5445075],
  [54.286966, 30.5439001],
  [54.2889179, 30.54111],
  [54.2891977, 30.5407101],
  [54.2890023, 30.5402711],
  [54.2875363, 30.5369165],
  [54.2869096, 30.5356066],
  [54.2864464, 30.5343341],
  [54.2833859, 30.5274781],
  [54.2826672, 30.5285709],
  [54.2823055, 30.5328463],
  [54.2832265, 30.5352556],
  [54.2832712, 30.5355832],
  [54.2832143, 30.5358907],
  [54.2830894, 30.5360222],
  [54.2824965, 30.5359149],
  [54.2819255, 30.5357516],
  [54.280081, 30.5353143],
  [54.2799891, 30.5352918],
  [54.2799698, 30.5354219],
  [54.2794932, 30.538892],
  [54.2788789, 30.5459878],
  [54.2784248, 30.5514115],
  [54.277557, 30.5606927],
  [54.2774136, 30.5627804],
  [54.2773297, 30.5628785],
  [54.2771456, 30.5629874],
  [54.2767962, 30.5631729],
  [54.2764292, 30.5632473],
  [54.2760935, 30.5631232],
  [54.2743, 30.5632678],
  [54.2734501, 30.5632509],
  [54.2735671, 30.5613848],
  [54.2738818, 30.5569199],
  [54.2752117, 30.5423756],
  [54.2759664, 30.5335314],
  [54.2763396, 30.528876],
  [54.2726119, 30.5293823],
  [54.2688413, 30.5309508],
  [54.2643514, 30.526082],
  [54.2643531, 30.529772],
  [54.2645476, 30.5344927],
  [54.2628345, 30.5329246],
  [54.2624177, 30.5309522],
  [54.2613983, 30.5303147],
  [54.2576931, 30.5340215],
  [54.2579362, 30.536477],
  [54.257857, 30.5400697],
  [54.2539231, 30.5405742],
  [54.2535696, 30.5363414],
  [54.2531605, 30.5333927],
  [54.2534552, 30.5325244],
  [54.2533507, 30.5299818],
  [54.252988, 30.5238734],
  [54.2529252, 30.5220142],
  [54.252848, 30.5203768],
  [54.2528348, 30.5198182],
  [54.2531114, 30.5197949],
  [54.255367, 30.5199539],
  [54.2569108, 30.5201704],
  [54.2570399, 30.5201951],
  [54.2570075, 30.5186236],
  [54.2598023, 30.5215045],
  [54.2596897, 30.5153295],
  [54.259942, 30.515615],
  [54.2614923, 30.5179672],
  [54.2632981, 30.5195595],
  [54.2634885, 30.5169669],
  [54.2639107, 30.5170478],
  [54.2641333, 30.5142923],
  [54.2642993, 30.5116918],
  [54.2640219, 30.5105551],
  [54.2639283, 30.5090224],
  [54.2637581, 30.5068896],
  [54.2637737, 30.5049113],
  [54.2640125, 30.503204],
  [54.2641403, 30.50131],
  [54.265898, 30.501404],
  [54.2675474, 30.5003065],
  [54.268636, 30.4996642],
  [54.2684261, 30.5028787],
  [54.2707134, 30.5037531],
  [54.2707517, 30.5035265],
  [54.2709096, 30.503299],
  [54.271084, 30.5029299],
  [54.2713122, 30.5025254],
  [54.2715565, 30.5022842],
  [54.2718834, 30.5022695],
  [54.2725389, 30.5023063],
  [54.273087, 30.5022582],
  [54.2736228, 30.5024989],
  [54.2739053, 30.5026294],
  [54.2745335, 30.5038227],
  [54.2751658, 30.5037802],
  [54.2753766, 30.5035669],
  [54.2765049, 30.502667],
  [54.2767596, 30.5022112],
  [54.2769117, 30.5015868],
  [54.277006, 30.5007785],
  [54.2771319, 30.4979606],
  [54.2772048, 30.4977133],
  [54.2774479, 30.4974764],
  [54.2780571, 30.4975208],
  [54.2783617, 30.49755],
  [54.2787035, 30.4977421],
  [54.2794872, 30.4982062],
  [54.2803659, 30.4986773],
  [54.2813997, 30.4988837],
  [54.2815626, 30.4960406],
  [54.2809518, 30.4950556],
  [54.2806452, 30.4947784],
  [54.2798123, 30.4941692],
  [54.2789819, 30.493176],
  [54.2774593, 30.4921943],
  [54.276351, 30.49088],
  [54.2757747, 30.489732],
  [54.2762002, 30.4882711],
  [54.2706574, 30.4798613],
  [54.2710845, 30.478986],
  [54.271145, 30.4786877],
  [54.2695725, 30.4761493],
  [54.2689835, 30.4750219],
  [54.2684654, 30.4742028],
  [54.2688452, 30.4724496],
  [54.2691714, 30.4723354],
  [54.2694878, 30.4724079],
  [54.2698622, 30.4725088],
  [54.2700542, 30.4723112],
  [54.2707754, 30.4709244],
  [54.2712096, 30.4704915],
  [54.2718947, 30.4702118],
  [54.2721703, 30.4701534],
  [54.2725947, 30.469911],
  [54.2731431, 30.4698738],
  [54.2737162, 30.4699074],
  [54.2741811, 30.4699497],
  [54.2745867, 30.4698913],
  [54.2750832, 30.4660671],
  [54.2763635, 30.4664532],
  [54.2763127, 30.4671642],
  [54.2778316, 30.4684136],
  [54.2787314, 30.4690684],
  [54.2817464, 30.4710187],
  [54.2826533, 30.4705871],
  [54.2915648, 30.4655322],
  [54.297114, 30.4621357],
  [54.2967828, 30.4611068],
  [54.2972203, 30.4601984],
  [54.2982828, 30.4571575],
  [54.2986425, 30.4533039],
  [54.2995909, 30.450114],
  [54.2999477, 30.4493463],
  [54.3001401, 30.4493101],
  [54.3001479, 30.4477389],
  [54.3006108, 30.4478207],
  [54.3011729, 30.4477863],
  [54.301301, 30.4479511],
  [54.3016225, 30.4479425],
  [54.3023938, 30.4478834],
  [54.3078501, 30.4475665],
  [54.3080815, 30.4462617],
  [54.3109307, 30.4420763],
  [54.3117324, 30.4426801],
  [54.3124391, 30.4430045],
  [54.3131531, 30.4433727],
  [54.3134284, 30.4434076],
  [54.3139596, 30.4432587],
  [54.3140715, 30.4432587],
  [54.3144517, 30.4432011],
  [54.3145863, 30.4432118],
  [54.3147271, 30.4433352],
  [54.315403, 30.4444456],
  [54.3159593, 30.4452341],
  [54.3160825, 30.4452921],
  [54.316212, 30.4452857],
  [54.3165211, 30.4450477],
  [54.3175611, 30.4457371],
  [54.3179629, 30.4461155],
  [54.3181009, 30.4462191],
  [54.3182766, 30.4462691],
  [54.3187906, 30.4466052],
  [54.3187196, 30.4390977],
  [54.3186193, 30.4375367],
  [54.3204497, 30.4373666],
  [54.3225835, 30.4373974],
  [54.3286026, 30.4374184],
  [54.3305592, 30.4373485],
  [54.3305201, 30.4342904],
  [54.3307046, 30.4239197],
  [54.3326744, 30.4242599],
  [54.3336031, 30.4238957],
  [54.3345399, 30.4237008],
  [54.335518, 30.4234053],
  [54.3359606, 30.4233173],
  [54.3364445, 30.4235124],
  [54.3393354, 30.4146228],
  [54.3348288, 30.4126918],
  [54.3327405, 30.4110266],
  [54.3295747, 30.4084845],
  [54.3279732, 30.4070059],
  [54.3258721, 30.4132887],
  [54.3222394, 30.4101788],
  [54.3198567, 30.4083795],
  [54.3189826, 30.4107678],
  [54.3182096, 30.413149],
  [54.3177668, 30.4138363],
  [54.3138884, 30.4136267],
  [54.313408, 30.4136007],
  [54.3133085, 30.4134338],
  [54.313209, 30.4130405],
  [54.3130165, 30.4122936],
  [54.3130281, 30.4114307],
  [54.3139656, 30.4081248],
  [54.31506, 30.4046632],
  [54.3119714, 30.4026902],
  [54.3111696, 30.402178],
  [54.3129559, 30.3963268],
  [54.3145144, 30.3943548],
  [54.3161613, 30.3958074],
  [54.3163992, 30.3896027],
  [54.316406, 30.388183],
  [54.3166661, 30.3826531],
  [54.3170067, 30.3774405],
  [54.3170914, 30.3732188],
  [54.3171671, 30.3731048],
  [54.3171111, 30.3727574],
  [54.3171193, 30.3724685],
  [54.3165856, 30.3720712],
  [54.3136427, 30.3691053],
  [54.311363, 30.3668149],
  [54.310252, 30.3657603],
  [54.3093797, 30.3649716],
  [54.310167, 30.3618127],
  [54.3104283, 30.3608417],
  [54.3105722, 30.3604662],
  [54.3109164, 30.3590498],
  [54.3097087, 30.3579769],
  [54.2989007, 30.3484095],
  [54.2955497, 30.3455304],
  [54.2901558, 30.3406914],
  [54.2893052, 30.3400039],
  [54.2866498, 30.3375115],
  [54.2866, 30.3367053],
  [54.2880686, 30.3313413],
  [54.2888179, 30.3288119],
  [54.2914676, 30.319928],
  [54.2928868, 30.3153676],
  [54.2942665, 30.3105621],
  [54.2966695, 30.3021921],
  [54.2957709, 30.3012277],
  [54.2908927, 30.2961255],
  [54.2897426, 30.2951765],
  [54.292138, 30.2863154],
  [54.2924042, 30.2850214],
  [54.2937366, 30.2795623],
  [54.2944113, 30.277113],
  [54.2953925, 30.2730615],
  [54.2954888, 30.2726639],
  [54.29587, 30.2710897],
  [54.2967951, 30.2678425],
  [54.2970197, 30.2682398],
  [54.297798, 30.2691042],
  [54.2986264, 30.2695008],
  [54.2996519, 30.2696283],
  [54.30038, 30.269586],
  [54.3019352, 30.2697071],
  [54.3034573, 30.2701397],
  [54.3048504, 30.2711436],
  [54.3061755, 30.2722667],
  [54.3079384, 30.2737861],
  [54.3085635, 30.2738468],
  [54.3086806, 30.2738582],
  [54.3098523, 30.2731092],
  [54.3109787, 30.2727635],
  [54.3123694, 30.2728708],
  [54.3134293, 30.2731249],
  [54.3139744, 30.2734475],
  [54.3142415, 30.2736056],
  [54.314793, 30.2741796],
  [54.3152783, 30.27515],
  [54.3163068, 30.2771555],
  [54.31855, 30.28012],
  [54.3200136, 30.2819842],
  [54.3204129, 30.2823627],
  [54.3212008, 30.2828793],
  [54.3217906, 30.2829995],
  [54.3232534, 30.2828988],
  [54.3237379, 30.2829181],
  [54.3256886, 30.2824895],
  [54.326369, 30.2825615],
  [54.3270229, 30.2827673],
  [54.3275778, 30.2832563],
  [54.3284466, 30.2842989],
  [54.3294971, 30.2862476],
  [54.3301212, 30.2878176],
  [54.3304498, 30.2889141],
  [54.3307128, 30.29035],
  [54.330747, 30.2919697],
  [54.3307322, 30.2946932],
  [54.330858, 30.2961947],
  [54.3311488, 30.2974697],
  [54.331545, 30.2991836],
  [54.3325154, 30.3014272],
  [54.3337591, 30.3033851],
  [54.3360013, 30.3070444],
  [54.3369744, 30.3088727],
  [54.3374287, 30.3099642],
  [54.3381125, 30.3116071],
  [54.3396867, 30.3145187],
  [54.3405561, 30.3156421],
  [54.3415245, 30.3164257],
  [54.3426006, 30.3174249],
  [54.3438318, 30.3180378],
  [54.344997, 30.3185657],
  [54.3459485, 30.3194152],
  [54.3472466, 30.3211141],
  [54.3483566, 30.3225056],
  [54.3490187, 30.3228737],
  [54.3497138, 30.3228454],
  [54.3507402, 30.3219273],
  [54.3513106, 30.3216829],
  [54.3518316, 30.3216933],
  [54.3525019, 30.3218462],
  [54.353276, 30.322257],
  [54.3545259, 30.3231397],
  [54.3558418, 30.3244471],
  [54.3559238, 30.3242268],
  [54.3560188, 30.3239718],
  [54.3568715, 30.3218036],
  [54.3597257, 30.3143645],
  [54.3690597, 30.3165246],
  [54.3718998, 30.3185847],
  [54.3737097, 30.3196172],
  [54.3760385, 30.313814],
  [54.3761, 30.3121282],
  [54.3756785, 30.311696],
  [54.3764221, 30.30923],
  [54.3767157, 30.3083737],
  [54.3771041, 30.3071334],
  [54.3764075, 30.3061583],
  [54.3749896, 30.3041822],
  [54.3752286, 30.3035653],
  [54.3749693, 30.3031146],
  [54.3746709, 30.3036645],
  [54.3729144, 30.3010226],
  [54.3721879, 30.2999237],
  [54.374073, 30.2958632],
  [54.3752099, 30.2933434],
  [54.3695734, 30.2906564],
  [54.3668591, 30.2894171],
  [54.3636189, 30.2879147],
  [54.3596961, 30.2860877],
  [54.3557825, 30.2842151],
  [54.3528196, 30.282907],
  [54.3517048, 30.2824127],
  [54.3517481, 30.2821904],
  [54.3521962, 30.2812214],
  [54.3524358, 30.2809029],
  [54.3526645, 30.2801167],
  [54.3534044, 30.2784924],
  [54.3535895, 30.2779729],
  [54.3535238, 30.2773714],
  [54.3534202, 30.2768023],
  [54.3534499, 30.2761033],
  [54.3534429, 30.2756159],
  [54.3528494, 30.2722495],
  [54.3531177, 30.2711825],
  [54.3531786, 30.2711002],
  [54.3535414, 30.271142],
  [54.3542104, 30.2708201],
  [54.354398, 30.2704875],
  [54.3544825, 30.2698398],
  [54.3530969, 30.2696763],
  [54.3531847, 30.2695001],
  [54.3585969, 30.2586375],
  [54.3579377, 30.257797],
  [54.3573301, 30.2570578],
  [54.3558557, 30.2551243],
  [54.3544049, 30.2528067],
  [54.3529, 30.2506123],
  [54.352572, 30.2501732],
  [54.3527106, 30.2497909],
  [54.3528293, 30.2494269],
  [54.3530121, 30.249038],
  [54.353159, 30.2486657],
  [54.353617, 30.2475707],
  [54.3547561, 30.244838],
  [54.3645569, 30.2239976],
  [54.3646682, 30.2236073],
  [54.3654427, 30.221851],
  [54.3658476, 30.2212478],
  [54.3662524, 30.220547],
  [54.3667211, 30.2191778],
  [54.367412, 30.2170738],
  [54.3666471, 30.2155895],
  [54.3660575, 30.2140157],
  [54.3621401, 30.2055018],
  [54.361976, 30.2054373],
  [54.3517784, 30.2162117],
  [54.3523755, 30.2177775],
  [54.3504929, 30.2195862],
  [54.3483562, 30.2138488],
  [54.3478403, 30.2144697],
  [54.342919, 30.2140607],
  [54.3353743, 30.2081653],
  [54.3344261, 30.2029742],
  [54.3339094, 30.1985736],
  [54.3337676, 30.1938909],
  [54.3335917, 30.1885407],
  [54.3332814, 30.1797348],
  [54.3409686, 30.1789951],
  [54.343959, 30.1788496],
  [54.3449456, 30.1828766],
  [54.345016, 30.183004],
  [54.3452068, 30.1835403],
  [54.3453101, 30.1838193],
  [54.345529, 30.1838605],
  [54.3457415, 30.1836984],
  [54.3476971, 30.1825013],
  [54.3478069, 30.182475],
  [54.3478697, 30.1825291],
  [54.3563118, 30.1769326],
  [54.3568619, 30.1763317],
  [54.3572371, 30.1741644],
  [54.359569, 30.1699121],
  [54.3615507, 30.1665913],
  [54.3628322, 30.1644412],
  [54.3681309, 30.1599949],
  [54.3688489, 30.1597818],
  [54.3712352, 30.155635],
  [54.3677495, 30.1393614],
  [54.364862, 30.126789],
  [54.3628825, 30.1180986],
  [54.36128, 30.1189998],
  [54.3608923, 30.1174991],
  [54.3618016, 30.1170257],
  [54.3615867, 30.1153949],
  [54.3628646, 30.1145366],
  [54.362741, 30.1136783],
  [54.3682172, 30.1102187],
  [54.3700459, 30.111128],
  [54.3716669, 30.1148922],
  [54.3683546, 30.1172004],
  [54.3714135, 30.1284401],
  [54.3752537, 30.1262321],
  [54.3760704, 30.1305011],
  [54.3757998, 30.1309936],
  [54.3777144, 30.1401279],
  [54.3854605, 30.1352189],
  [54.3828172, 30.1251108],
  [54.3840852, 30.1238647],
  [54.3825474, 30.1169094],
  [54.3835842, 30.1162228],
  [54.3834366, 30.1153859],
  [54.3852374, 30.114356],
  [54.3838811, 30.1091111],
  [54.3832746, 30.1072566],
  [54.382424, 30.1032686],
  [54.3797997, 30.0950709],
  [54.3766332, 30.0976467],
  [54.3753708, 30.0941705],
  [54.3743959, 30.0861025],
  [54.3735869, 30.0852651],
  [54.3587926, 30.0960796],
  [54.3575066, 30.1031184],
  [54.3567188, 30.1049852],
  [54.3549057, 30.1040625],
  [54.3529674, 30.1048136],
  [54.3555243, 30.1157946],
  [54.3539053, 30.1161861],
  [54.3519169, 30.1171303],
  [54.3511541, 30.1111436],
  [54.3513917, 30.105114],
  [54.3490988, 30.1052164],
  [54.3484903, 30.1049208],
  [54.3481526, 30.1063156],
  [54.3465673, 30.1066428],
  [54.3454541, 30.1062083],
  [54.3453541, 30.1060742],
  [54.3452165, 30.106203],
  [54.3452759, 30.1063156],
  [54.3448475, 30.1067877],
  [54.3447193, 30.1066053],
  [54.3446661, 30.1063371],
  [54.3440752, 30.1062298],
  [54.3442628, 30.1051998],
  [54.3447506, 30.1048565],
  [54.344663, 30.103569],
  [54.3430261, 30.0978139],
  [54.3412983, 30.0984191],
  [54.3400974, 30.0972604],
  [54.3336536, 30.1012267],
  [54.3332168, 30.0983333],
  [54.3324661, 30.0974536],
  [54.3312649, 30.0972605],
  [54.3306769, 30.0950074],
  [54.3298511, 30.0951576],
  [54.3291003, 30.0926041],
  [54.3285873, 30.0926256],
  [54.3281494, 30.0913167],
  [54.3275988, 30.0909519],
  [54.3267413, 30.091552],
  [54.3264476, 30.0895142],
  [54.3276739, 30.0885057],
  [54.3276864, 30.0875616],
  [54.3287124, 30.0869393],
  [54.3287875, 30.0878405],
  [54.3300513, 30.086832],
  [54.3322784, 30.0853729],
  [54.331903, 30.0841498],
  [54.3313525, 30.0842571],
  [54.3310458, 30.0832911],
  [54.3346931, 30.0809955],
  [54.3349433, 30.0819826],
  [54.3372021, 30.0809952],
  [54.3367448, 30.0785494],
  [54.3365321, 30.078367],
  [54.3359942, 30.0786781],
  [54.3372202, 30.075438],
  [54.3389716, 30.0752878],
  [54.3396221, 30.0737643],
  [54.3404914, 30.0729811],
  [54.3413108, 30.0728416],
  [54.3414671, 30.0723374],
  [54.3415672, 30.071125],
  [54.3413983, 30.0697732],
  [54.3415172, 30.0686467],
  [54.3416735, 30.068593],
  [54.3420488, 30.0690865],
  [54.3424803, 30.0686252],
  [54.3422552, 30.0667262],
  [54.3440033, 30.0658249],
  [54.3417173, 30.0544417],
  [54.3421113, 30.0540554],
  [54.3423115, 30.0533581],
  [54.3420738, 30.0525105],
  [54.3467988, 30.0499993],
  [54.3460076, 30.0454509],
  [54.3449507, 30.0410306],
  [54.3442683, 30.0376723],
  [54.3422084, 30.0340675],
  [54.3363194, 30.04529],
  [54.3357393, 30.0456557],
  [54.3284556, 30.0502463],
  [54.3281368, 30.0495815],
  [54.3276614, 30.0497961],
  [54.3270107, 30.0512123],
  [54.3272109, 30.0535297],
  [54.3280117, 30.0551176],
  [54.3288876, 30.0563407],
  [54.3295257, 30.0561261],
  [54.3300763, 30.0592804],
  [54.3239448, 30.0628209],
  [54.3265292, 30.0745795],
  [54.3207114, 30.0783989],
  [54.3187386, 30.0702667],
  [54.3179626, 30.06428],
  [54.3161352, 30.0577569],
  [54.31568, 30.0508684],
  [54.3143078, 30.0510299],
  [54.3071198, 30.0576705],
  [54.306246, 30.0566625],
  [54.3056075, 30.0553536],
  [54.3053195, 30.0533581],
  [54.306221, 30.0526285],
  [54.3053321, 30.0485086],
  [54.3058579, 30.0479507],
  [54.3060832, 30.0473714],
  [54.3069596, 30.0466203],
  [54.3073477, 30.0469851],
  [54.307862, 30.0462793],
  [54.307309, 30.0443057],
  [54.30649, 30.0421194],
  [54.3056404, 30.0391509],
  [54.3053109, 30.037845],
  [54.3068404, 30.0361864],
  [54.312127, 30.0301969],
  [54.3135405, 30.0289197],
  [54.3153346, 30.0274021],
  [54.315306, 30.0273058],
  [54.3140053, 30.0229233],
  [54.3135687, 30.0214524],
  [54.3130287, 30.019633],
  [54.3152645, 30.0063056],
  [54.3058207, 30.0047994],
  [54.3042061, 30.005116],
  [54.3039037, 30.0053812],
  [54.3038752, 30.0059234],
  [54.30299, 30.0061101],
  [54.3028723, 30.0106698],
  [54.3016811, 30.0126915],
  [54.3004295, 30.0140022],
  [54.3004746, 30.0147425],
  [54.2999029, 30.0154671],
  [54.2993012, 30.0158656],
  [54.2982078, 30.0138374],
  [54.2981067, 30.0138159],
  [54.2973552, 30.0113744],
  [54.2950614, 30.012907],
  [54.2933582, 30.0140208],
  [54.290679, 30.0184828],
  [54.2851143, 30.0240767],
  [54.2823301, 30.0268471],
  [54.2813368, 30.0276451],
  [54.2811252, 30.0276878],
  [54.2791016, 30.0247843],
  [54.2767709, 30.0176129],
  [54.2763088, 30.0169582],
  [54.2758479, 30.014528],
  [54.2774128, 30.0105455],
  [54.2786562, 30.0021172],
  [54.2796004, 29.9950207],
  [54.2798372, 29.9852475],
  [54.277881, 29.9786922],
  [54.2877626, 29.9789453],
  [54.2879483, 29.9804861],
  [54.2886723, 29.9803162],
  [54.289125, 29.980468],
  [54.2897428, 29.9810787],
  [54.2903607, 29.9808054],
  [54.2909762, 29.9810516],
  [54.2921077, 29.9798988],
  [54.2921061, 29.9790905],
  [54.2932776, 29.9788678],
  [54.2936923, 29.9784984],
  [54.2928103, 29.9734325],
  [54.2939475, 29.9727674],
  [54.2941654, 29.9730357],
  [54.2948142, 29.9729435],
  [54.2950545, 29.9724969],
  [54.2953336, 29.966752],
  [54.2954077, 29.9657919],
  [54.2953606, 29.9647904],
  [54.2953501, 29.9645662],
  [54.2958656, 29.9604136],
  [54.2966975, 29.9604291],
  [54.2967482, 29.9591377],
  [54.297325, 29.9586359],
  [54.2971523, 29.9571674],
  [54.2971599, 29.9553898],
  [54.2976059, 29.9550105],
  [54.2976742, 29.9539849],
  [54.2975429, 29.95361],
  [54.2967496, 29.9532957],
  [54.2950267, 29.952712],
  [54.2931434, 29.9519697],
  [54.2929341, 29.9513543],
  [54.2916968, 29.9512814],
  [54.2913359, 29.951401],
  [54.2915261, 29.9505765],
  [54.2912201, 29.947022],
  [54.2915223, 29.9441882],
  [54.2916845, 29.9410097],
  [54.2919639, 29.9388413],
  [54.2928153, 29.9358215],
  [54.2939522, 29.9313818],
  [54.2951993, 29.9269935],
  [54.295881, 29.9248695],
  [54.2983354, 29.9155311],
  [54.3013005, 29.9162865],
  [54.3019508, 29.9163864],
  [54.3021052, 29.9156708],
  [54.3023822, 29.9155745],
  [54.3024846, 29.9145322],
  [54.3024555, 29.9134975],
  [54.3025093, 29.9122368],
  [54.3027768, 29.9104742],
  [54.3029306, 29.9099362],
  [54.3032497, 29.9067461],
  [54.3033127, 29.9054148],
  [54.3035249, 29.9032555],
  [54.3037013, 29.9031329],
  [54.3056158, 29.903674],
  [54.3058912, 29.9033843],
  [54.306372, 29.9037362],
  [54.3065339, 29.9041328],
  [54.3100993, 29.9141751],
  [54.3126419, 29.9160908],
  [54.3134982, 29.9153928],
  [54.3136407, 29.9106958],
  [54.3139313, 29.9098025],
  [54.3169203, 29.9064199],
  [54.3195914, 29.9035727],
  [54.3198371, 29.9038112],
  [54.3208274, 29.903339],
  [54.3229414, 29.9021177],
  [54.3240366, 29.9010917],
  [54.3246697, 29.8993652],
  [54.325048, 29.8995751],
  [54.325655, 29.8993928],
  [54.325874, 29.8992855],
  [54.3261367, 29.8989851],
  [54.3262181, 29.8987705],
  [54.3262619, 29.8986203],
  [54.3281388, 29.890005],
  [54.3283328, 29.8876983],
  [54.3284531, 29.8875903],
  [54.3300913, 29.8895541],
  [54.3341053, 29.8943418],
  [54.3359496, 29.8964964],
  [54.3399112, 29.9014514],
  [54.3416704, 29.903652],
  [54.3417074, 29.9036953],
  [54.3426723, 29.904825],
  [54.3429741, 29.9042313],
  [54.3441843, 29.9018515],
  [54.3457942, 29.8984416],
  [54.349305, 29.8895416],
  [54.3483787, 29.8884879],
  [54.3480532, 29.8879385],
  [54.3466418, 29.8860415],
  [54.3462346, 29.8851364],
  [54.3451733, 29.8833018],
  [54.3437462, 29.880233],
  [54.3429318, 29.8826936],
  [54.343227, 29.8831253],
  [54.34099, 29.887118],
  [54.3373522, 29.8826146],
  [54.3342094, 29.8789071],
  [54.3339846, 29.8790199],
  [54.3338673, 29.8789903],
  [54.3306601, 29.8743624],
  [54.3302735, 29.8741926],
  [54.3264104, 29.868961],
  [54.3273087, 29.8675478],
  [54.3275972, 29.8666248],
  [54.3277377, 29.8637214],
  [54.3275131, 29.8609912],
  [54.3276499, 29.8596317],
  [54.3276232, 29.85814],
  [54.3278073, 29.8571962],
  [54.3279958, 29.8543675],
  [54.3291479, 29.8547355],
  [54.3302285, 29.8560434],
  [54.3312928, 29.8529838],
  [54.3339929, 29.8465419],
  [54.3343007, 29.8458818],
  [54.3348708, 29.845418],
  [54.3352529, 29.8459121],
  [54.3353519, 29.8450554],
  [54.3359331, 29.8401179],
  [54.3362134, 29.8383667],
  [54.3365463, 29.8363688],
  [54.3354816, 29.8349471],
  [54.3355973, 29.8301477],
  [54.3344447, 29.8291861],
  [54.3308921, 29.8267597],
  [54.3303431, 29.8263847],
  [54.3297047, 29.825277],
  [54.3291664, 29.8237401],
  [54.328861, 29.8228262],
  [54.3291711, 29.821685],
  [54.3287555, 29.8208837],
  [54.3277094, 29.820486],
  [54.3255625, 29.8165102],
  [54.323607, 29.8145106],
  [54.3227511, 29.8141065],
  [54.3225199, 29.8136253],
  [54.3223321, 29.8119455],
  [54.3218489, 29.8109161],
  [54.3224284, 29.8097547],
  [54.3226611, 29.809058],
  [54.3228866, 29.8083826],
  [54.3231226, 29.8067566],
  [54.3246775, 29.8004446],
  [54.3264036, 29.7945297],
  [54.3282624, 29.7881952],
  [54.3287339, 29.7866378],
  [54.3291273, 29.7850538],
  [54.3296712, 29.7840968],
  [54.3303456, 29.7834593],
  [54.3318878, 29.7820674],
  [54.3316434, 29.7817576],
  [54.3313181, 29.7816879],
  [54.3311742, 29.7815055],
  [54.3310245, 29.7806941],
  [54.33073, 29.7802931],
  [54.3305392, 29.7802448],
  [54.3304438, 29.7803441],
  [54.3303203, 29.7804889],
  [54.3301842, 29.7805157],
  [54.3295304, 29.7803414],
  [54.3293787, 29.7802877],
  [54.3292348, 29.7801268],
  [54.3291332, 29.7799417],
  [54.3290815, 29.7797298],
  [54.3290847, 29.7795609],
  [54.329116, 29.7794455],
  [54.3292505, 29.7792095],
  [54.3296696, 29.7786543],
  [54.3297134, 29.7784692],
  [54.3297103, 29.7782412],
  [54.3296649, 29.7780159],
  [54.3295539, 29.7777986],
  [54.3291942, 29.7775358],
  [54.3289705, 29.7774714],
  [54.3288563, 29.7775492],
  [54.3287234, 29.7775546],
  [54.3286201, 29.777458],
  [54.3284966, 29.7771335],
  [54.3284152, 29.777053],
  [54.3280273, 29.7768116],
  [54.3278365, 29.776597],
  [54.3277661, 29.7764093],
  [54.3276457, 29.7758621],
  [54.3276144, 29.7756234],
  [54.3274627, 29.7753283],
  [54.3273579, 29.7749984],
  [54.3270857, 29.7743735],
  [54.3268011, 29.7740543],
  [54.3266759, 29.7738826],
  [54.3266603, 29.7737887],
  [54.3266697, 29.7737029],
  [54.3267573, 29.7735447],
  [54.3268824, 29.7733113],
  [54.3269074, 29.7730458],
  [54.3269074, 29.7728661],
  [54.326837, 29.7726354],
  [54.3268214, 29.772453],
  [54.3268386, 29.772335],
  [54.3269137, 29.7722679],
  [54.3270623, 29.772225],
  [54.3271389, 29.7721687],
  [54.3271952, 29.7720748],
  [54.3272375, 29.7718951],
  [54.3272422, 29.77171],
  [54.3271968, 29.7716027],
  [54.3270764, 29.7714365],
  [54.3270044, 29.7713828],
  [54.3268308, 29.7713882],
  [54.3266353, 29.7714928],
  [54.3262896, 29.7716483],
  [54.325922, 29.7719112],
  [54.3256404, 29.7721097],
  [54.3254668, 29.7721687],
  [54.3253323, 29.7721741],
  [54.3251446, 29.7720953],
  [54.3250617, 29.7720212],
  [54.3249741, 29.7718817],
  [54.324888, 29.7716269],
  [54.3247645, 29.7712058],
  [54.3247297, 29.7710323],
  [54.3246816, 29.7707927],
  [54.3245896, 29.7704654],
  [54.3244939, 29.7701865],
  [54.3243265, 29.76987],
  [54.3240136, 29.7694999],
  [54.3238902, 29.7693635],
  [54.3238118, 29.769339],
  [54.3237133, 29.7693336],
  [54.32361, 29.7694194],
  [54.3235287, 29.7695696],
  [54.3234974, 29.7697225],
  [54.3235143, 29.7699552],
  [54.3236344, 29.7701719],
  [54.3236727, 29.7703046],
  [54.3237571, 29.7706559],
  [54.3237884, 29.7709697],
  [54.3237727, 29.7712836],
  [54.3237649, 29.7716108],
  [54.3237493, 29.7721231],
  [54.3236554, 29.7723484],
  [54.3235365, 29.7726247],
  [54.3234536, 29.7728366],
  [54.323341, 29.7730672],
  [54.3232409, 29.7731584],
  [54.3231095, 29.7731638],
  [54.3229127, 29.7730427],
  [54.3227638, 29.7730082],
  [54.3225466, 29.7729889],
  [54.3224402, 29.7729395],
  [54.3223147, 29.7728246],
  [54.322161, 29.7725817],
  [54.3220645, 29.7723055],
  [54.3220066, 29.7720185],
  [54.3219675, 29.7717556],
  [54.3219519, 29.7714177],
  [54.3219378, 29.7709993],
  [54.3219706, 29.7707874],
  [54.3220457, 29.770613],
  [54.3222209, 29.7704011],
  [54.3223555, 29.7701624],
  [54.3223977, 29.7700363],
  [54.3224055, 29.769862],
  [54.3223289, 29.7696689],
  [54.3222194, 29.7695214],
  [54.3219769, 29.7692665],
  [54.3218455, 29.7692102],
  [54.3217477, 29.7692151],
  [54.3216828, 29.7693014],
  [54.3216327, 29.7694087],
  [54.3215514, 29.769457],
  [54.3213543, 29.7694516],
  [54.321251, 29.7694945],
  [54.3211125, 29.769561],
  [54.3209898, 29.7696501],
  [54.3208427, 29.7697681],
  [54.3205471, 29.770098],
  [54.3200371, 29.7706291],
  [54.3198728, 29.7706962],
  [54.3196253, 29.7706883],
  [54.3194223, 29.7706572],
  [54.3192337, 29.770553],
  [54.3191285, 29.7704565],
  [54.3189415, 29.7702479],
  [54.3186744, 29.7700015],
  [54.3185743, 29.7698593],
  [54.3184738, 29.7696343],
  [54.3184554, 29.7694302],
  [54.3184804, 29.7692826],
  [54.3186009, 29.76906],
  [54.3186494, 29.768765],
  [54.3186447, 29.7685692],
  [54.3185868, 29.7684082],
  [54.3185211, 29.7683331],
  [54.3182103, 29.7681748],
  [54.3180377, 29.7680595],
  [54.3179407, 29.7678664],
  [54.3179407, 29.7675768],
  [54.3180595, 29.76724],
  [54.3183506, 29.7669778],
  [54.3185764, 29.766753],
  [54.3187326, 29.7663435],
  [54.3188644, 29.7659247],
  [54.3189479, 29.7655134],
  [54.3189981, 29.765275],
  [54.3189926, 29.7647002],
  [54.3190116, 29.7642307],
  [54.319096, 29.7636771],
  [54.3194939, 29.7625873],
  [54.3197555, 29.7617684],
  [54.3199356, 29.7613208],
  [54.3200763, 29.7610899],
  [54.3201843, 29.760887],
  [54.320286, 29.7605933],
  [54.3203808, 29.7600359],
  [54.3204445, 29.7595984],
  [54.3204537, 29.759245],
  [54.3204181, 29.7589581],
  [54.3203458, 29.7587213],
  [54.3202354, 29.7584658],
  [54.3201376, 29.7583781],
  [54.3200848, 29.7583525],
  [54.3198214, 29.7583163],
  [54.3197023, 29.7582661],
  [54.3195676, 29.7581648],
  [54.319403, 29.7579573],
  [54.3192499, 29.7575686],
  [54.3191052, 29.7570521],
  [54.3189824, 29.7563674],
  [54.3191391, 29.7561988],
  [54.319233, 29.7560835],
  [54.3193831, 29.7560593],
  [54.3195584, 29.7559547],
  [54.3196766, 29.7559456],
  [54.3198822, 29.7557804],
  [54.3199601, 29.7555406],
  [54.3200745, 29.7549361],
  [54.32044, 29.75364],
  [54.3203247, 29.7516016],
  [54.3207974, 29.7503862],
  [54.3209847, 29.7492825],
  [54.3214444, 29.7488627],
  [54.3213951, 29.7459323],
  [54.3209982, 29.7366428],
  [54.319343, 29.7317616],
  [54.3193109, 29.7316815],
  [54.3191313, 29.731296],
  [54.3192665, 29.7280999],
  [54.3195892, 29.7251903],
  [54.3196419, 29.7247151],
  [54.3196516, 29.7224566],
  [54.3209703, 29.718254],
  [54.3215956, 29.7141801],
  [54.3181995, 29.7046877],
  [54.3172346, 29.6994165],
  [54.3171259, 29.6988222],
  [54.3167561, 29.698635],
  [54.3166554, 29.6989374],
  [54.3166688, 29.6992954],
  [54.3163804, 29.6997488],
  [54.31641, 29.70034],
  [54.3156238, 29.7001412],
  [54.3153704, 29.6994846],
  [54.3149503, 29.699619],
  [54.3148934, 29.6992387],
  [54.3148815, 29.6991589],
  [54.3146611, 29.6965748],
  [54.3137069, 29.690345],
  [54.3237486, 29.6725978],
  [54.3244335, 29.671473],
  [54.3246523, 29.6692044],
  [54.3243757, 29.667928],
  [54.3244782, 29.6641894],
  [54.3312577, 29.6648338],
  [54.3330233, 29.6505031],
  [54.3333669, 29.6501469],
  [54.3347181, 29.6406626],
  [54.3353311, 29.6385169],
  [54.336332, 29.6368432],
  [54.3365446, 29.6351695],
  [54.3367698, 29.6346545],
  [54.3383961, 29.628818],
  [54.3388715, 29.6275735],
  [54.3391717, 29.6254706],
  [54.3390216, 29.6205997],
  [54.3390686, 29.6185821],
  [54.3503662, 29.6226382],
  [54.3518669, 29.6229172],
  [54.3522421, 29.621973],
  [54.353073, 29.6227127],
  [54.3503662, 29.6134972],
  [54.3482526, 29.6026611],
  [54.3452541, 29.5830324],
  [54.3429494, 29.5681142],
  [54.3406478, 29.5718479],
  [54.3389466, 29.5698738],
  [54.3387214, 29.568758],
  [54.3350684, 29.5645952],
  [54.3347181, 29.5659256],
  [54.3295067, 29.5628349],
  [54.322368, 29.5610547],
  [54.3186009, 29.5618057],
  [54.3191892, 29.5633077],
  [54.3187761, 29.5650673],
  [54.3180127, 29.5664835],
  [54.3168862, 29.565947],
  [54.3149837, 29.569788],
  [54.3135818, 29.5686507],
  [54.3134566, 29.5675564],
  [54.3126805, 29.5673203],
  [54.3111033, 29.5683932],
  [54.310888, 29.5736717],
  [54.3073602, 29.5720625],
  [54.3049307, 29.5701526],
  [54.3061083, 29.5583725],
  [54.3082491, 29.5523214],
  [54.3083592, 29.5299622],
  [54.3073602, 29.5309925],
  [54.3063712, 29.5309496],
  [54.3051943, 29.5290828],
  [54.3042546, 29.5235673],
  [54.3020267, 29.5208859],
  [54.3021143, 29.5243835],
  [54.2992345, 29.5221734],
  [54.2930358, 29.5205855],
  [54.2920339, 29.521594],
  [54.2917082, 29.5208001],
  [54.2910194, 29.5216155],
  [54.2897541, 29.5224731],
  [54.2893316, 29.5184729],
  [54.2898171, 29.5172167],
  [54.2899679, 29.5155646],
  [54.2896013, 29.5111311],
  [54.2848413, 29.5001617],
  [54.2792024, 29.5081355],
  [54.2791327, 29.5086672],
  [54.27852, 29.5075357],
  [54.2769873, 29.5045636],
  [54.2755338, 29.5068801],
  [54.2753283, 29.5066923],
  [54.2718338, 29.5050851],
  [54.2713359, 29.5044895],
  [54.2714207, 29.504175],
  [54.2705946, 29.5034689],
  [54.2702653, 29.5035689],
  [54.2689878, 29.502096],
  [54.2675993, 29.5012346],
  [54.2669527, 29.5001274],
  [54.2628738, 29.4990835],
  [54.2598162, 29.4915382],
  [54.2567805, 29.4904682],
  [54.2555498, 29.487407],
  [54.2605081, 29.473723],
  [54.2580092, 29.4579506],
  [54.2517115, 29.4535897],
  [54.251959, 29.4524715],
  [54.2406425, 29.445912],
  [54.2389593, 29.4387586],
  [54.2401823, 29.4370563],
  [54.240505, 29.4328301],
  [54.2407938, 29.4306652],
  [54.2409353, 29.4296291],
  [54.2413463, 29.4292011],
  [54.2421838, 29.4290256],
  [54.2431619, 29.4299697],
  [54.2474882, 29.4222062],
  [54.2457027, 29.4032272],
  [54.2442198, 29.3976006],
  [54.2427502, 29.3997615],
  [54.2418781, 29.4005765],
  [54.2405731, 29.4009681],
  [54.2378083, 29.401021],
  [54.2340158, 29.4008562],
  [54.2335862, 29.4009181],
  [54.2293655, 29.4016671],
  [54.2295848, 29.4077116],
  [54.2271346, 29.4138555],
  [54.2284046, 29.4344673],
  [54.2204798, 29.4354111],
  [54.2212246, 29.448457],
  [54.2123673, 29.4618808],
  [54.2116567, 29.461972],
  [54.2107755, 29.4594711],
  [54.2101172, 29.4578682],
  [54.2091685, 29.4568943],
  [54.2049758, 29.4533669],
  [54.2040235, 29.4460624],
  [54.2029119, 29.4472555],
  [54.2007879, 29.4556496],
  [54.1977874, 29.4559678],
  [54.1965, 29.4478909],
  [54.1912312, 29.445744],
  [54.1901936, 29.4502596],
  [54.1861196, 29.444773],
  [54.1846479, 29.4395971],
  [54.1830921, 29.4377194],
  [54.181679, 29.4332305],
  [54.1750399, 29.4276343],
  [54.1685515, 29.4409743],
  [54.1604344, 29.4325651],
  [54.1596645, 29.4330805],
  [54.1594936, 29.4327458],
  [54.1592976, 29.4327458],
  [54.1591213, 29.4324771],
  [54.1590207, 29.4318849],
  [54.1587669, 29.4315115],
  [54.1582392, 29.4317347],
  [54.1580106, 29.431533],
  [54.1579201, 29.4312583],
  [54.1577166, 29.4311553],
  [54.1575557, 29.431357],
  [54.1572491, 29.4309966],
  [54.157023, 29.4306361],
  [54.1567415, 29.4307262],
  [54.1566008, 29.430606],
  [54.1563872, 29.4305932],
  [54.1560982, 29.4308206],
  [54.1559072, 29.4308764],
  [54.1558796, 29.4313871],
  [54.1558544, 29.4316532],
  [54.1556735, 29.431636],
  [54.1555805, 29.431842],
  [54.1556559, 29.4322196],
  [54.1554775, 29.4323741],
  [54.155098, 29.4325887],
  [54.1549246, 29.4323226],
  [54.1548567, 29.4323484],
  [54.1548517, 29.4325844],
  [54.1549918, 29.4329329],
  [54.1548737, 29.4331518],
  [54.1547757, 29.4331775],
  [54.1547103, 29.4332891],
  [54.1546299, 29.4332848],
  [54.1545344, 29.4334136],
  [54.1545193, 29.4335981],
  [54.1546224, 29.4339028],
  [54.1544892, 29.4341045],
  [54.1543384, 29.4341303],
  [54.154273, 29.4339715],
  [54.1541951, 29.4338298],
  [54.153974, 29.4338599],
  [54.1539287, 29.4336324],
  [54.1537729, 29.4335251],
  [54.1536472, 29.4335509],
  [54.1535945, 29.4337011],
  [54.1536422, 29.4339028],
  [54.1535869, 29.4340916],
  [54.1534663, 29.4341474],
  [54.1533155, 29.4340358],
  [54.1530516, 29.4340187],
  [54.1528782, 29.4344221],
  [54.1527576, 29.4343663],
  [54.1527576, 29.4341946],
  [54.1526545, 29.4341388],
  [54.1525264, 29.4342333],
  [54.1524434, 29.4341174],
  [54.1522298, 29.4341431],
  [54.1520438, 29.4339758],
  [54.1518553, 29.4340144],
  [54.1516618, 29.4339972],
  [54.1516316, 29.4337998],
  [54.1516894, 29.4336539],
  [54.1515587, 29.4333578],
  [54.1516417, 29.4332419],
  [54.1516718, 29.433126],
  [54.1516417, 29.4328728],
  [54.1514909, 29.4328643],
  [54.1513476, 29.4332033],
  [54.1512194, 29.4331904],
  [54.1511843, 29.4330059],
  [54.1512345, 29.4328685],
  [54.1512747, 29.4325081],
  [54.151227, 29.4323922],
  [54.1510134, 29.4324222],
  [54.1508651, 29.4322377],
  [54.1508123, 29.4320489],
  [54.1508374, 29.4318472],
  [54.1507746, 29.4317828],
  [54.1506012, 29.4317699],
  [54.1504353, 29.4312206],
  [54.1504604, 29.4309459],
  [54.1501714, 29.4308472],
  [54.1501286, 29.430697],
  [54.1499552, 29.4306541],
  [54.1500206, 29.4303709],
  [54.1497717, 29.4302679],
  [54.1497743, 29.4304953],
  [54.1495832, 29.4305983],
  [54.1494228, 29.4304175],
  [54.1492267, 29.430389],
  [54.1486652, 29.4296216],
  [54.1484014, 29.429577],
  [54.1481098, 29.430144],
  [54.1480376, 29.4304949],
  [54.1479757, 29.4307585],
  [54.1473168, 29.4314155],
  [54.1466526, 29.4318745],
  [54.1464138, 29.4322953],
  [54.1455947, 29.432498],
  [54.1453222, 29.4320322],
  [54.1451704, 29.4325235],
  [54.1447561, 29.432034],
  [54.14425, 29.43111],
  [54.1439872, 29.4303026],
  [54.1435947, 29.4296362],
  [54.1435567, 29.4292805],
  [54.1434634, 29.4289676],
  [54.1425999, 29.4289004],
  [54.1416888, 29.4285793],
  [54.1400433, 29.4270231],
  [54.1396662, 29.4265219],
  [54.1391919, 29.4253392],
  [54.1388609, 29.4237207],
  [54.1389018, 29.422682],
  [54.1390824, 29.4213988],
  [54.1392511, 29.4205911],
  [54.1392036, 29.4202468],
  [54.1392036, 29.4195809],
  [54.1391034, 29.4191939],
  [54.1385278, 29.4190203],
  [54.1383483, 29.4187912],
  [54.1383975, 29.4182801],
  [54.1382678, 29.4182619],
  [54.1377895, 29.4179849],
  [54.1375833, 29.4181223],
  [54.1372389, 29.4187917],
  [54.1372364, 29.4192981],
  [54.13699, 29.41959],
  [54.1368552, 29.420306],
  [54.1366516, 29.4206279],
  [54.1363197, 29.4207309],
  [54.1361915, 29.4207094],
  [54.1361563, 29.4205464],
  [54.1357716, 29.4205077],
  [54.1356157, 29.4205549],
  [54.1355353, 29.4208124],
  [54.1354322, 29.4209712],
  [54.135231, 29.420894],
  [54.1349369, 29.4207266],
  [54.1345496, 29.4207223],
  [54.1344742, 29.4204863],
  [54.1343912, 29.4196923],
  [54.1343736, 29.4194606],
  [54.1344566, 29.4193576],
  [54.1344767, 29.4191988],
  [54.1344717, 29.4190443],
  [54.1343485, 29.4187997],
  [54.1343284, 29.4185594],
  [54.1341976, 29.4183748],
  [54.1341247, 29.4183105],
  [54.1339412, 29.4183362],
  [54.1338582, 29.4185851],
  [54.1336545, 29.4182633],
  [54.1336621, 29.4179586],
  [54.133481, 29.4177611],
  [54.1333101, 29.4172333],
  [54.1332195, 29.4170488],
  [54.1330511, 29.4170015],
  [54.1328776, 29.4168342],
  [54.13287, 29.4166711],
  [54.1330033, 29.4165981],
  [54.1331843, 29.4166153],
  [54.1332346, 29.4164909],
  [54.1331693, 29.4163063],
  [54.1329731, 29.4161733],
  [54.132772, 29.4162076],
  [54.1326915, 29.4167097],
  [54.1326563, 29.4168342],
  [54.1325432, 29.4166926],
  [54.1324149, 29.4167269],
  [54.1322012, 29.4166368],
  [54.1320654, 29.4164351],
  [54.1321408, 29.4161389],
  [54.1321283, 29.4159716],
  [54.132254, 29.4158257],
  [54.1321434, 29.4156411],
  [54.1319246, 29.4156712],
  [54.1317285, 29.4160059],
  [54.131741, 29.4161733],
  [54.1316757, 29.4163106],
  [54.1316709, 29.4164521],
  [54.1314672, 29.4162933],
  [54.131437, 29.416053],
  [54.1315476, 29.4158427],
  [54.1315652, 29.4156797],
  [54.1315275, 29.4154779],
  [54.1312057, 29.4153106],
  [54.1310221, 29.4153192],
  [54.1310095, 29.4152033],
  [54.1310825, 29.414993],
  [54.1308059, 29.4142978],
  [54.1305343, 29.413933],
  [54.1305242, 29.4138643],
  [54.1305821, 29.4134481],
  [54.1308637, 29.4131047],
  [54.1310171, 29.4132764],
  [54.131085, 29.413212],
  [54.1310975, 29.4129932],
  [54.1309442, 29.4127056],
  [54.130924, 29.4125554],
  [54.1307933, 29.4125168],
  [54.1307354, 29.4126455],
  [54.1306374, 29.412667],
  [54.1305519, 29.4125597],
  [54.1304186, 29.4126627],
  [54.1303708, 29.4123108],
  [54.1304111, 29.4122078],
  [54.1303281, 29.4120533],
  [54.1300917, 29.4121348],
  [54.1299861, 29.4118816],
  [54.1299836, 29.4114954],
  [54.1300817, 29.4110877],
  [54.129976, 29.4109079],
  [54.1298955, 29.4108264],
  [54.129903, 29.410453],
  [54.1300137, 29.4102685],
  [54.1299181, 29.4100883],
  [54.1297597, 29.4100754],
  [54.1295963, 29.4103972],
  [54.1294303, 29.4103887],
  [54.1294026, 29.4101269],
  [54.1294906, 29.4099209],
  [54.1294127, 29.4097364],
  [54.1290858, 29.4095733],
  [54.1289676, 29.4098265],
  [54.1288192, 29.4096462],
  [54.1287413, 29.40929],
  [54.1288695, 29.408981],
  [54.1287186, 29.408715],
  [54.1287312, 29.408436],
  [54.1288343, 29.4081957],
  [54.1288117, 29.4080069],
  [54.128701, 29.4078695],
  [54.1283414, 29.4079597],
  [54.128437, 29.4071314],
  [54.1285577, 29.4071142],
  [54.1285376, 29.4067323],
  [54.1284294, 29.406419],
  [54.1284244, 29.4062388],
  [54.1283842, 29.4061529],
  [54.1282811, 29.406183],
  [54.1282358, 29.4061272],
  [54.128321, 29.4059613],
  [54.1283026, 29.4057661],
  [54.1279769, 29.4060267],
  [54.1276553, 29.4062732],
  [54.127115, 29.4066918],
  [54.1265317, 29.4071651],
  [54.1262384, 29.407468],
  [54.1261532, 29.4076046],
  [54.1260514, 29.408619],
  [54.1263303, 29.4097781],
  [54.1265064, 29.4101858],
  [54.1265944, 29.4108081],
  [54.1266764, 29.4109849],
  [54.1267958, 29.4111192],
  [54.1268488, 29.4112767],
  [54.1268147, 29.4114413],
  [54.126686, 29.4114673],
  [54.1264246, 29.411366],
  [54.1259783, 29.4109583],
  [54.1258085, 29.411248],
  [54.1254909, 29.4125663],
  [54.1253143, 29.4131484],
  [54.1252962, 29.4133791],
  [54.1252615, 29.4138229],
  [54.1251546, 29.4139409],
  [54.1249346, 29.413737],
  [54.1247208, 29.4139945],
  [54.1246325, 29.4142662],
  [54.1245739, 29.4147807],
  [54.1246065, 29.415366],
  [54.1245011, 29.4157398],
  [54.124545, 29.4160782],
  [54.124507, 29.4161618],
  [54.1243885, 29.4161823],
  [54.1242618, 29.416033],
  [54.1241361, 29.4160974],
  [54.1238846, 29.4166231],
  [54.1237651, 29.4167089],
  [54.1236749, 29.4166082],
  [54.1235534, 29.416569],
  [54.123436, 29.4166765],
  [54.1233215, 29.4173312],
  [54.1232558, 29.4175722],
  [54.1232819, 29.4178036],
  [54.1234781, 29.4180279],
  [54.1235044, 29.4183428],
  [54.1235722, 29.4187073],
  [54.1232814, 29.4192753],
  [54.1231739, 29.4196197],
  [54.1229586, 29.420134],
  [54.1228585, 29.4202298],
  [54.122634, 29.4202832],
  [54.1223883, 29.4205173],
  [54.1221525, 29.4204716],
  [54.1219417, 29.4205391],
  [54.1218663, 29.4207114],
  [54.1218991, 29.4209321],
  [54.1219734, 29.4210041],
  [54.121987, 29.4211541],
  [54.121853, 29.421492],
  [54.1218097, 29.4216013],
  [54.1217153, 29.4227815],
  [54.1217908, 29.4236076],
  [54.121692, 29.4236537],
  [54.1215243, 29.4234165],
  [54.1213318, 29.4232643],
  [54.121154, 29.4233907],
  [54.1210259, 29.4237153],
  [54.1210322, 29.4240114],
  [54.1210912, 29.4242165],
  [54.1212373, 29.4243579],
  [54.1212438, 29.4245195],
  [54.1208609, 29.4250051],
  [54.1205772, 29.425528],
  [54.120571, 29.4257426],
  [54.120703, 29.4261396],
  [54.1206778, 29.4263542],
  [54.1204354, 29.4265664],
  [54.1203257, 29.4266653],
  [54.1202045, 29.4266018],
  [54.1200999, 29.42634],
  [54.1200239, 29.426322],
  [54.1199044, 29.4264293],
  [54.1197472, 29.4267833],
  [54.1197598, 29.4272232],
  [54.1198918, 29.4278562],
  [54.1198353, 29.42806],
  [54.1197095, 29.428103],
  [54.1194957, 29.4277704],
  [54.1194011, 29.4273148],
  [54.1192966, 29.4272184],
  [54.1190846, 29.4273967],
  [54.1189888, 29.4275043],
  [54.1187977, 29.4275565],
  [54.1186594, 29.4275987],
  [54.1185642, 29.4275342],
  [54.1185022, 29.4267619],
  [54.1185022, 29.4265365],
  [54.1185799, 29.4263378],
  [54.1185353, 29.426007],
  [54.1184493, 29.4258177],
  [54.1183582, 29.4257778],
  [54.1181467, 29.4260693],
  [54.1179933, 29.4260635],
  [54.1177853, 29.4259357],
  [54.1176612, 29.4257202],
  [54.1176408, 29.4254765],
  [54.1177792, 29.4252214],
  [54.1177723, 29.4248955],
  [54.1176324, 29.4247702],
  [54.1175149, 29.4247341],
  [54.1169741, 29.4250667],
  [54.11685, 29.42499],
  [54.1167603, 29.4247126],
  [54.1166609, 29.424718],
  [54.1164509, 29.4244401],
  [54.1162194, 29.4244444],
  [54.1158673, 29.4241977],
  [54.1157415, 29.4242835],
  [54.1154396, 29.4247341],
  [54.1153013, 29.4251203],
  [54.114818, 29.4258207],
  [54.1147667, 29.4263971],
  [54.114641, 29.4264507],
  [54.1144858, 29.4260887],
  [54.1143511, 29.4261179],
  [54.1140697, 29.4270405],
  [54.1136473, 29.4279206],
  [54.113597, 29.4281351],
  [54.1135467, 29.428575],
  [54.1137102, 29.4289184],
  [54.1136473, 29.4291222],
  [54.1134209, 29.429326],
  [54.1131052, 29.4302086],
  [54.1129304, 29.4301736],
  [54.1127102, 29.4299483],
  [54.1125783, 29.4301174],
  [54.1124461, 29.4309461],
  [54.112465, 29.4311714],
  [54.1123832, 29.4313645],
  [54.1122574, 29.4314504],
  [54.1121467, 29.4313105],
  [54.1120664, 29.4310177],
  [54.1120159, 29.4304761],
  [54.1118971, 29.4301837],
  [54.1116924, 29.4301547],
  [54.1113837, 29.4302567],
  [54.1111442, 29.4301414],
  [54.1110436, 29.4301844],
  [54.1109807, 29.4303882],
  [54.1109726, 29.4306382],
  [54.1112008, 29.4308925],
  [54.1112448, 29.431107],
  [54.1111379, 29.4312358],
  [54.1109885, 29.4310671],
  [54.1107963, 29.4310881],
  [54.1107228, 29.4311714],
  [54.1107532, 29.4313293],
  [54.1109082, 29.4315381],
  [54.1109428, 29.4317186],
  [54.1109241, 29.4321692],
  [54.1108612, 29.4323623],
  [54.1107417, 29.4322979],
  [54.11067, 29.43212],
  [54.1106285, 29.4320726],
  [54.1104964, 29.4320726],
  [54.1102079, 29.4323336],
  [54.1101112, 29.4322726],
  [54.1099681, 29.4324696],
  [54.1097837, 29.4337835],
  [54.109574, 29.4350742],
  [54.1096093, 29.4354186],
  [54.1096993, 29.4357106],
  [54.1097567, 29.436083],
  [54.1099303, 29.4362998],
  [54.1099065, 29.4364925],
  [54.1097084, 29.4366851],
  [54.1094382, 29.4366674],
  [54.1092825, 29.4369006],
  [54.1091297, 29.4369679],
  [54.1090449, 29.4367896],
  [54.1090183, 29.4362998],
  [54.1089114, 29.4361603],
  [54.108773, 29.4361496],
  [54.1085207, 29.436494],
  [54.1083481, 29.4368172],
  [54.1083032, 29.4371384],
  [54.1079762, 29.437955],
  [54.1079868, 29.438113],
  [54.1081755, 29.4384456],
  [54.1084145, 29.4386494],
  [54.10861, 29.43838],
  [54.108729, 29.4383061],
  [54.1088108, 29.4384885],
  [54.1087605, 29.4386923],
  [54.1086661, 29.438864],
  [54.1085592, 29.4390035],
  [54.10821, 29.4392235],
  [54.1081, 29.4393682],
  [54.1077428, 29.4391716],
  [54.1075472, 29.4392597],
  [54.1074038, 29.4391551],
  [54.1073102, 29.4392062],
  [54.1072322, 29.4395257],
  [54.1072057, 29.440004],
  [54.1071377, 29.4403124],
  [54.1071628, 29.4413423],
  [54.1070445, 29.4416932],
  [54.1067603, 29.4424689],
  [54.1067395, 29.4434667],
  [54.1067007, 29.4436628],
  [54.1063138, 29.4445741],
  [54.1057265, 29.4458376],
  [54.1055589, 29.4461059],
  [54.1045964, 29.445591],
  [54.1042693, 29.4452369],
  [54.1040177, 29.4451404],
  [54.1037875, 29.4448399],
  [54.1036761, 29.4448226],
  [54.1035874, 29.4450512],
  [54.1035193, 29.4453577],
  [54.1034704, 29.4453764],
  [54.1033383, 29.4453549],
  [54.1032314, 29.4452262],
  [54.1031496, 29.4448185],
  [54.1030678, 29.4446576],
  [54.1029357, 29.4445825],
  [54.1028162, 29.4441962],
  [54.1023877, 29.4439036],
  [54.1021165, 29.4432027],
  [54.1019544, 29.4430697],
  [54.1018474, 29.4431877],
  [54.1018262, 29.4434648],
  [54.1016084, 29.4439602],
  [54.1009982, 29.4448078],
  [54.1009604, 29.4450223],
  [54.1010849, 29.4453988],
  [54.1010674, 29.4455875],
  [54.1009686, 29.4456443],
  [54.1008614, 29.445492],
  [54.1008031, 29.4451712],
  [54.1007131, 29.4450077],
  [54.1002026, 29.4449243],
  [54.0994597, 29.4449966],
  [54.0994064, 29.4451597],
  [54.0993435, 29.4454116],
  [54.0992807, 29.4454086],
  [54.0990013, 29.4450757],
  [54.098834, 29.4450867],
  [54.0985383, 29.445548],
  [54.0984125, 29.445591],
  [54.0983307, 29.44543],
  [54.0983433, 29.4452155],
  [54.0985195, 29.444915],
  [54.0985635, 29.4447219],
  [54.0984376, 29.4446204],
  [54.0983118, 29.4446039],
  [54.0979281, 29.4447434],
  [54.0978211, 29.4449043],
  [54.0977348, 29.4453191],
  [54.097526, 29.4455963],
  [54.0974099, 29.4461642],
  [54.0971314, 29.4468245],
  [54.0971228, 29.4470286],
  [54.0972575, 29.4472368],
  [54.0972659, 29.4473958],
  [54.0971165, 29.4475973],
  [54.0969969, 29.4475114],
  [54.0969026, 29.4473505],
  [54.0968774, 29.4471359],
  [54.0968774, 29.4469213],
  [54.0969466, 29.4465136],
  [54.0968837, 29.4463313],
  [54.0966949, 29.4460416],
  [54.0966446, 29.4458377],
  [54.0965522, 29.445814],
  [54.0964118, 29.4458592],
  [54.0963827, 29.445733],
  [54.0964573, 29.4454678],
  [54.09659, 29.44533],
  [54.0967229, 29.4450745],
  [54.0967893, 29.4448614],
  [54.0966949, 29.4447005],
  [54.0965683, 29.4447331],
  [54.0963347, 29.4450317],
  [54.0962088, 29.4449395],
  [54.0961979, 29.4446897],
  [54.0960658, 29.444679],
  [54.095594, 29.4454168],
  [54.0955562, 29.4455784],
  [54.095648, 29.4459256],
  [54.0956568, 29.4461596],
  [54.0955581, 29.4462666],
  [54.0954317, 29.4462352],
  [54.0951535, 29.4453978],
  [54.0952541, 29.4450009],
  [54.0954223, 29.4446546],
  [54.0954474, 29.4445391],
  [54.0952465, 29.4440828],
  [54.09529, 29.4437529],
  [54.0952101, 29.4436383],
  [54.0950843, 29.4436383],
  [54.0949773, 29.4437778],
  [54.0949836, 29.4439924],
  [54.0949584, 29.4442069],
  [54.0948623, 29.4443718],
  [54.094776, 29.4444966],
  [54.0946501, 29.4444859],
  [54.0942537, 29.4446361],
  [54.0937567, 29.4444108],
  [54.0936749, 29.4442284],
  [54.0936119, 29.4440353],
  [54.0936659, 29.4437535],
  [54.0938114, 29.4431053],
  [54.0937818, 29.4428873],
  [54.0936778, 29.4426301],
  [54.0933037, 29.4424766],
  [54.0932344, 29.4423723],
  [54.0932143, 29.4422307],
  [54.0932773, 29.4420608],
  [54.0940739, 29.4413021],
  [54.0941462, 29.4411889],
  [54.0940979, 29.4409622],
  [54.0939749, 29.4408134],
  [54.0938378, 29.4406408],
  [54.0937144, 29.440251],
  [54.0936479, 29.4400765],
  [54.0936977, 29.439961],
  [54.0939841, 29.4397038],
  [54.0941153, 29.4394326],
  [54.0941101, 29.4392513],
  [54.0938957, 29.439196],
  [54.0937063, 29.4389284],
  [54.0935805, 29.4385421],
  [54.0935364, 29.4381237],
  [54.0936731, 29.4378902],
  [54.0938301, 29.4377762],
  [54.0939517, 29.4378018],
  [54.0941128, 29.4377235],
  [54.0941405, 29.4375765],
  [54.0939265, 29.4370615],
  [54.093839, 29.4368895],
  [54.0938829, 29.4366676],
  [54.0941261, 29.4363749],
  [54.0945417, 29.4360491],
  [54.0946208, 29.4358835],
  [54.0946917, 29.4356046],
  [54.0947445, 29.4354415],
  [54.0949647, 29.4352162],
  [54.0949144, 29.4347978],
  [54.0948389, 29.4346261],
  [54.0948137, 29.4341755],
  [54.0948703, 29.4339824],
  [54.0948782, 29.433742],
  [54.094774, 29.4334663],
  [54.0947948, 29.4331455],
  [54.0949583, 29.4326996],
  [54.0949616, 29.432437],
  [54.0947885, 29.4321095],
  [54.0947552, 29.4318243],
  [54.0949333, 29.4309676],
  [54.0950153, 29.4308037],
  [54.0952959, 29.4309253],
  [54.0953691, 29.4308171],
  [54.0953073, 29.4305394],
  [54.0950504, 29.4300563],
  [54.0950234, 29.4299019],
  [54.0950672, 29.4298232],
  [54.0952313, 29.4297799],
  [54.0954873, 29.4298264],
  [54.0956379, 29.4297938],
  [54.0958141, 29.4294226],
  [54.096028, 29.4287574],
  [54.0960154, 29.4285428],
  [54.0958267, 29.4282424],
  [54.0955313, 29.4282929],
  [54.095366, 29.4282109],
  [54.0953094, 29.4279789],
  [54.0953031, 29.4273967],
  [54.0953851, 29.4270293],
  [54.0953912, 29.4265186],
  [54.0954627, 29.4259968],
  [54.0956212, 29.4258077],
  [54.0957491, 29.4257956],
  [54.0959351, 29.4259745],
  [54.0960006, 29.4263774],
  [54.0960909, 29.4265962],
  [54.0962168, 29.4265473],
  [54.096293, 29.4263612],
  [54.0963277, 29.4261398],
  [54.0963049, 29.4259465],
  [54.0961684, 29.4255392],
  [54.0959149, 29.4253883],
  [54.0957266, 29.4252716],
  [54.0954869, 29.424938],
  [54.0953614, 29.4247452],
  [54.0953845, 29.4245307],
  [54.0956694, 29.4243103],
  [54.0958953, 29.4237789],
  [54.0958317, 29.4236616],
  [54.0955165, 29.4239047],
  [54.0955231, 29.4236725],
  [54.0954093, 29.4235789],
  [54.095285, 29.4238295],
  [54.0951139, 29.4235225],
  [54.0950032, 29.4237496],
  [54.0951745, 29.4240837],
  [54.09496, 29.4243446],
  [54.0947967, 29.4240433],
  [54.0946536, 29.4237849],
  [54.0945205, 29.4239729],
  [54.0943471, 29.4234399],
  [54.0940269, 29.4230792],
  [54.0939706, 29.4232846],
  [54.0940794, 29.4234626],
  [54.0939969, 29.4237265],
  [54.0936003, 29.423413],
  [54.0936426, 29.4231466],
  [54.0933691, 29.4223386],
  [54.0752666, 29.4249834],
  [54.0654094, 29.4263378],
  [54.0602955, 29.4246543],
  [54.0573982, 29.4218207],
  [54.0515877, 29.4167127],
  [54.0429488, 29.4265795],
  [54.041496, 29.4285741],
  [54.0414491, 29.4137593],
  [54.0438419, 29.3968733],
  [54.0265301, 29.341113],
  [54.019976, 29.3381054],
  [54.0161532, 29.3299656],
  [54.0133783, 29.3303665],
  [54.0092731, 29.3287482],
  [54.0077827, 29.3266349],
  [54.0077531, 29.3267131],
  [54.0078108, 29.3268315],
  [54.0079335, 29.3269533],
  [54.0079501, 29.3271575],
  [54.0078142, 29.3273322],
  [54.0077697, 29.327273],
  [54.0077268, 29.3271829],
  [54.0076032, 29.327303],
  [54.0075477, 29.3275391],
  [54.0075906, 29.3277193],
  [54.0075654, 29.3280154],
  [54.0074418, 29.3283587],
  [54.0071745, 29.3288823],
  [54.0070358, 29.3291012],
  [54.006945, 29.3290883],
  [54.0068189, 29.3286978],
  [54.0066574, 29.3285304],
  [54.0064759, 29.3286506],
  [54.0064204, 29.3288523],
  [54.0064305, 29.329187],
  [54.0064456, 29.3294445],
  [54.0064002, 29.3296505],
  [54.0062262, 29.329835],
  [54.0060774, 29.3300067],
  [54.0060673, 29.3301526],
  [54.0062438, 29.3303157],
  [54.0062943, 29.330629],
  [54.0062186, 29.330895],
  [54.0060597, 29.3310152],
  [54.0059235, 29.3306676],
  [54.0057924, 29.330732],
  [54.0057142, 29.3309508],
  [54.005747, 29.3311697],
  [54.0057369, 29.3312899],
  [54.0055149, 29.3314658],
  [54.0055275, 29.3317233],
  [54.0055427, 29.3320065],
  [54.0052677, 29.3325473],
  [54.0051089, 29.3324185],
  [54.0049827, 29.33244],
  [54.0049399, 29.3326889],
  [54.0048919, 29.3328906],
  [54.004786, 29.3329335],
  [54.0047532, 29.3327962],
  [54.004781, 29.332646],
  [54.0047305, 29.3323713],
  [54.0045161, 29.332543],
  [54.0043648, 29.3325387],
  [54.0042866, 29.3322082],
  [54.0041807, 29.3321782],
  [54.0041176, 29.332337],
  [54.0037267, 29.3321482],
  [54.0036964, 29.3328262],
  [54.0036283, 29.3329164],
  [54.0034265, 29.3330966],
  [54.0034467, 29.3333369],
  [54.0034467, 29.3335],
  [54.0033836, 29.3335172],
  [54.0033004, 29.3332854],
  [54.003081, 29.3332854],
  [54.0028161, 29.3327704],
  [54.0026421, 29.332852],
  [54.0027606, 29.3332511],
  [54.0027606, 29.3333412],
  [54.0029019, 29.3335257],
  [54.0029019, 29.3336931],
  [54.0028514, 29.3338777],
  [54.0025513, 29.3337189],
  [54.0024327, 29.3338347],
  [54.0024933, 29.3339935],
  [54.0024983, 29.334148],
  [54.0024302, 29.3342768],
  [54.0020266, 29.3345257],
  [54.0020493, 29.3347188],
  [54.0023848, 29.3348089],
  [54.0025437, 29.3349033],
  [54.0025361, 29.3351909],
  [54.0025008, 29.3352767],
  [54.0024352, 29.3357573],
  [54.0023268, 29.3358904],
  [54.0020317, 29.3359204],
  [54.0020064, 29.336105],
  [54.0020645, 29.3363753],
  [54.0019736, 29.3367916],
  [54.0019989, 29.3369761],
  [54.0020872, 29.3372165],
  [54.002236, 29.3373452],
  [54.002236, 29.3374911],
  [54.002146, 29.3376287],
  [54.0019795, 29.3375343],
  [54.0019114, 29.337706],
  [54.0019341, 29.3381008],
  [54.0019266, 29.3382038],
  [54.0016895, 29.3382639],
  [54.001639, 29.3386329],
  [54.0015356, 29.3385643],
  [54.0014978, 29.3388218],
  [54.0015886, 29.3392638],
  [54.0015709, 29.3393968],
  [54.0014498, 29.3396672],
  [54.0014524, 29.3398646],
  [54.0015482, 29.340032],
  [54.0016466, 29.340062],
  [54.0017601, 29.3398174],
  [54.001924, 29.3398088],
  [54.0020048, 29.3399762],
  [54.0021384, 29.3400663],
  [54.0021485, 29.3402895],
  [54.0021006, 29.3404096],
  [54.0020098, 29.3403066],
  [54.0019266, 29.3404139],
  [54.0019493, 29.3405598],
  [54.0020199, 29.3406886],
  [54.0019467, 29.3411177],
  [54.0021208, 29.3415297],
  [54.0020603, 29.341813],
  [54.0019669, 29.3418473],
  [54.0018837, 29.3415769],
  [54.0017626, 29.3415683],
  [54.0017323, 29.3416585],
  [54.0017954, 29.3419331],
  [54.0016668, 29.3421091],
  [54.0014851, 29.3419632],
  [54.0013262, 29.3419675],
  [54.0011244, 29.342255],
  [54.0011345, 29.3425082],
  [54.0013212, 29.3429245],
  [54.0015129, 29.3431905],
  [54.0016289, 29.3435939],
  [54.0016012, 29.3439373],
  [54.001417, 29.3440145],
  [54.0012985, 29.3441304],
  [54.001301, 29.3443707],
  [54.0014397, 29.3446282],
  [54.0014473, 29.3447441],
  [54.001359, 29.3449029],
  [54.0013313, 29.3450445],
  [54.001417, 29.3454136],
  [54.001412, 29.3454994],
  [54.0012834, 29.3456195],
  [54.0012531, 29.3457569],
  [54.0012884, 29.3459843],
  [54.0012707, 29.3461732],
  [54.0010841, 29.3464607],
  [54.0010942, 29.3466366],
  [54.0010479, 29.3468069],
  [54.0009218, 29.3468756],
  [54.0008259, 29.3470086],
  [54.0008184, 29.3472103],
  [54.0008537, 29.3475622],
  [54.0007654, 29.3478755],
  [54.000493, 29.348412],
  [54.0004602, 29.3486051],
  [54.0003542, 29.3487596],
  [54.0003189, 29.348987],
  [54.0003189, 29.3492059],
  [54.0001423, 29.3495964],
  [54.0001474, 29.3497552],
  [54.0002306, 29.3498668],
  [54.0001978, 29.3502573],
  [54.0001121, 29.3504118],
  [54.00016, 29.3505491],
  [54.0001045, 29.3507809],
  [53.9999823, 29.3508767],
  [53.9999016, 29.3508038],
  [53.9998309, 29.3508682],
  [53.9998032, 29.3509797],
  [53.9997073, 29.3506879],
  [53.9995509, 29.3508682],
  [53.9996039, 29.3514861],
  [53.9993946, 29.3515677],
  [53.9993718, 29.3517565],
  [53.9994728, 29.3521041],
  [53.999387, 29.3523359],
  [53.9994072, 29.3525032],
  [53.9995333, 29.3527865],
  [53.9995232, 29.3530354],
  [53.9993491, 29.35325],
  [53.9993567, 29.3535547],
  [53.9995308, 29.3537778],
  [53.9994072, 29.353928],
  [53.9994526, 29.354207],
  [53.9994223, 29.35434],
  [53.9992861, 29.3543829],
  [53.9992482, 29.3545546],
  [53.9991045, 29.3547348],
  [53.9991019, 29.354958],
  [53.9990439, 29.3549923],
  [53.9989354, 29.3549237],
  [53.9988396, 29.3549666],
  [53.9987589, 29.3551683],
  [53.9986857, 29.3552198],
  [53.9983906, 29.3554344],
  [53.9984335, 29.3555974],
  [53.9983679, 29.3557262],
  [53.9982998, 29.355782],
  [53.9982569, 29.3560309],
  [53.9983578, 29.355988],
  [53.9983906, 29.356091],
  [53.9983805, 29.3562369],
  [53.9984057, 29.3563485],
  [53.9985066, 29.3564815],
  [53.9985192, 29.3567347],
  [53.9985142, 29.3569106],
  [53.9984536, 29.3571081],
  [53.9982493, 29.3574557],
  [53.9982468, 29.3576359],
  [53.9982014, 29.357799],
  [53.9980349, 29.3578805],
  [53.9980071, 29.3579964],
  [53.9979668, 29.3580779],
  [53.9978255, 29.3581809],
  [53.9977369, 29.3585058],
  [53.997472, 29.358686],
  [53.9973458, 29.3586216],
  [53.9972298, 29.3588405],
  [53.9845834, 29.3645487],
  [53.9785512, 29.3678366],
  [53.9671858, 29.3450827],
  [53.9652509, 29.358344],
  [53.962646, 29.3616839],
  [53.9614701, 29.3638909],
  [53.9610346, 29.3638909],
  [53.9571647, 29.3724752],
  [53.954637, 29.3752014],
  [53.9524184, 29.3720408],
  [53.9480182, 29.3666679],
  [53.9438372, 29.3711081],
  [53.9428665, 29.370397],
  [53.9428139, 29.3733678],
  [53.9305502, 29.3701713],
  [53.9276593, 29.3716597],
  [53.9255705, 29.3748235],
  [53.9218682, 29.3870973],
  [53.9211606, 29.3897366],
  [53.9196259, 29.3929333],
  [53.9197074, 29.3936419],
  [53.9201655, 29.3950541],
  [53.920188, 29.3951233],
  [53.9187034, 29.3961545],
  [53.9176203, 29.3959726],
  [53.9166714, 29.3957582],
  [53.9165121, 29.3956895],
  [53.9148801, 29.393456],
  [53.9144673, 29.3930154],
  [53.9138665, 29.392667],
  [53.9134942, 29.3923464],
  [53.9132082, 29.3921885],
  [53.9128398, 29.3923254],
  [53.9122074, 29.3925831],
  [53.9112762, 29.3930351],
  [53.9108069, 29.3931536],
  [53.9097634, 29.3936064],
  [53.9095583, 29.3935355],
  [53.9082316, 29.3934006],
  [53.907851, 29.393376],
  [53.9071909, 29.3933644],
  [53.9069902, 29.3933261],
  [53.9067703, 29.3933853],
  [53.9067544, 29.3931198],
  [53.906732, 29.392786],
  [53.9066348, 29.3926672],
  [53.9064465, 29.3929963],
  [53.9062403, 29.3927933],
  [53.9061036, 29.3927014],
  [53.9054227, 29.3929794],
  [53.9052428, 29.3927552],
  [53.9050435, 29.3922262],
  [53.9050997, 29.3917195],
  [53.9049838, 29.3913666],
  [53.9048932, 29.3912197],
  [53.9050008, 29.3910889],
  [53.9049633, 29.390869],
  [53.9048611, 29.3907996],
  [53.9046531, 29.3906723],
  [53.904586, 29.3900167],
  [53.9043427, 29.3899876],
  [53.9041109, 29.3897793],
  [53.9039707, 29.3900149],
  [53.9037155, 29.3900716],
  [53.9035146, 29.3905582],
  [53.9034383, 29.3906058],
  [53.9033692, 29.390516],
  [53.9033096, 29.3900684],
  [53.9032274, 29.3898324],
  [53.9033159, 29.3893925],
  [53.9031326, 29.3892745],
  [53.9030631, 29.3895749],
  [53.9027726, 29.3895099],
  [53.9027407, 29.3895749],
  [53.9030757, 29.3899826],
  [53.9030947, 29.3904224],
  [53.9028039, 29.3905512],
  [53.9025493, 29.390401],
  [53.9025528, 29.390152],
  [53.9024487, 29.3900252],
  [53.9024023, 29.3898655],
  [53.9023847, 29.3896082],
  [53.9022919, 29.3894676],
  [53.9021792, 29.3895436],
  [53.9020031, 29.3898011],
  [53.9018557, 29.3899611],
  [53.9019155, 29.3902238],
  [53.9018209, 29.3904527],
  [53.9017015, 29.3903752],
  [53.9016914, 29.3901971],
  [53.9016851, 29.3897894],
  [53.901546, 29.3894568],
  [53.901369, 29.3894998],
  [53.9012616, 29.3898645],
  [53.9011035, 29.3898002],
  [53.9010282, 29.389425],
  [53.9008852, 29.3892293],
  [53.900838, 29.3889848],
  [53.9008448, 29.3887882],
  [53.901024, 29.3883314],
  [53.9010188, 29.3881614],
  [53.9008603, 29.3879834],
  [53.9006536, 29.3880326],
  [53.9003847, 29.3881795],
  [53.9003692, 29.3883269],
  [53.9004112, 29.3885393],
  [53.9003151, 29.3886144],
  [53.900099, 29.3884073],
  [53.8999404, 29.3883303],
  [53.8998768, 29.3885478],
  [53.8997697, 29.3886093],
  [53.8995485, 29.3885342],
  [53.8994138, 29.3887487],
  [53.8992198, 29.3887894],
  [53.8989669, 29.388502],
  [53.8989175, 29.3883776],
  [53.898916, 29.3881557],
  [53.8988089, 29.3881265],
  [53.8986002, 29.3884269],
  [53.8983763, 29.388409],
  [53.8983421, 29.388266],
  [53.8984085, 29.3879441],
  [53.8985157, 29.3879977],
  [53.8985911, 29.3879269],
  [53.8986761, 29.3875471],
  [53.8986325, 29.3873732],
  [53.8984341, 29.3873627],
  [53.8983411, 29.3875149],
  [53.8981704, 29.3878261],
  [53.8980574, 29.3876869],
  [53.8979157, 29.3873688],
  [53.8977089, 29.3871716],
  [53.8974244, 29.3873862],
  [53.8972917, 29.3872145],
  [53.8973549, 29.3869785],
  [53.897298, 29.3866674],
  [53.8971336, 29.3870214],
  [53.896944, 29.386839],
  [53.8968273, 29.3864695],
  [53.8968447, 29.3862951],
  [53.897074, 29.3863183],
  [53.8971021, 29.3861464],
  [53.8970147, 29.3858856],
  [53.8967602, 29.3857717],
  [53.8966214, 29.3854429],
  [53.8965088, 29.3853639],
  [53.896425, 29.3853662],
  [53.8963796, 29.3856433],
  [53.8963028, 29.3856624],
  [53.8962342, 29.3855095],
  [53.8962669, 29.3853761],
  [53.896223, 29.3850314],
  [53.8963163, 29.3849016],
  [53.8961727, 29.384586],
  [53.8959261, 29.3847469],
  [53.8958103, 29.3848699],
  [53.8957807, 29.385058],
  [53.8958722, 29.3852328],
  [53.8959733, 29.3853506],
  [53.8959619, 29.3855194],
  [53.8958503, 29.3855516],
  [53.8957807, 29.3853906],
  [53.8953761, 29.3851117],
  [53.8952686, 29.3847254],
  [53.8951075, 29.3846038],
  [53.8949902, 29.3847129],
  [53.8949209, 29.384822],
  [53.8948261, 29.3846289],
  [53.8948968, 29.3843736],
  [53.8950947, 29.3843171],
  [53.8951612, 29.3842319],
  [53.8951611, 29.384027],
  [53.8949407, 29.3838872],
  [53.8947517, 29.3839494],
  [53.8945091, 29.383767],
  [53.8943469, 29.3838349],
  [53.8943026, 29.3840865],
  [53.8941701, 29.3842182],
  [53.8937573, 29.3834217],
  [53.8934252, 29.3833092],
  [53.8934095, 29.3829672],
  [53.8932984, 29.3826999],
  [53.8930811, 29.3828479],
  [53.8928622, 29.3826892],
  [53.8927292, 29.3827234],
  [53.8923621, 29.3825946],
  [53.8922276, 29.3821505],
  [53.8924151, 29.381868],
  [53.8927367, 29.3817155],
  [53.8926575, 29.3815926],
  [53.8923249, 29.3814227],
  [53.8921647, 29.3813585],
  [53.8920799, 29.3815017],
  [53.8921484, 29.3816856],
  [53.8920475, 29.3817447],
  [53.8918419, 29.3813458],
  [53.8917597, 29.3801228],
  [53.8918482, 29.379994],
  [53.8918798, 29.3794683],
  [53.8920375, 29.3795086],
  [53.89215, 29.3793235],
  [53.8922529, 29.3791464],
  [53.8921339, 29.3787913],
  [53.892, 29.3788031],
  [53.8918546, 29.378964],
  [53.8916396, 29.3784169],
  [53.8917673, 29.3781808],
  [53.8918356, 29.377698],
  [53.8917534, 29.3775157],
  [53.891804, 29.3769041],
  [53.891589, 29.3770865],
  [53.8914626, 29.3764857],
  [53.8914626, 29.375799],
  [53.8910832, 29.3754879],
  [53.8909378, 29.376078],
  [53.8908113, 29.3761209],
  [53.8906975, 29.3757776],
  [53.8903624, 29.3753806],
  [53.8904193, 29.3751875],
  [53.8903055, 29.3747047],
  [53.8901601, 29.3746403],
  [53.8901474, 29.3748227],
  [53.890021, 29.3747583],
  [53.8899135, 29.3744472],
  [53.8894519, 29.3739215],
  [53.8890662, 29.3736533],
  [53.8890725, 29.3726984],
  [53.8891421, 29.3725589],
  [53.8894013, 29.3727628],
  [53.8895467, 29.3726126],
  [53.8891484, 29.371647],
  [53.8889777, 29.3715075],
  [53.8886425, 29.3707779],
  [53.8886109, 29.3705312],
  [53.8884971, 29.3705419],
  [53.8884908, 29.3708101],
  [53.888143, 29.3714002],
  [53.887732, 29.3710784],
  [53.8877004, 29.3707565],
  [53.8877967, 29.3706519],
  [53.8879505, 29.3705473],
  [53.8880377, 29.3703381],
  [53.8882831, 29.3702096],
  [53.8883218, 29.3699932],
  [53.8882863, 29.36986],
  [53.8879249, 29.3698732],
  [53.8874601, 29.3696514],
  [53.8874095, 29.3694476],
  [53.8874727, 29.3692115],
  [53.887321, 29.3686536],
  [53.8870111, 29.3683425],
  [53.886946, 29.3676425],
  [53.8870111, 29.3673769],
  [53.8868467, 29.3664864],
  [53.8869528, 29.366262],
  [53.8868278, 29.366205],
  [53.8864535, 29.3665096],
  [53.8864122, 29.3661958],
  [53.886486, 29.3660202],
  [53.8863859, 29.3655596],
  [53.8857282, 29.3660424],
  [53.88502, 29.36586],
  [53.88348, 29.36628],
  [53.87953, 29.36757],
  [53.87841, 29.36826],
  [53.87678, 29.37152],
  [53.8767022, 29.3746246],
  [53.8766069, 29.3752273],
  [53.8767075, 29.3755286],
  [53.8765195, 29.3755245],
  [53.8766327, 29.3758911],
  [53.8765635, 29.3762703],
  [53.8764238, 29.3759505],
  [53.8763467, 29.3764821],
  [53.8761303, 29.376519],
  [53.8759509, 29.3783121],
  [53.8763418, 29.3808132],
  [53.875827, 29.3826105],
  [53.8748015, 29.3835652],
  [53.874502, 29.3832861],
  [53.87343, 29.38482],
  [53.87318, 29.38594],
  [53.8732045, 29.3867828],
  [53.8734892, 29.3869119],
  [53.8733084, 29.3874186],
  [53.873594, 29.3885698],
  [53.8765281, 29.392586],
  [53.8778657, 29.3955464],
  [53.8785214, 29.401117],
  [53.8784803, 29.4037546],
  [53.8792673, 29.4084528],
  [53.8792839, 29.4105626],
  [53.8741389, 29.4101841],
  [53.8662418, 29.4093889],
  [53.8663776, 29.4108832],
  [53.8674612, 29.4135847],
  [53.8666119, 29.4151372],
  [53.8677321, 29.4177678],
  [53.8654689, 29.4204498],
  [53.8652831, 29.4199276],
  [53.8648402, 29.4199276],
  [53.8645681, 29.419316],
  [53.8646314, 29.4189298],
  [53.8645112, 29.4186079],
  [53.8641443, 29.4186294],
  [53.8634356, 29.4182753],
  [53.8620261, 29.4150474],
  [53.8624728, 29.4138766],
  [53.862398, 29.4126105],
  [53.8609498, 29.4095723],
  [53.860908, 29.4092555],
  [53.8475928, 29.4081079],
  [53.8481344, 29.3887496],
  [53.8470837, 29.3870759],
  [53.8465647, 29.3881058],
  [53.8457039, 29.3877625],
  [53.842982, 29.3885135],
  [53.8427921, 29.3879342],
  [53.8418173, 29.3866682],
  [53.8415016, 29.3842645],
  [53.8380823, 29.3856597],
  [53.8299424, 29.3912165],
  [53.8292617, 29.3918394],
  [53.8267234, 29.392333],
  [53.8248996, 29.3934488],
  [53.8220118, 29.3937707],
  [53.8211505, 29.3954015],
  [53.8200738, 29.3963027],
  [53.8191744, 29.3977618],
  [53.817325, 29.396882],
  [53.8172616, 29.3976545],
  [53.8166282, 29.3973541],
  [53.8158704, 29.4005937],
  [53.8127897, 29.4010877],
  [53.8106612, 29.4037056],
  [53.8102304, 29.4067525],
  [53.8093182, 29.4073104],
  [53.80871, 29.4107437],
  [53.8071642, 29.4107008],
  [53.8059224, 29.4097995],
  [53.8052266, 29.4115584],
  [53.807444, 29.4599455],
  [53.8086023, 29.4828406],
  [53.8055296, 29.4836783],
  [53.80392, 29.4929043],
  [53.8016393, 29.4925189],
  [53.8006255, 29.4928193],
  [53.8004988, 29.4920897],
  [53.7986738, 29.4913816],
  [53.7981796, 29.4923258],
  [53.7959997, 29.491167],
  [53.7956194, 29.491446],
  [53.7924127, 29.4901585],
  [53.7895183, 29.488334],
  [53.7890156, 29.4894075],
  [53.7856435, 29.483056],
  [53.783924, 29.4777771],
  [53.7828798, 29.4710397],
  [53.7853393, 29.4573497],
  [53.7829401, 29.4491101],
  [53.7864295, 29.4300985],
  [53.7864295, 29.4254636],
  [53.7828291, 29.4210863],
  [53.7823727, 29.4163656],
  [53.7843251, 29.4075679],
  [53.7837672, 29.4064307],
  [53.7848322, 29.4032335],
  [53.786252, 29.4017529],
  [53.7885212, 29.3982982],
  [53.7889015, 29.3937492],
  [53.787076, 29.3863463],
  [53.785783, 29.3843293],
  [53.7814517, 29.3861525],
  [53.7805089, 29.3856382],
  [53.7803694, 29.3819046],
  [53.778645, 29.378643],
  [53.7780364, 29.3810677],
  [53.7769967, 29.382441],
  [53.775716, 29.3818402],
  [53.7748656, 29.380123],
  [53.7698699, 29.3806815],
  [53.7689441, 29.3811321],
  [53.7670037, 29.3830848],
  [53.7665598, 29.3879986],
  [53.7675744, 29.3933201],
  [53.7634015, 29.4046068],
  [53.762078, 29.4057219],
  [53.7615496, 29.4046497],
  [53.7605558, 29.4052716],
  [53.7550759, 29.394865],
  [53.7535784, 29.388191],
  [53.725933, 29.3919244],
  [53.7245152, 29.3870752],
  [53.7222047, 29.3672406],
  [53.7292533, 29.3594382],
  [53.7435067, 29.3429801],
  [53.7459346, 29.340403],
  [53.7458907, 29.3401682],
  [53.745702, 29.3371222],
  [53.7449279, 29.3342039],
  [53.7444952, 29.3319938],
  [53.7443747, 29.3284959],
  [53.7452566, 29.3212645],
  [53.7406139, 29.3179816],
  [53.7366296, 29.3184757],
  [53.7337357, 29.3146991],
  [53.7319333, 29.3154716],
  [53.7291406, 29.3126392],
  [53.7273887, 29.3138837],
  [53.7236308, 29.3192911],
  [53.7136505, 29.3186903],
  [53.712158, 29.317016],
  [53.709358, 29.3093776],
  [53.7059796, 29.3080902],
  [53.7045824, 29.3099784],
  [53.6999841, 29.3084335],
  [53.6960205, 29.3019533],
  [53.6954247, 29.297684],
  [53.695151, 29.2976164],
  [53.6945318, 29.2984758],
  [53.6945334, 29.299199],
  [53.6938453, 29.2998556],
  [53.6931604, 29.2994181],
  [53.6924686, 29.2999479],
  [53.6910422, 29.3000317],
  [53.690205, 29.2693103],
  [53.6878126, 29.2652607],
  [53.6878888, 29.2633295],
  [53.6887148, 29.2620849],
  [53.6879778, 29.2599177],
  [53.6881103, 29.2592947],
  [53.6859828, 29.2526221],
  [53.682882, 29.2486954],
  [53.6794379, 29.2523646],
  [53.6771247, 29.2518496],
  [53.6732353, 29.2523432],
  [53.6730001, 29.250133],
  [53.6727781, 29.250154],
  [53.671926, 29.2247915],
  [53.6699937, 29.2222595],
  [53.6699365, 29.2211652],
  [53.6684428, 29.2175817],
  [53.6678008, 29.2153609],
  [53.6675338, 29.2149746],
  [53.6674258, 29.213655],
  [53.6677818, 29.2121744],
  [53.6677436, 29.2115736],
  [53.6673114, 29.2108869],
  [53.6678072, 29.2099321],
  [53.6680467, 29.2092129],
  [53.6661926, 29.2006945],
  [53.6662307, 29.1998255],
  [53.6666439, 29.1990209],
  [53.6662435, 29.1983986],
  [53.6649085, 29.2022824],
  [53.6637007, 29.2004478],
  [53.6636626, 29.1988277],
  [53.6630396, 29.1981089],
  [53.6622068, 29.1977012],
  [53.659295, 29.1979802],
  [53.6561642, 29.197948],
  [53.6556646, 29.1923046],
  [53.6554357, 29.1855883],
  [53.6541004, 29.1832709],
  [53.6518621, 29.1779065],
  [53.658256, 29.1726061],
  [53.6576483, 29.1713619],
  [53.6582205, 29.1704821],
  [53.6589835, 29.1704392],
  [53.6622131, 29.1617059],
  [53.669053, 29.1584444],
  [53.6685827, 29.156363],
  [53.6765808, 29.1528004],
  [53.6766163, 29.1485309],
  [53.6770103, 29.1462779],
  [53.6767307, 29.1447544],
  [53.676657, 29.1435093],
  [53.671723, 29.1433593],
  [53.6705277, 29.1271376],
  [53.6706171, 29.1258502],
  [53.684908, 29.1286174],
  [53.6857389, 29.1138437],
  [53.68656, 29.0992425],
  [53.6795269, 29.0991354],
  [53.6794252, 29.0999507],
  [53.6593368, 29.0963029],
  [53.6450444, 29.1041561],
  [53.6369705, 29.0936843],
  [53.634995, 29.0939641],
  [53.6350841, 29.0930199],
  [53.6334301, 29.0901017],
  [53.63642, 29.0763902],
  [53.6367635, 29.0765834],
  [53.6388897, 29.0684078],
  [53.6384682, 29.0681505],
  [53.6384937, 29.0672493],
  [53.6379339, 29.0669274],
  [53.6377848, 29.0665411],
  [53.6262281, 29.0662837],
  [53.6235162, 29.0726348],
  [53.6217867, 29.0708112],
  [53.6205903, 29.0677642],
  [53.6074284, 29.0736222],
  [53.60697, 29.0701675],
  [53.6061552, 29.0683222],
  [53.5997729, 29.0710685],
  [53.6014282, 29.0849084],
  [53.5932562, 29.088149],
  [53.5927981, 29.0903585],
  [53.5885438, 29.0878701],
  [53.5862639, 29.0845871],
  [53.5841494, 29.0779996],
  [53.5845188, 29.0774631],
  [53.5825189, 29.0753817],
  [53.5816144, 29.0733647],
  [53.5796213, 29.0732143],
  [53.5812902, 29.0596738],
  [53.5819074, 29.0569067],
  [53.5854456, 29.0512626],
  [53.5854487, 29.0502548],
  [53.5852321, 29.048624],
  [53.5834233, 29.0422296],
  [53.5814048, 29.0357921],
  [53.5818692, 29.0317797],
  [53.5826463, 29.0287757],
  [53.5843277, 29.0244198],
  [53.5857895, 29.0178101],
  [53.5855888, 29.0165233],
  [53.5862512, 29.0152144],
  [53.5827961, 28.9995288],
  [53.5861238, 28.997941],
  [53.5884165, 28.9971256],
  [53.5898812, 28.997705],
  [53.5907345, 28.9964604],
  [53.5932566, 28.9956441],
  [53.5843414, 28.9764389],
  [53.5845825, 28.9759469],
  [53.5826463, 28.9723205],
  [53.5807354, 28.966763],
  [53.5800475, 28.9639306],
  [53.580194, 28.9635551],
  [53.580124, 28.9623856],
  [53.5794105, 28.9599609],
  [53.5795321, 28.9589521],
  [53.5807482, 28.9579868],
  [53.5820844, 28.9564619],
  [53.5806208, 28.9529657],
  [53.5821495, 28.9503264],
  [53.5814998, 28.9478159],
  [53.5802991, 28.9471346],
  [53.5790379, 28.9485079],
  [53.5783276, 28.9493072],
  [53.5778053, 28.9497096],
  [53.5771778, 28.9499241],
  [53.5763879, 28.950069],
  [53.5758592, 28.9500314],
  [53.5747412, 28.9495915],
  [53.574187, 28.9493448],
  [53.5739672, 28.9492965],
  [53.5732759, 28.9487279],
  [53.5727981, 28.9484006],
  [53.5721133, 28.948111],
  [53.5717278, 28.948068],
  [53.5713647, 28.9481056],
  [53.5709092, 28.948229],
  [53.5702657, 28.9487922],
  [53.5700204, 28.9491946],
  [53.569877, 28.9496184],
  [53.5697719, 28.9503157],
  [53.5698069, 28.9509273],
  [53.5699599, 28.9520109],
  [53.5700841, 28.9530087],
  [53.5701383, 28.9538723],
  [53.5700809, 28.9549452],
  [53.5699662, 28.956222],
  [53.5696286, 28.9582765],
  [53.5692367, 28.960535],
  [53.5688385, 28.9627505],
  [53.5686346, 28.9639145],
  [53.5684722, 28.964561],
  [53.5680771, 28.9662239],
  [53.5676184, 28.968831],
  [53.5673062, 28.9698181],
  [53.5668283, 28.9706013],
  [53.5663759, 28.9710412],
  [53.5660063, 28.9712772],
  [53.564853, 28.9714596],
  [53.5644133, 28.9715132],
  [53.5636105, 28.9713523],
  [53.5632218, 28.9712236],
  [53.562712, 28.9708373],
  [53.5621831, 28.9701399],
  [53.561737, 28.9693353],
  [53.5615203, 28.9683804],
  [53.5615267, 28.9669535],
  [53.5617497, 28.9654944],
  [53.5621321, 28.9638636],
  [53.5624539, 28.9630965],
  [53.5627152, 28.9625815],
  [53.5629382, 28.9623776],
  [53.5635085, 28.9615783],
  [53.5639227, 28.9611599],
  [53.564356, 28.9605698],
  [53.5647001, 28.9599368],
  [53.5649582, 28.9594916],
  [53.565264, 28.9587298],
  [53.5656368, 28.9577052],
  [53.565847, 28.9568952],
  [53.5659936, 28.9561066],
  [53.5660191, 28.9552966],
  [53.5659458, 28.954567],
  [53.5658343, 28.9540091],
  [53.5654647, 28.9530811],
  [53.5650997, 28.9523994],
  [53.563399, 28.9497688],
  [53.5625017, 28.9489746],
  [53.5615766, 28.9494255],
  [53.5575872, 28.9555838],
  [53.5568479, 28.9562061],
  [53.5563652, 28.9564235],
  [53.5561544, 28.9563695],
  [53.5558102, 28.9560423],
  [53.5554055, 28.9555434],
  [53.5548255, 28.9544705],
  [53.5544877, 28.953993],
  [53.5541276, 28.9536873],
  [53.5538376, 28.9535585],
  [53.5535986, 28.953639],
  [53.5534265, 28.953757],
  [53.5530536, 28.9543364],
  [53.5525469, 28.9553395],
  [53.5521709, 28.9564339],
  [53.5517757, 28.9575014],
  [53.5515366, 28.9581183],
  [53.5512658, 28.9584884],
  [53.550912, 28.9587298],
  [53.5502905, 28.9592395],
  [53.5498348, 28.959395],
  [53.5491814, 28.9592985],
  [53.5485694, 28.9590624],
  [53.5482667, 28.9588371],
  [53.5479607, 28.9584187],
  [53.5476451, 28.9578769],
  [53.547234, 28.9568791],
  [53.5469631, 28.9559135],
  [53.5468356, 28.9554039],
  [53.5467782, 28.9548353],
  [53.5466093, 28.9543203],
  [53.5464467, 28.9539984],
  [53.5461567, 28.9537785],
  [53.5459335, 28.9537409],
  [53.5456148, 28.9539126],
  [53.5451622, 28.9541325],
  [53.5442984, 28.9544437],
  [53.5437405, 28.9547441],
  [53.5433644, 28.9550284],
  [53.543001, 28.9554253],
  [53.5427173, 28.955876],
  [53.542389, 28.95645],
  [53.5422328, 28.956981],
  [53.5420893, 28.958011],
  [53.5419778, 28.9598617],
  [53.541965, 28.9614871],
  [53.5420224, 28.9625332],
  [53.5419459, 28.9633486],
  [53.5417578, 28.9639494],
  [53.5416062, 28.9644279],
  [53.5415793, 28.9645127],
  [53.541353, 28.9649204],
  [53.5410469, 28.965371],
  [53.5408429, 28.9655534],
  [53.5404126, 28.9657089],
  [53.5400842, 28.9657948],
  [53.5397176, 28.9657143],
  [53.5392617, 28.9653924],
  [53.538978, 28.965033],
  [53.5388887, 28.9645717],
  [53.5387166, 28.9636115],
  [53.5386465, 28.9633754],
  [53.5386465, 28.9630857],
  [53.5385349, 28.962045],
  [53.5385572, 28.9607576],
  [53.538605, 28.9600978],
  [53.5387134, 28.959674],
  [53.5388632, 28.9591751],
  [53.5390019, 28.9583785],
  [53.5390338, 28.957665],
  [53.5389605, 28.9569676],
  [53.5387469, 28.9563775],
  [53.5384408, 28.9560396],
  [53.5382272, 28.9559269],
  [53.5380232, 28.9559216],
  [53.5377745, 28.9560396],
  [53.5374366, 28.9562488],
  [53.5363845, 28.9570213],
  [53.5357182, 28.9574504],
  [53.5347936, 28.9580137],
  [53.5340539, 28.9583248],
  [53.533488, 28.9584884],
  [53.5327228, 28.9586923],
  [53.5321042, 28.9589122],
  [53.53139, 28.9590892],
  [53.5306662, 28.9591751],
  [53.5295056, 28.9592931],
  [53.5290815, 28.9594433],
  [53.5286733, 28.9596364],
  [53.5282715, 28.9598456],
  [53.5278857, 28.960189],
  [53.5275636, 28.960543],
  [53.5269641, 28.9615676],
  [53.5265241, 28.9623025],
  [53.5262498, 28.962721],
  [53.5258576, 28.9635149],
  [53.5255738, 28.9642284],
  [53.5253282, 28.9651886],
  [53.5250859, 28.9662722],
  [53.5249424, 28.9671949],
  [53.5247829, 28.96808],
  [53.5245661, 28.9689759],
  [53.5243683, 28.9695981],
  [53.5240943, 28.9703604],
  [53.5236704, 28.9707225],
  [53.5232777, 28.9708641],
  [53.5227355, 28.9709875],
  [53.5223496, 28.9709661],
  [53.5207805, 28.9704725],
  [53.5201426, 28.9702687],
  [53.5193549, 28.9701078],
  [53.5186787, 28.969743],
  [53.5180663, 28.9693728],
  [53.5176006, 28.9688471],
  [53.5172498, 28.9682785],
  [53.5170648, 28.9678118],
  [53.5168064, 28.9667067],
  [53.5167363, 28.9660366],
  [53.5166661, 28.9653656],
  [53.5162961, 28.9636866],
  [53.5161686, 28.9632955],
  [53.516336, 28.9626727],
  [53.5166227, 28.9623891],
  [53.5170997, 28.9631386],
  [53.5172815, 28.9633545],
  [53.5175118, 28.9635005],
  [53.5177404, 28.9634896],
  [53.5185059, 28.9626313],
  [53.5188002, 28.9626259],
  [53.5190162, 28.962803],
  [53.5192902, 28.9632712],
  [53.5195521, 28.9634758],
  [53.5197752, 28.9634517],
  [53.5199803, 28.9632248],
  [53.5201716, 28.9629494],
  [53.5203758, 28.962506],
  [53.5204695, 28.9621206],
  [53.5204987, 28.9617623],
  [53.5204533, 28.9613493],
  [53.5203514, 28.9610285],
  [53.5201589, 28.9606713],
  [53.5187556, 28.9579247],
  [53.5185377, 28.9569119],
  [53.5185425, 28.9560998],
  [53.518667, 28.9555672],
  [53.519058, 28.9548806],
  [53.5197379, 28.9541375],
  [53.5209754, 28.9535581],
  [53.5215303, 28.9537298],
  [53.523093, 28.9558541],
  [53.5237436, 28.9567553],
  [53.5264223, 28.9564013],
  [53.52771, 28.95653],
  [53.5278127, 28.9562779],
  [53.5280164, 28.9554518],
  [53.5277518, 28.954513],
  [53.5280515, 28.9543842],
  [53.5281249, 28.9540195],
  [53.5280834, 28.9537673],
  [53.5279495, 28.9537351],
  [53.5277709, 28.9532792],
  [53.5276593, 28.9531611],
  [53.5277008, 28.9529895],
  [53.5275732, 28.952791],
  [53.5274967, 28.95204],
  [53.5275668, 28.9519327],
  [53.5277741, 28.95204],
  [53.5279144, 28.9515357],
  [53.5280611, 28.9512568],
  [53.5279463, 28.9508384],
  [53.5280675, 28.9508384],
  [53.5281376, 28.9502697],
  [53.5283513, 28.9500176],
  [53.5285904, 28.9497816],
  [53.528438, 28.9496115],
  [53.5284189, 28.9490965],
  [53.528489, 28.9486888],
  [53.5286261, 28.9486083],
  [53.5286197, 28.9482489],
  [53.5286708, 28.9480987],
  [53.5288621, 28.9472511],
  [53.5285496, 28.9464679],
  [53.5284093, 28.9460602],
  [53.528438, 28.9458778],
  [53.5281988, 28.9451912],
  [53.528269, 28.9450195],
  [53.5280936, 28.9447728],
  [53.5278162, 28.9445582],
  [53.5275706, 28.9438876],
  [53.5274112, 28.9436945],
  [53.527298, 28.9434486],
  [53.5271067, 28.9432548],
  [53.5269743, 28.9424553],
  [53.5267702, 28.9425519],
  [53.5267033, 28.942112],
  [53.5264673, 28.9422568],
  [53.5264322, 28.9419672],
  [53.5263079, 28.9414361],
  [53.5263876, 28.9409157],
  [53.5262377, 28.9401057],
  [53.5265868, 28.939868],
  [53.5268468, 28.9395534],
  [53.5268732, 28.9394508],
  [53.5268681, 28.9393054],
  [53.5268882, 28.939183],
  [53.5269413, 28.93913],
  [53.5270126, 28.9391616],
  [53.5271497, 28.9393064],
  [53.5271869, 28.9392939],
  [53.5271944, 28.9391777],
  [53.5271286, 28.939009],
  [53.5271204, 28.9388985],
  [53.5271397, 28.9387726],
  [53.5271655, 28.9386226],
  [53.5273324, 28.9384843],
  [53.5273474, 28.9384267],
  [53.5273185, 28.9382711],
  [53.5273261, 28.9381826],
  [53.5273751, 28.9381217],
  [53.5273921, 28.9380243],
  [53.527463, 28.9380299],
  [53.527582, 28.9381199],
  [53.5276599, 28.9380619],
  [53.5276791, 28.9377668],
  [53.5276025, 28.9375898],
  [53.5274074, 28.9374228],
  [53.5273873, 28.9374504],
  [53.5274015, 28.937551],
  [53.5273808, 28.9376249],
  [53.5272391, 28.9376526],
  [53.5272022, 28.9375287],
  [53.5272472, 28.9373641],
  [53.5272964, 28.9369675],
  [53.5274307, 28.9369077],
  [53.5274463, 28.936871],
  [53.5274155, 28.9368221],
  [53.5273458, 28.9367886],
  [53.5273092, 28.93671],
  [53.527278, 28.9365296],
  [53.527227, 28.9364105],
  [53.5272422, 28.9363453],
  [53.5273555, 28.9363573],
  [53.5273729, 28.9362809],
  [53.5274379, 28.9359917],
  [53.5274367, 28.9358946],
  [53.5273705, 28.9358197],
  [53.5273431, 28.9356948],
  [53.5274231, 28.9348329],
  [53.5274602, 28.9347452],
  [53.5275105, 28.9347243],
  [53.5275962, 28.9348379],
  [53.5276291, 28.9348311],
  [53.5277097, 28.9346651],
  [53.5278961, 28.9343218],
  [53.5279233, 28.9343163],
  [53.5280362, 28.9343819],
  [53.5279979, 28.9345482],
  [53.5280043, 28.9346394],
  [53.5280617, 28.9346984],
  [53.5281032, 28.934457],
  [53.5281893, 28.9345321],
  [53.528202, 28.9346555],
  [53.5282913, 28.9348003],
  [53.5283041, 28.934929],
  [53.5284628, 28.9348459],
  [53.5284744, 28.9347999],
  [53.5284408, 28.9346715],
  [53.5284444, 28.9346125],
  [53.5284868, 28.9346039],
  [53.5286995, 28.9347735],
  [53.5288366, 28.9345428],
  [53.5288623, 28.9344501],
  [53.5288398, 28.9343497],
  [53.5287314, 28.9343443],
  [53.5286325, 28.9340922],
  [53.5285954, 28.9339882],
  [53.5286171, 28.9339044],
  [53.5288, 28.9337158],
  [53.5288271, 28.9334838],
  [53.5288015, 28.9334216],
  [53.5286644, 28.9331695],
  [53.5286756, 28.9330543],
  [53.5286612, 28.9330354],
  [53.5285487, 28.9331452],
  [53.5285145, 28.9331105],
  [53.5285018, 28.932912],
  [53.5284507, 28.9328262],
  [53.5284703, 28.9326982],
  [53.5284507, 28.9326438],
  [53.5283199, 28.9326706],
  [53.5282901, 28.9326368],
  [53.5282913, 28.9325472],
  [53.5284584, 28.9324526],
  [53.5285305, 28.9323327],
  [53.5285974, 28.9320752],
  [53.5286303, 28.9320404],
  [53.5286708, 28.932064],
  [53.5288621, 28.9322629],
  [53.5289131, 28.9322737],
  [53.5289804, 28.932243],
  [53.5290199, 28.932173],
  [53.5290183, 28.9320537],
  [53.5290006, 28.9318974],
  [53.5290438, 28.9316568],
  [53.5289801, 28.931174],
  [53.5287186, 28.9311525],
  [53.5285337, 28.9313295],
  [53.5284539, 28.9312383],
  [53.5284954, 28.9308628],
  [53.5283806, 28.9301279],
  [53.5284061, 28.9299294],
  [53.5285687, 28.9296987],
  [53.5285911, 28.9295485],
  [53.5285879, 28.9293286],
  [53.5284284, 28.9286312],
  [53.5285113, 28.9284864],
  [53.5285081, 28.9283684],
  [53.5284731, 28.9282557],
  [53.5283774, 28.9280519],
  [53.5284284, 28.9276442],
  [53.5284986, 28.9273062],
  [53.5286421, 28.9271292],
  [53.5286038, 28.9270434],
  [53.5284954, 28.927038],
  [53.5284125, 28.9269951],
  [53.5283232, 28.9265927],
  [53.5283774, 28.9263943],
  [53.528505, 28.9262709],
  [53.5285528, 28.926464],
  [53.5286803, 28.9265391],
  [53.5287569, 28.9265015],
  [53.5287919, 28.9262977],
  [53.5291172, 28.9264962],
  [53.5292033, 28.9263835],
  [53.529216, 28.9263031],
  [53.5290311, 28.9261099],
  [53.528945, 28.9259436],
  [53.528945, 28.9258525],
  [53.5289928, 28.9257774],
  [53.5291204, 28.9257934],
  [53.5291331, 28.925654],
  [53.5290821, 28.9254609],
  [53.5291076, 28.9251175],
  [53.5290183, 28.9248922],
  [53.5291204, 28.9246937],
  [53.5291076, 28.9245811],
  [53.5290088, 28.9244899],
  [53.5290151, 28.9243182],
  [53.5289418, 28.9242217],
  [53.5288685, 28.92427],
  [53.5288079, 28.9242163],
  [53.5287728, 28.9240232],
  [53.5287951, 28.9238837],
  [53.5290024, 28.9236691],
  [53.5291204, 28.9236906],
  [53.5292256, 28.9236423],
  [53.5292479, 28.9237979],
  [53.5293755, 28.9238086],
  [53.5294488, 28.9237335],
  [53.5294392, 28.9235887],
  [53.5292415, 28.9233741],
  [53.5291969, 28.9229449],
  [53.5291044, 28.9228484],
  [53.5290024, 28.9225319],
  [53.5290056, 28.9223763],
  [53.5289514, 28.9222529],
  [53.5287388, 28.9221397],
  [53.5286368, 28.9217213],
  [53.5287771, 28.9215711],
  [53.5287515, 28.9212814],
  [53.5289556, 28.9211848],
  [53.5289556, 28.9210668],
  [53.52886, 28.9210454],
  [53.5288089, 28.9209166],
  [53.5288344, 28.9194596],
  [53.5307438, 28.9175006],
  [53.532157, 28.9131919],
  [53.5343098, 28.9070678],
  [53.5372888, 28.9103572],
  [53.5378809, 28.9097314],
  [53.5414055, 28.9078517],
  [53.5461996, 28.9070449],
  [53.5470981, 28.9069219],
  [53.5486841, 28.9063812],
  [53.5503363, 28.9056773],
  [53.5516672, 28.9041496],
  [53.5552715, 28.9002186],
  [53.5573903, 28.8968931],
  [53.5581247, 28.8957403],
  [53.5638207, 28.8867991],
  [53.5652792, 28.8837476],
  [53.566119, 28.8830756],
  [53.5664901, 28.8827786],
  [53.567637, 28.8826584],
  [53.5699562, 28.8797831],
  [53.5707248, 28.8788279],
  [53.5732437, 28.8756976],
  [53.5751139, 28.8734848],
  [53.5796755, 28.8680871],
  [53.5795041, 28.8621927],
  [53.5792339, 28.8538356],
  [53.5791319, 28.8499885],
  [53.579007, 28.8454817],
  [53.5789342, 28.8428552],
  [53.5788888, 28.841219],
  [53.5788663, 28.8398902],
  [53.5829805, 28.8370216],
  [53.5796596, 28.8302706],
  [53.5820791, 28.8285978],
  [53.5844741, 28.8276163],
  [53.5849646, 28.8293266],
  [53.5856139, 28.8302781],
  [53.5891132, 28.8247879],
  [53.5915242, 28.8259792],
  [53.5926244, 28.8250163],
  [53.592785, 28.8219559],
  [53.5927798, 28.8219208],
  [53.5922155, 28.8180763],
  [53.6031386, 28.8155675],
  [53.5999677, 28.8005175],
  [53.5952661, 28.7778414],
  [53.5942225, 28.7738905],
  [53.5870831, 28.7753377],
  [53.5768364, 28.7777247],
  [53.5770199, 28.7717815],
  [53.578178, 28.7342638],
  [53.5782587, 28.7309631],
  [53.5784564, 28.722882],
  [53.5788541, 28.7066226],
  [53.5788646, 28.7061935],
  [53.5819613, 28.6980418],
  [53.5852448, 28.6893975],
  [53.613281, 28.619384],
  [53.6010716, 28.6219373],
  [53.6008121, 28.6137623],
  [53.5890915, 28.6100077],
  [53.5888082, 28.6094923],
  [53.5878561, 28.6119175],
  [53.5762687, 28.6225168],
  [53.5777084, 28.5855882],
  [53.5564498, 28.5829274],
  [53.5565496, 28.5767269],
  [53.5553663, 28.5649251],
  [53.5506603, 28.5645818],
  [53.5499719, 28.5643887],
  [53.5477918, 28.5646033],
  [53.5468356, 28.5644102],
  [53.5461923, 28.5646032],
  [53.5453311, 28.5641742],
  [53.5449449, 28.5635089],
  [53.5438521, 28.5633802],
  [53.5420033, 28.5625648],
  [53.5408615, 28.5625278],
  [53.540843, 28.5639596],
  [53.5410113, 28.5663023],
  [53.5355387, 28.5662888],
  [53.5335485, 28.5679501],
  [53.5301991, 28.5692556],
  [53.5304847, 28.5705805],
  [53.5298914, 28.5719538],
  [53.5271393, 28.5685122],
  [53.5256796, 28.5671565],
  [53.5248965, 28.5680268],
  [53.5217195, 28.5604604],
  [53.522425, 28.5591412],
  [53.5227539, 28.5544509],
  [53.5226603, 28.5539172],
  [53.5228909, 28.5532796],
  [53.5255755, 28.5517394],
  [53.5258933, 28.551087],
  [53.526893, 28.5416677],
  [53.5261765, 28.5417723],
  [53.5220307, 28.5243702],
  [53.5175013, 28.5260029],
  [53.5161494, 28.5183835],
  [53.5157029, 28.5174823],
  [53.5119261, 28.520894],
  [53.5119388, 28.5220957],
  [53.5085153, 28.5213765],
  [53.5105161, 28.5163665],
  [53.5103311, 28.5158729],
  [53.5110775, 28.5149288],
  [53.511556, 28.5149073],
  [53.511135, 28.5134482],
  [53.5119325, 28.5128045],
  [53.5118623, 28.51215],
  [53.5125641, 28.5115385],
  [53.5128448, 28.5121822],
  [53.5148097, 28.5107231],
  [53.5148097, 28.5098433],
  [53.5160091, 28.5093069],
  [53.5163625, 28.5084911],
  [53.5195941, 28.5069036],
  [53.5185447, 28.4929991],
  [53.5199896, 28.4899521],
  [53.5193134, 28.4895015],
  [53.5170808, 28.4817123],
  [53.5158177, 28.4817982],
  [53.5155753, 28.4788799],
  [53.5131663, 28.4782786],
  [53.5139676, 28.474288],
  [53.5184204, 28.4763479],
  [53.5203945, 28.4687301],
  [53.5168155, 28.4636709],
  [53.5087232, 28.4534311],
  [53.5067325, 28.4513926],
  [53.4941478, 28.4365654],
  [53.491029, 28.4318264],
  [53.4917909, 28.4159216],
  [53.4890038, 28.4132024],
  [53.4887118, 28.4113123],
  [53.488352, 28.4086275],
  [53.4873416, 28.4062513],
  [53.4884924, 28.405323],
  [53.4881732, 28.402791],
  [53.4881605, 28.4006667],
  [53.4886201, 28.3994865],
  [53.4888371, 28.3980703],
  [53.4885562, 28.3947229],
  [53.4882243, 28.3934784],
  [53.4882115, 28.3927059],
  [53.4876753, 28.3921909],
  [53.4874583, 28.3930921],
  [53.4876753, 28.3937788],
  [53.4876115, 28.3943796],
  [53.4866284, 28.3945513],
  [53.4860666, 28.395946],
  [53.4855176, 28.3991003],
  [53.4855814, 28.4011388],
  [53.4857474, 28.4019542],
  [53.4860155, 28.4022975],
  [53.4854665, 28.4031987],
  [53.4841003, 28.4025979],
  [53.4838067, 28.404057],
  [53.4833975, 28.4050328],
  [53.481636, 28.4044218],
  [53.4818914, 28.4033704],
  [53.4822872, 28.4029627],
  [53.4823, 28.4020614],
  [53.4814444, 28.4016967],
  [53.4813551, 28.4011602],
  [53.4796009, 28.4005012],
  [53.480308, 28.3975982],
  [53.4825298, 28.3978772],
  [53.482683, 28.394959],
  [53.4806291, 28.394522],
  [53.4812401, 28.3891439],
  [53.4812925, 28.3839212],
  [53.4817126, 28.3831787],
  [53.4821595, 28.3833289],
  [53.4825681, 28.380754],
  [53.4853133, 28.3795094],
  [53.4854793, 28.3785224],
  [53.4875476, 28.3789944],
  [53.4876836, 28.3801434],
  [53.4881251, 28.3799107],
  [53.4885435, 28.3763981],
  [53.4892685, 28.3730722],
  [53.4896414, 28.3727932],
  [53.489552, 28.3703899],
  [53.4891435, 28.370583],
  [53.4886328, 28.3683514],
  [53.4881988, 28.3681583],
  [53.4876498, 28.3658194],
  [53.4873689, 28.3655834],
  [53.4862522, 28.3624287],
  [53.4884796, 28.3598971],
  [53.4876625, 28.3583951],
  [53.4881349, 28.356893],
  [53.4876625, 28.3550048],
  [53.4882763, 28.3543436],
  [53.487305, 28.351593],
  [53.4850196, 28.3523011],
  [53.4823127, 28.3502197],
  [53.4805284, 28.3502091],
  [53.4789896, 28.3474126],
  [53.4796312, 28.3460998],
  [53.4792896, 28.3443436],
  [53.4769367, 28.3379245],
  [53.47792, 28.3365512],
  [53.4780733, 28.3345556],
  [53.4768473, 28.3329677],
  [53.4759661, 28.3334827],
  [53.4751858, 28.3344609],
  [53.4745991, 28.3376623],
  [53.4742548, 28.3385038],
  [53.4743825, 28.341937],
  [53.4733864, 28.3457136],
  [53.4730543, 28.3490181],
  [53.4726328, 28.351357],
  [53.470459, 28.355712],
  [53.4684818, 28.3559918],
  [53.4680859, 28.3590817],
  [53.4686223, 28.3616566],
  [53.4682264, 28.3694458],
  [53.4693376, 28.3698106],
  [53.4696186, 28.3714628],
  [53.46043, 28.3957737],
  [53.4544645, 28.4019753],
  [53.4517459, 28.4031343],
  [53.4505448, 28.4046363],
  [53.4444362, 28.4009885],
  [53.4404998, 28.4041214],
  [53.4388126, 28.4066104],
  [53.4314623, 28.4084344],
  [53.4302222, 28.4078979],
  [53.4282917, 28.4095073],
  [53.4245593, 28.4105154],
  [53.4207607, 28.407855],
  [53.4175893, 28.4045934],
  [53.4087388, 28.4009885],
  [53.406091, 28.4026623],
  [53.4054131, 28.4036279],
  [53.4032873, 28.4059878],
  [53.4022021, 28.4056878],
  [53.4007949, 28.4048724],
  [53.3994078, 28.4047254],
  [53.3973917, 28.4062457],
  [53.3970207, 28.4021044],
  [53.3962658, 28.3981347],
  [53.3969439, 28.3969438],
  [53.397155, 28.3943474],
  [53.3971292, 28.3917679],
  [53.396707, 28.3904503],
  [53.3949607, 28.3878994],
  [53.3942122, 28.3860004],
  [53.3941418, 28.3837473],
  [53.3945513, 28.3818376],
  [53.394257, 28.3810007],
  [53.3929334, 28.3801847],
  [53.3907765, 28.3811724],
  [53.3880999, 28.3817208],
  [53.3866623, 28.3819663],
  [53.3853996, 28.3813882],
  [53.3863231, 28.3782756],
  [53.3845378, 28.375808],
  [53.3846317, 28.3705413],
  [53.387716, 28.361218],
  [53.3872399, 28.3596783],
  [53.3867029, 28.3590432],
  [53.3840046, 28.3568454],
  [53.3830182, 28.3561176],
  [53.3817429, 28.3561626],
  [53.3816661, 28.3562216],
  [53.3814901, 28.3562806],
  [53.3813141, 28.3563933],
  [53.3811445, 28.3564362],
  [53.3810645, 28.3563557],
  [53.3810677, 28.3561787],
  [53.3810741, 28.3560285],
  [53.3809973, 28.3557227],
  [53.3809173, 28.355535],
  [53.3807861, 28.355476],
  [53.3807125, 28.3555511],
  [53.3806453, 28.3557496],
  [53.3806005, 28.3560392],
  [53.3805461, 28.3560982],
  [53.3804757, 28.3560553],
  [53.3804565, 28.3558729],
  [53.3803733, 28.3554652],
  [53.3802933, 28.3552131],
  [53.3802005, 28.3551058],
  [53.3801301, 28.3551541],
  [53.3800949, 28.3553204],
  [53.3800693, 28.3556208],
  [53.3800245, 28.3557925],
  [53.3799349, 28.3559588],
  [53.3798198, 28.3560339],
  [53.3796854, 28.3559534],
  [53.3795126, 28.3559105],
  [53.3793974, 28.3559266],
  [53.3792982, 28.3560875],
  [53.3792182, 28.3561572],
  [53.3789142, 28.3562914],
  [53.378767, 28.3563289],
  [53.3786006, 28.3562377],
  [53.3785878, 28.3561465],
  [53.378623, 28.356007],
  [53.378751, 28.3556905],
  [53.3787446, 28.3555403],
  [53.378623, 28.3554062],
  [53.3785174, 28.3553472],
  [53.3784438, 28.3554009],
  [53.3784054, 28.3556262],
  [53.3783798, 28.3559158],
  [53.3783446, 28.3559963],
  [53.3782806, 28.3559588],
  [53.378143, 28.3556154],
  [53.3780758, 28.3555082],
  [53.377951, 28.3554545],
  [53.3777846, 28.3554652],
  [53.3775285, 28.3553955],
  [53.3772757, 28.355374],
  [53.3771573, 28.3552882],
  [53.3770229, 28.3552024],
  [53.3769237, 28.3552024],
  [53.3768565, 28.3551702],
  [53.3768565, 28.3550468],
  [53.3770581, 28.3547303],
  [53.3770581, 28.3545855],
  [53.3770037, 28.3545157],
  [53.3769205, 28.3545265],
  [53.3767861, 28.3546284],
  [53.3766869, 28.3546552],
  [53.3766069, 28.3545855],
  [53.3765525, 28.3544621],
  [53.3765685, 28.3543012],
  [53.3766421, 28.3539471],
  [53.3766229, 28.3537969],
  [53.3765621, 28.3537808],
  [53.3764725, 28.3538184],
  [53.3763701, 28.3540222],
  [53.3762837, 28.3542368],
  [53.3761973, 28.3542904],
  [53.3760469, 28.3542153],
  [53.3758869, 28.3540061],
  [53.3758069, 28.3538827],
  [53.3757109, 28.353872],
  [53.3755925, 28.3539739],
  [53.3753748, 28.3541617],
  [53.3752692, 28.3542314],
  [53.3751956, 28.3542046],
  [53.37517, 28.354108],
  [53.375154, 28.3539149],
  [53.3751604, 28.3535984],
  [53.3751188, 28.3535019],
  [53.3750452, 28.3534858],
  [53.3749844, 28.3535823],
  [53.37493, 28.3537808],
  [53.3748756, 28.3540222],
  [53.3748148, 28.3540919],
  [53.3747316, 28.3540598],
  [53.3745716, 28.353872],
  [53.3744372, 28.3535662],
  [53.3743667, 28.3534482],
  [53.3742675, 28.353416],
  [53.3741427, 28.3533731],
  [53.3740819, 28.353239],
  [53.3740531, 28.3530512],
  [53.3740467, 28.3527884],
  [53.3740371, 28.3525953],
  [53.3740179, 28.3525202],
  [53.3739443, 28.3525041],
  [53.3734002, 28.3527723],
  [53.3732562, 28.3528206],
  [53.3731826, 28.352885],
  [53.3731602, 28.3530191],
  [53.3731634, 28.3533517],
  [53.3731986, 28.3535662],
  [53.373269, 28.3536843],
  [53.3733042, 28.353813],
  [53.373253, 28.3540973],
  [53.3731186, 28.3544514],
  [53.3729426, 28.3546338],
  [53.3726097, 28.3548805],
  [53.3724945, 28.3549985],
  [53.3724113, 28.3550468],
  [53.3722769, 28.3550575],
  [53.3721681, 28.3549395],
  [53.3720945, 28.3549234],
  [53.371976, 28.3549985],
  [53.3718928, 28.3551058],
  [53.3718576, 28.3552989],
  [53.3718384, 28.3557227],
  [53.371864, 28.3558461],
  [53.3718576, 28.3559856],
  [53.3717232, 28.3563933],
  [53.37148, 28.3567366],
  [53.3712335, 28.3570638],
  [53.3711823, 28.357214],
  [53.3711983, 28.3573857],
  [53.3712911, 28.357552],
  [53.3714575, 28.3579543],
  [53.371544, 28.3580884],
  [53.3716048, 28.3582708],
  [53.3716304, 28.3584264],
  [53.3716304, 28.3585605],
  [53.3715888, 28.3587375],
  [53.3714575, 28.3589467],
  [53.3712975, 28.3591023],
  [53.3710511, 28.3590755],
  [53.3707982, 28.3590594],
  [53.3705006, 28.3591023],
  [53.3703149, 28.3591023],
  [53.3702253, 28.3592203],
  [53.3701389, 28.3592203],
  [53.3699597, 28.3590379],
  [53.3697868, 28.358877],
  [53.3696684, 28.3588555],
  [53.3695468, 28.3589199],
  [53.3693643, 28.3590004],
  [53.3692587, 28.3589843],
  [53.3691755, 28.3588502],
  [53.3691723, 28.3586678],
  [53.3692235, 28.3585015],
  [53.3692171, 28.3582494],
  [53.3692363, 28.3580831],
  [53.3693803, 28.3578739],
  [53.369486, 28.3577988],
  [53.3695212, 28.3577022],
  [53.3695116, 28.3575735],
  [53.3694252, 28.3573321],
  [53.3693419, 28.3572838],
  [53.3692363, 28.3572891],
  [53.3691947, 28.3574179],
  [53.3692107, 28.3576486],
  [53.3691915, 28.3577719],
  [53.3690955, 28.3578041],
  [53.3689162, 28.3576968],
  [53.3686282, 28.3575144],
  [53.3685097, 28.3573964],
  [53.3684329, 28.357375],
  [53.3683625, 28.3573964],
  [53.3683209, 28.3573267],
  [53.3682985, 28.3571765],
  [53.3683337, 28.3570102],
  [53.3684425, 28.3570102],
  [53.3685994, 28.3571067],
  [53.3687242, 28.3570585],
  [53.3688394, 28.3569512],
  [53.3688458, 28.3568171],
  [53.3687946, 28.3564791],
  [53.3687498, 28.3561948],
  [53.368721, 28.3560553],
  [53.3685161, 28.3557817],
  [53.3684169, 28.3557335],
  [53.3681929, 28.3557335],
  [53.368116, 28.3556905],
  [53.368116, 28.3555779],
  [53.3680648, 28.3554652],
  [53.3679112, 28.3553419],
  [53.3676071, 28.3552131],
  [53.3674759, 28.355138],
  [53.3673222, 28.3550146],
  [53.367207, 28.3550468],
  [53.3671526, 28.3549824],
  [53.3671046, 28.3548161],
  [53.3670758, 28.3545479],
  [53.367079, 28.3542636],
  [53.3670886, 28.3540973],
  [53.3669894, 28.3539525],
  [53.3668229, 28.3538398],
  [53.3667141, 28.3537057],
  [53.3665892, 28.353475],
  [53.3665316, 28.3534697],
  [53.3664868, 28.3535501],
  [53.3664612, 28.3537003],
  [53.3664228, 28.353872],
  [53.3663524, 28.354049],
  [53.3662371, 28.3540919],
  [53.3660099, 28.3539417],
  [53.3658626, 28.3538666],
  [53.3657218, 28.3539417],
  [53.3656354, 28.3541456],
  [53.3655745, 28.3542207],
  [53.3654273, 28.3542207],
  [53.365248, 28.3541295],
  [53.3651936, 28.3539793],
  [53.3651584, 28.3536145],
  [53.3651648, 28.3532605],
  [53.3651904, 28.3530298],
  [53.3650944, 28.3527133],
  [53.3649503, 28.3524182],
  [53.3647967, 28.3521232],
  [53.3646943, 28.3519569],
  [53.3644254, 28.3517477],
  [53.3643261, 28.3517262],
  [53.3641837, 28.3517681],
  [53.3641437, 28.3517799],
  [53.3640156, 28.3518764],
  [53.3638428, 28.3518818],
  [53.3637339, 28.3518496],
  [53.3636699, 28.3518764],
  [53.3634938, 28.3521178],
  [53.363353, 28.3523163],
  [53.3632634, 28.3524182],
  [53.3631737, 28.3524075],
  [53.3631257, 28.3522895],
  [53.3630617, 28.3519998],
  [53.3630105, 28.3519462],
  [53.3629208, 28.3520427],
  [53.3628728, 28.3522573],
  [53.3628216, 28.3523753],
  [53.3627672, 28.3525255],
  [53.3626808, 28.3525148],
  [53.3625463, 28.3524129],
  [53.3624503, 28.3522788],
  [53.3623958, 28.3520696],
  [53.3623414, 28.3515063],
  [53.3623254, 28.3512434],
  [53.3622902, 28.351104],
  [53.362243, 28.3510833],
  [53.3622166, 28.3510718],
  [53.3621461, 28.3511522],
  [53.3620693, 28.3513883],
  [53.3620469, 28.3516458],
  [53.3620021, 28.3518228],
  [53.3618997, 28.3518979],
  [53.3616564, 28.3518657],
  [53.3613778, 28.3518174],
  [53.3610865, 28.3518174],
  [53.3609841, 28.3517638],
  [53.3609201, 28.3518228],
  [53.3608912, 28.3520749],
  [53.3608304, 28.35215],
  [53.3607344, 28.3521339],
  [53.3605135, 28.3519247],
  [53.3604463, 28.3519247],
  [53.3603918, 28.3520052],
  [53.3603918, 28.3522144],
  [53.3604463, 28.3524075],
  [53.3604366, 28.3526221],
  [53.3603982, 28.3527455],
  [53.360331, 28.3527884],
  [53.3601613, 28.3525363],
  [53.3599789, 28.352311],
  [53.3598604, 28.3522573],
  [53.3597772, 28.3522788],
  [53.3597035, 28.3523968],
  [53.3597387, 28.3527079],
  [53.359758, 28.3529171],
  [53.3597131, 28.3531746],
  [53.3596683, 28.3532336],
  [53.3595851, 28.3532444],
  [53.3595531, 28.3531424],
  [53.3595403, 28.3529761],
  [53.359505, 28.3527133],
  [53.3593994, 28.3523163],
  [53.3593194, 28.3520588],
  [53.3592425, 28.3519891],
  [53.3591209, 28.3520481],
  [53.3587079, 28.3523485],
  [53.3585286, 28.352547],
  [53.3583941, 28.3525899],
  [53.3582501, 28.3525631],
  [53.3578851, 28.3522573],
  [53.3575905, 28.3519676],
  [53.3574817, 28.3517638],
  [53.3573417, 28.3517184],
  [53.3572159, 28.351737],
  [53.3570367, 28.3517048],
  [53.3568638, 28.3517048],
  [53.3566845, 28.3518443],
  [53.3565948, 28.3519194],
  [53.3565276, 28.3519998],
  [53.3564828, 28.3522037],
  [53.3564956, 28.3524182],
  [53.35655, 28.3525792],
  [53.3566204, 28.3526596],
  [53.3567997, 28.3527669],
  [53.3568798, 28.3528259],
  [53.3569246, 28.3529386],
  [53.356883, 28.3530512],
  [53.3567741, 28.3532068],
  [53.3564476, 28.3535984],
  [53.3563419, 28.3537754],
  [53.3562426, 28.353813],
  [53.3562042, 28.3537218],
  [53.3561978, 28.3536038],
  [53.356249, 28.3534107],
  [53.3563131, 28.3532658],
  [53.3562875, 28.3531532],
  [53.3561434, 28.3530244],
  [53.3559481, 28.3529761],
  [53.3557592, 28.3530673],
  [53.3555319, 28.353121],
  [53.3553878, 28.353062],
  [53.3552757, 28.3529118],
  [53.3552021, 28.3527347],
  [53.355122, 28.3526006],
  [53.3549395, 28.3525094],
  [53.354725, 28.3524719],
  [53.3545329, 28.3525631],
  [53.3544048, 28.3526275],
  [53.3543344, 28.3525363],
  [53.354312, 28.3524612],
  [53.3543216, 28.3523324],
  [53.3544144, 28.3521232],
  [53.3545201, 28.3518174],
  [53.3545297, 28.3516887],
  [53.3544208, 28.3514956],
  [53.3543216, 28.3514795],
  [53.3541039, 28.3515278],
  [53.3539694, 28.3515278],
  [53.3535724, 28.3513561],
  [53.3534642, 28.3513343],
  [53.3534123, 28.3513239],
  [53.353265, 28.3512649],
  [53.3531657, 28.3512381],
  [53.3529839, 28.3513377],
  [53.3525507, 28.3520072],
  [53.3524489, 28.3522515],
  [53.352302, 28.353449],
  [53.3519515, 28.3537316],
  [53.3519821, 28.3573093],
  [53.3516963, 28.3573106],
  [53.3508192, 28.3586474],
  [53.3502231, 28.3593839],
  [53.3498961, 28.3598883],
  [53.3491263, 28.3613996],
  [53.3486905, 28.3623499],
  [53.3482167, 28.3630912],
  [53.3478397, 28.3635742],
  [53.3463074, 28.3652949],
  [53.3450313, 28.3666742],
  [53.3445649, 28.367158],
  [53.3438007, 28.3684909],
  [53.3432972, 28.3693649],
  [53.3431078, 28.3696669],
  [53.3424439, 28.3703048],
  [53.3421552, 28.3705819],
  [53.3405617, 28.371527],
  [53.3399254, 28.3719993],
  [53.3392599, 28.3724171],
  [53.3383239, 28.3727181],
  [53.3374406, 28.3734256],
  [53.3359792, 28.3750784],
  [53.3345385, 28.3766442],
  [53.3331987, 28.3793592],
  [53.3324619, 28.3803141],
  [53.3315401, 28.3810216],
  [53.3309947, 28.3811831],
  [53.3306423, 28.3812046],
  [53.3298799, 28.3816123],
  [53.3287586, 28.3819878],
  [53.3262559, 28.382465],
  [53.3258892, 28.3824308],
  [53.3239529, 28.381262],
  [53.3231863, 28.3810178],
  [53.3218032, 28.3812607],
  [53.3196849, 28.3840959],
  [53.3185844, 28.3843715],
  [53.3179995, 28.3845233],
  [53.3182645, 28.3886999],
  [53.3183301, 28.3890797],
  [53.3184034, 28.3893092],
  [53.3189065, 28.3906745],
  [53.319804, 28.3929711],
  [53.3200776, 28.3940311],
  [53.3201708, 28.3950101],
  [53.3207669, 28.4056347],
  [53.3207603, 28.407765],
  [53.3204724, 28.4116148],
  [53.3212122, 28.4166327],
  [53.3217443, 28.4198849],
  [53.3218382, 28.4205924],
  [53.3218061, 28.4208978],
  [53.3210405, 28.4232179],
  [53.32085, 28.42652],
  [53.3211385, 28.4283712],
  [53.3210019, 28.4310161],
  [53.3210142, 28.4312148],
  [53.3149696, 28.4344106],
  [53.3136214, 28.4350204],
  [53.301518, 28.4347629],
  [53.3006573, 28.4337756],
  [53.2958754, 28.4328746],
  [53.2756548, 28.4222853],
  [53.2755893, 28.4185777],
  [53.2732726, 28.3252207],
  [53.2622687, 28.3266146],
  [53.2575864, 28.3271947],
  [53.2561447, 28.2721782],
  [53.2555414, 28.2712662],
  [53.2563629, 28.2686162],
  [53.2563822, 28.2673931],
  [53.2553167, 28.2657194],
  [53.2555478, 28.2644963],
  [53.2559136, 28.2646251],
  [53.2560356, 28.2639384],
  [53.2553167, 28.2628441],
  [53.2555991, 28.262093],
  [53.2554323, 28.2600545],
  [53.2567755, 28.2451931],
  [53.2582306, 28.2402706],
  [53.2591548, 28.2353782],
  [53.2583077, 28.2346057],
  [53.2577942, 28.231945],
  [53.2578456, 28.228898],
  [53.2596683, 28.2237482],
  [53.2591132, 28.2207226],
  [53.2648536, 28.1850385],
  [53.2669327, 28.1701898],
  [53.2677284, 28.1636238],
  [53.2692052, 28.1559105],
  [53.2797387, 28.1440544],
  [53.2784594, 28.1405278],
  [53.2682393, 28.1093847],
  [53.2743972, 28.081725],
];
